import React, {
	useEffect,
	useState,
	useRef,
	useCallback,
	useMemo,
} from "react";
import { Stage, Layer, Text } from "react-konva";
import { NumericFormat } from "react-number-format";
import Sticker from "./Sticker";
import {
	Box,
	TextField,
	Button,
	MenuItem,
	Select,
	Typography,
	Divider,
	Pagination,
	Stack,
	Grid,
	IconButton,
	Hidden,
	CircularProgress,
	useMediaQuery,
	Menu,
} from "@mui/material";
import {
	DndContext,
	closestCenter,
	KeyboardSensor,
	MouseSensor,
	PointerSensor,
	TouchSensor,
	useSensor,
	useSensors,
	DragOverlay,
} from "@dnd-kit/core";
import {
	SortableContext,
	sortableKeyboardCoordinates,
	verticalListSortingStrategy,
	arrayMove,
	horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import {
	FaSave,
	FaSignInAlt,
	FaFolder,
	FaSignOutAlt,
	FaFileExport,
	FaShare,
} from "react-icons/fa";
import { useSnackbar } from "notistack";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddIcon from "@mui/icons-material/Add";
import { FiLogOut } from "react-icons/fi";

import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import { FiFolderPlus } from "react-icons/fi";

// Modern Lucide icons for tab bar
import {
	LuLayoutGrid,
	LuSticker,
	LuPalette,
	LuType,
	LuImagePlus,
	LuSettings2,
	LuLayers,
	LuPlusCircle,
	LuChevronLeft,
	LuChevronRight,
} from "react-icons/lu";

import { useFirebase } from "../context/FirebaseContext";
import { getApiOrigin } from "../utils/api";
import { trackEditorAction } from "../utils/analytics";
import { loadEditorFonts } from "../utils/loadEditorFonts";
import { ImageBaseUrlProvider } from "../context/ImageBaseUrlContext";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import EditorHeader from "./Editor/EditorHeader";
import _, { set } from "lodash";

import Template1 from "./templates/Template1";
import Template2 from "./templates/Template2";
import Template3 from "./templates/Template3";
import Template4 from "./templates/Template4";

import LockIcon from "@mui/icons-material/Lock";
import { PurchaseChoiceModal } from "./PurchaseChoiceModal";

import Template5 from "./templates/Template5";
import Template6 from "./templates/Template6";
import Template7 from "./templates/Template7";
import Template8 from "./templates/Template8";
import Template9 from "./templates/Template9";
import Template23 from "./templates/Template23";
import Template24 from "./templates/Template24";
import Template25 from "./templates/Template25";
import Template26 from "./templates/Template26";
import Template27 from "./templates/Template27";
import Template28 from "./templates/Template28";
import Template29 from "./templates/Template29";
import Template30 from "./templates/Template30";
import Template31 from "./templates/Template31";
import Template32 from "./templates/Template32";
import Template33 from "./templates/Template33";
import Template34 from "./templates/Template34";
import Template35 from "./templates/Template35";
import Template36 from "./templates/Template36";
import Template37 from "./templates/Template37";
import Template38 from "./templates/Template38";
import Template39 from "./templates/Template39";
import Template40 from "./templates/Template40";
import Template41 from "./templates/Template41";
import Template42 from "./templates/Template42";
import Template43 from "./templates/Template43";
import Template50 from "./templates/Template50";
import Template51 from "./templates/Template51";
import Template52 from "./templates/Template52";
import Template53 from "./templates/Template53";
import Template54 from "./templates/Template54";
import Template55 from "./templates/Template55";
import Template56 from "./templates/Template56";
import Template57 from "./templates/Template57";
import Template58 from "./templates/Template58";
import Template59 from "./templates/Template59";
import Template60 from "./templates/Template60";
import Template61 from "./templates/Template61";
import Template62 from "./templates/Template62";
import Template63 from "./templates/Template63";
import Template64 from "./templates/Template64";
import Template65 from "./templates/Template65";
import Template70 from "./templates/Template70";
import Template71 from "./templates/Template71";
import Template72 from "./templates/Template72";
import Template73 from "./templates/Template73";
import Template74 from "./templates/Template74";
import Template75 from "./templates/Template75";
import Template76 from "./templates/Template76";
import Template77 from "./templates/Template77";
import Template78 from "./templates/Template78";
import Template79 from "./templates/Template79";
import Template80 from "./templates/Template80";
import Template81 from "./templates/Template81";
import Template82 from "./templates/Template82";
import Template83 from "./templates/Template83";
import Template84 from "./templates/Template84";
import Template85 from "./templates/Template85";
import Template86 from "./templates/Template86";
import Template87 from "./templates/Template87";
import Template88 from "./templates/Template88";
import Template89 from "./templates/Template89";
import Template90 from "./templates/Template90";
import Template91 from "./templates/Template91";
import Template92 from "./templates/Template92";
import Template93 from "./templates/Template93";
import Template94 from "./templates/Template94";
import Template95 from "./templates/Template95";
import Template96 from "./templates/Template96";
import Template97 from "./templates/Template97";
import Template98 from "./templates/Template98";
import Template99 from "./templates/Template99";
import Template100 from "./templates/Template100";
// Travel Kit Templates
import Template101 from "./templates/Template101";
import Template102 from "./templates/Template102";
import Template103 from "./templates/Template103";
import Template104 from "./templates/Template104";
import Template105 from "./templates/Template105";
import Template106 from "./templates/Template106";
import Template110 from "./templates/Template110";
import Template111 from "./templates/Template111";
import Template112 from "./templates/Template112";
import Template113 from "./templates/Template113";
import Template114 from "./templates/Template114";
import Template115 from "./templates/Template115";
import Template116 from "./templates/Template116";
import Template117 from "./templates/Template117";
import Template118 from "./templates/Template118";
import Template119 from "./templates/Template119";
import Template120 from "./templates/Template120";
import Template121 from "./templates/Template121";
import Template122 from "./templates/Template122";
import Template123 from "./templates/Template123";
import Template124 from "./templates/Template124";
import Template125 from "./templates/Template125";
import Template126 from "./templates/Template126";
import Template127 from "./templates/Template127";
import Template128 from "./templates/Template128";
// Seúl Templates
import Template129 from "./templates/Template129";
import Template130 from "./templates/Template130";
import Template131 from "./templates/Template131";
import Template132 from "./templates/Template132";
import Template133 from "./templates/Template133";
import Template134 from "./templates/Template134";
import Template144 from "./templates/Template144";
import Template145 from "./templates/Template145";
import Template135 from "./templates/Template135";
import Template136 from "./templates/Template136";
import Template137 from "./templates/Template137";
import Template138 from "./templates/Template138";
import Template139 from "./templates/Template139";
import Template140 from "./templates/Template140";
import Template141 from "./templates/Template141";
import Template142 from "./templates/Template142";
import Template143 from "./templates/Template143";
import Template146 from "./templates/Template146";
import Template147 from "./templates/Template147";
// París templates (150-167)
import Template150 from "./templates/Template150";
import Template151 from "./templates/Template151";
import Template152 from "./templates/Template152";
import Template153 from "./templates/Template153";
import Template154 from "./templates/Template154";
import Template155 from "./templates/Template155";
import Template156 from "./templates/Template156";
import Template157 from "./templates/Template157";
import Template158 from "./templates/Template158";
import Template159 from "./templates/Template159";
import Template160 from "./templates/Template160";
import Template161 from "./templates/Template161";
import Template162 from "./templates/Template162";
import Template163 from "./templates/Template163";
import Template164 from "./templates/Template164";
import Template165 from "./templates/Template165";
import Template166 from "./templates/Template166";
import Template167 from "./templates/Template167";
// San Francisco templates (168-182)
import Template168 from "./templates/Template168";
import Template169 from "./templates/Template169";
import Template170 from "./templates/Template170";
import Template171 from "./templates/Template171";
import Template172 from "./templates/Template172";
import Template173 from "./templates/Template173";
import Template174 from "./templates/Template174";
import Template175 from "./templates/Template175";
import Template176 from "./templates/Template176";
import Template177 from "./templates/Template177";
import Template178 from "./templates/Template178";
import Template179 from "./templates/Template179";
import Template180 from "./templates/Template180";
import Template181 from "./templates/Template181";
import Template182 from "./templates/Template182";
import Template183 from "./templates/Template183";
import Template184 from "./templates/Template184";
import Template185 from "./templates/Template185";
import Template186 from "./templates/Template186";
import Template10 from "./templates/Template10";
import Template11 from "./templates/Template11";
import Template12 from "./templates/Template12";
import Template13 from "./templates/Template13";
import Template14 from "./templates/Template14";
import Template15 from "./templates/Template15";
import Template16 from "./templates/Template16";
import Template17 from "./templates/Template17";
import Template18 from "./templates/Template18";
import Template19 from "./templates/Template19";
import Template20 from "./templates/Template20";
import Template21 from "./templates/Template21";
import Template22 from "./templates/Template22";
import Template187 from "./templates/Template187";
import Template188 from "./templates/Template188";
import Template189 from "./templates/Template189";
import Template190 from "./templates/Template190";
import Template191 from "./templates/Template191";
import Template192 from "./templates/Template192";
import Template193 from "./templates/Template193";
import Template194 from "./templates/Template194";
import Template195 from "./templates/Template195";
import Template196 from "./templates/Template196";
import Template197 from "./templates/Template197";
import Template198 from "./templates/Template198";
import Template199 from "./templates/Template199";
import Template200 from "./templates/Template200";
import Template201 from "./templates/Template201";
import Template202 from "./templates/Template202";
import Template203 from "./templates/Template203";
import Template204 from "./templates/Template204";
import Template205 from "./templates/Template205";
import Template206 from "./templates/Template206";
import Template207 from "./templates/Template207";
import Template208 from "./templates/Template208";
import Template209 from "./templates/Template209";
import Template210 from "./templates/Template210";
import Template211 from "./templates/Template211";
import Template212 from "./templates/Template212";
import Template213 from "./templates/Template213";
import Template214 from "./templates/Template214";
import Template215 from "./templates/Template215";
import Template216 from "./templates/Template216";
import Template217 from "./templates/Template217";
import Template218 from "./templates/Template218";
import Template219 from "./templates/Template219";
import Template220 from "./templates/Template220";
import Template221 from "./templates/Template221";
import Template222 from "./templates/Template222";
import Template223 from "./templates/Template223";
import Template224 from "./templates/Template224";
import Template225 from "./templates/Template225";
import Template226 from "./templates/Template226";
import Template227 from "./templates/Template227";
import Template228 from "./templates/Template228";
import Template229 from "./templates/Template229";
import Template230 from "./templates/Template230";
import Template231 from "./templates/Template231";
import Template232 from "./templates/Template232";
import Template233 from "./templates/Template233";
import Template246 from "./templates/Template246";
import Template247 from "./templates/Template247";
import Template248 from "./templates/Template248";
import Template249 from "./templates/Template249";
import Template250 from "./templates/Template250";
import Template251 from "./templates/Template251";
import Template252 from "./templates/Template252";
import Template253 from "./templates/Template253";
import Template254 from "./templates/Template254";
import Template255 from "./templates/Template255";
import Template256 from "./templates/Template256";
import Template257 from "./templates/Template257";
import Template258 from "./templates/Template258";
import Template259 from "./templates/Template259";
import Template260 from "./templates/Template260";
import Template261 from "./templates/Template261";
import Template262 from "./templates/Template262";
import Template263 from "./templates/Template263";
import Template264 from "./templates/Template264";
import Template265 from "./templates/Template265";
import Template266 from "./templates/Template266";
import Template267 from "./templates/Template267";
import Template268 from "./templates/Template268";
import Template269 from "./templates/Template269";
import Template270 from "./templates/Template270";
import Template271 from "./templates/Template271";
import Template272 from "./templates/Template272";
import Template273 from "./templates/Template273";
import Template274 from "./templates/Template274";
import Template275 from "./templates/Template275";
import Template276 from "./templates/Template276";
import Template277 from "./templates/Template277";
import Template278 from "./templates/Template278";
import Template279 from "./templates/Template279";
import Template280 from "./templates/Template280";
import Template281 from "./templates/Template281";
import Template282 from "./templates/Template282";
import Template283 from "./templates/Template283";
import Template284 from "./templates/Template284";
import Template285 from "./templates/Template285";
import Template286 from "./templates/Template286";
import Template287 from "./templates/Template287";
import Template288 from "./templates/Template288";
import Template289 from "./templates/Template289";
import Template290 from "./templates/Template290";
import Template291 from "./templates/Template291";
import Template293 from "./templates/Template293";
import Template294 from "./templates/Template294";
import Template295 from "./templates/Template295";
import Template296 from "./templates/Template296";
import Template297 from "./templates/Template297";
import Template298 from "./templates/Template298";
import Template299 from "./templates/Template299";
import Template300 from "./templates/Template300";
import Template301 from "./templates/Template301";
import Template302 from "./templates/Template302";
import Template303 from "./templates/Template303";
import Template304 from "./templates/Template304";
import Template305 from "./templates/Template305";
import Template309 from "./templates/Template309";
import Template310 from "./templates/Template310";
import Template311 from "./templates/Template311";
import Template312 from "./templates/Template312";
import Template313 from "./templates/Template313";
import Template314 from "./templates/Template314";
import Template315 from "./templates/Template315";
import Template316 from "./templates/Template316";
import Template317 from "./templates/Template317";
import Template318 from "./templates/Template318";
import Template319 from "./templates/Template319";
import Template324 from "./templates/Template324";
import Template325 from "./templates/Template325";
import Template326 from "./templates/Template326";
import Template327 from "./templates/Template327";
import Template328 from "./templates/Template328";
import Template330 from "./templates/Template330";
import Template331 from "./templates/Template331";
import Template332 from "./templates/Template332";
import Template333 from "./templates/Template333";
import Template334 from "./templates/Template334";
import Template335 from "./templates/Template335";
import Template336 from "./templates/Template336";
import Template337 from "./templates/Template337";
import Template338 from "./templates/Template338";
import Template339 from "./templates/Template339";
import Template340 from "./templates/Template340";
import MenuIcon from "@mui/icons-material/Menu";
import AppsIcon from "@mui/icons-material/Apps";
import LabelIcon from "@mui/icons-material/Label";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import SettingsIcon from "@mui/icons-material/Settings";
import { useWindowSize } from "@uidotdev/usehooks";
import { BasicModal } from "./BasicModal/BasicModal";
import CustomStickerModal from "./CustomStickers/CustomStickerModal";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import {
	TRAVEL_KIT_MODAL,
	modalContentSx,
	primaryButtonSx,
	secondaryButtonSx,
} from "./templates/TravelKitModalStyles";
import Auth from "./Auth/Auth";
import Projects from "./Projects/Projects";
import TextSticker from "./TextSticker";
import Export from "./Export/Export";
import { Link } from "react-router-dom";
import ReactQuill from "react-quill";
import imageCompression from "browser-image-compression";
import { Close } from "@mui/icons-material";
import { SortableItem } from "./SortableItem";
import Welcome from "./Welcome";
import Note from "./Note/Note";
import NoteIcon from "@mui/icons-material/Note";

// Sticker data loaded from backend API (no local assets bundled)
const sets = [];
const allImages = [];

// Tope máximo de páginas por guía (debe coincidir con el backend)
const MAX_PAGES_PER_GUIDE = 99;

const templates = [
	{
		id: 1,
		template: Template1,
	},
	{
		id: 2,
		template: Template2,
	},
	{
		id: 3,
		template: Template3,
	},
	{
		id: 4,
		template: Template4,
	},
	{
		id: 5,
		template: Template5,
	},
	{
		id: 23,
		template: Template23,
	},
	{
		id: 24,
		template: Template24,
	},
	{
		id: 25,
		template: Template25,
	},
	{
		id: 26,
		template: Template26,
	},
	{
		id: 27,
		template: Template27,
	},
	{
		id: 28,
		template: Template28,
	},
	{
		id: 29,
		template: Template29,
	},
	{
		id: 30,
		template: Template30,
	},
	{
		id: 31,
		template: Template31,
	},
	{
		id: 32,
		template: Template32,
	},
	{
		id: 33,
		template: Template33,
	},
	{
		id: 34,
		template: Template34,
	},
	{
		id: 35,
		template: Template35,
	},
	{
		id: 36,
		template: Template36,
	},
	{
		id: 37,
		template: Template37,
	},
	{
		id: 38,
		template: Template38,
	},
	{
		id: 39,
		template: Template39,
	},
	{
		id: 40,
		template: Template40,
	},
	{
		id: 41,
		template: Template41,
	},
	{
		id: 42,
		template: Template42,
	},
	{
		id: 43,
		template: Template43,
	},
	{
		id: 50,
		template: Template50,
	},
	{
		id: 51,
		template: Template51,
	},
	{
		id: 52,
		template: Template52,
	},
	{
		id: 53,
		template: Template53,
	},
	{
		id: 54,
		template: Template54,
	},
	{
		id: 55,
		template: Template55,
	},
	{
		id: 56,
		template: Template56,
	},
	{
		id: 57,
		template: Template57,
	},
	{
		id: 58,
		template: Template58,
	},
	{
		id: 59,
		template: Template59,
	},
	{
		id: 60,
		template: Template60,
	},
	{
		id: 61,
		template: Template61,
	},
	{
		id: 62,
		template: Template62,
	},
	{
		id: 63,
		template: Template63,
	},
	{
		id: 64,
		template: Template64,
	},
	{
		id: 65,
		template: Template65,
	},
	{ id: 70, template: Template70 },
	{ id: 71, template: Template71 },
	{ id: 72, template: Template72 },
	{ id: 73, template: Template73 },
	{ id: 74, template: Template74 },
	{ id: 75, template: Template75 },
	{ id: 76, template: Template76 },
	{ id: 77, template: Template77 },
	{ id: 78, template: Template78 },
	{ id: 79, template: Template79 },
	{ id: 80, template: Template80 },
	{ id: 81, template: Template81 },
	{ id: 82, template: Template82 },
	{ id: 83, template: Template83 },
	{ id: 84, template: Template84 },
	{ id: 85, template: Template85 },
	{ id: 86, template: Template86 },
	{ id: 87, template: Template87 },
	{ id: 88, template: Template88 },
	{ id: 89, template: Template89 },
	{ id: 90, template: Template90 },
	{ id: 91, template: Template91 },
	{ id: 92, template: Template92 },
	{ id: 93, template: Template93 },
	{ id: 94, template: Template94 },
	{ id: 95, template: Template95 },
	{ id: 96, template: Template96 },
	{ id: 97, template: Template97 },
	{ id: 98, template: Template98 },
	{ id: 99, template: Template99 },
	// Travel Kit Templates
	{ id: 101, template: Template101 },
	{ id: 102, template: Template102 },
	{ id: 103, template: Template103 },
	{ id: 104, template: Template104 },
	{ id: 105, template: Template105 },
	{ id: 106, template: Template106 },
	// Londres Templates
	{ id: 110, template: Template110 },
	{ id: 111, template: Template111 },
	{ id: 112, template: Template112 },
	{ id: 113, template: Template113 },
	{ id: 114, template: Template114 },
	{ id: 115, template: Template115 },
	{ id: 116, template: Template116 },
	{ id: 117, template: Template117 },
	{ id: 118, template: Template118 },
	{ id: 119, template: Template119 },
	{ id: 120, template: Template120 },
	{ id: 121, template: Template121 },
	{ id: 122, template: Template122 },
	{ id: 123, template: Template123 },
	{ id: 124, template: Template124 },
	{ id: 125, template: Template125 },
	{ id: 126, template: Template126 },
	{ id: 127, template: Template127 },
	{ id: 128, template: Template128 },
	// Seúl Templates
	{ id: 129, template: Template129 },
	{ id: 130, template: Template130 },
	{ id: 131, template: Template131 },
	{ id: 132, template: Template132 },
	{ id: 133, template: Template133 },
	{ id: 134, template: Template134 },
	{ id: 144, template: Template144 },
	{ id: 145, template: Template145 },
	{ id: 135, template: Template135 },
	{ id: 136, template: Template136 },
	{ id: 137, template: Template137 },
	{ id: 138, template: Template138 },
	{ id: 139, template: Template139 },
	{ id: 140, template: Template140 },
	{ id: 141, template: Template141 },
	{ id: 142, template: Template142 },
	{ id: 143, template: Template143 },
	{ id: 146, template: Template146 },
	{ id: 147, template: Template147 },
	// París templates (150-167)
	{ id: 150, template: Template150 },
	{ id: 151, template: Template151 },
	{ id: 152, template: Template152 },
	{ id: 153, template: Template153 },
	{ id: 154, template: Template154 },
	{ id: 155, template: Template155 },
	{ id: 156, template: Template156 },
	{ id: 157, template: Template157 },
	{ id: 158, template: Template158 },
	{ id: 159, template: Template159 },
	{ id: 160, template: Template160 },
	{ id: 161, template: Template161 },
	{ id: 162, template: Template162 },
	{ id: 163, template: Template163 },
	{ id: 164, template: Template164 },
	{ id: 165, template: Template165 },
	{ id: 166, template: Template166 },
	{ id: 167, template: Template167 },
	{ id: 168, template: Template168 },
	{ id: 169, template: Template169 },
	{ id: 170, template: Template170 },
	{ id: 171, template: Template171 },
	{ id: 172, template: Template172 },
	{ id: 173, template: Template173 },
	{ id: 174, template: Template174 },
	{ id: 175, template: Template175 },
	{ id: 176, template: Template176 },
	{ id: 177, template: Template177 },
	{ id: 178, template: Template178 },
	{ id: 179, template: Template179 },
	{ id: 180, template: Template180 },
	{ id: 181, template: Template181 },
	{ id: 182, template: Template182 },
	{ id: 183, template: Template183 },
	{ id: 184, template: Template184 },
	{ id: 185, template: Template185 },
	{ id: 186, template: Template186 },
	{ id: 187, template: Template187 },
	{ id: 188, template: Template188 },
	{ id: 189, template: Template189 },
	{ id: 190, template: Template190 },
	{ id: 191, template: Template191 },
	{ id: 192, template: Template192 },
	{ id: 193, template: Template193 },
	{ id: 194, template: Template194 },
	{ id: 195, template: Template195 },
	{ id: 196, template: Template196 },
	{ id: 197, template: Template197 },
	{ id: 198, template: Template198 },
	{ id: 199, template: Template199 },
	{ id: 200, template: Template200 },
	{ id: 201, template: Template201 },
	{ id: 202, template: Template202 },
	{ id: 203, template: Template203 },
	{ id: 204, template: Template204 },
	{ id: 205, template: Template205 },
	{ id: 206, template: Template206 },
	{ id: 207, template: Template207 },
	{ id: 208, template: Template208 },
	{ id: 209, template: Template209 },
	{ id: 210, template: Template210 },
	{ id: 211, template: Template211 },
	{ id: 212, template: Template212 },
	{ id: 213, template: Template213 },
	{ id: 214, template: Template214 },
	{ id: 215, template: Template215 },
	{ id: 216, template: Template216 },
	{ id: 217, template: Template217 },
	{ id: 218, template: Template218 },
	{ id: 219, template: Template219 },
	{ id: 220, template: Template220 },
	{ id: 221, template: Template221 },
	{ id: 222, template: Template222 },
	{ id: 223, template: Template223 },
	{ id: 224, template: Template224 },
	{ id: 225, template: Template225 },
	{ id: 226, template: Template226 },
	{ id: 227, template: Template227 },
	{ id: 228, template: Template228 },
	{ id: 229, template: Template229 },
	{ id: 230, template: Template230 },
	{ id: 231, template: Template231 },
	{ id: 232, template: Template232 },
	{ id: 233, template: Template233 },
	{ id: 246, template: Template246 },
	{ id: 247, template: Template247 },
	{ id: 248, template: Template248 },
	{ id: 249, template: Template249 },
	{ id: 250, template: Template250 },
	{ id: 251, template: Template251 },
	{ id: 252, template: Template252 },
	{ id: 253, template: Template253 },
	{ id: 254, template: Template254 },
	{ id: 255, template: Template255 },
	{ id: 256, template: Template256 },
	{ id: 257, template: Template257 },
	{ id: 258, template: Template258 },
	{ id: 259, template: Template259 },
	{ id: 260, template: Template260 },
	{ id: 261, template: Template261 },
	{ id: 262, template: Template262 },
	{ id: 263, template: Template263 },
	{ id: 264, template: Template264 },
	{ id: 265, template: Template265 },
	{ id: 266, template: Template266 },
	{ id: 267, template: Template267 },
	{ id: 268, template: Template268 },
	{ id: 269, template: Template269 },
	{ id: 270, template: Template270 },
	{ id: 271, template: Template271 },
	{ id: 272, template: Template272 },
	{ id: 273, template: Template273 },
	{ id: 274, template: Template274 },
	{ id: 275, template: Template275 },
	{ id: 276, template: Template276 },
	{ id: 277, template: Template277 },
	{ id: 278, template: Template278 },
	{ id: 279, template: Template279 },
	{ id: 280, template: Template280 },
	{ id: 281, template: Template281 },
	{ id: 282, template: Template282 },
	{ id: 283, template: Template283 },
	{ id: 284, template: Template284 },
	{ id: 285, template: Template285 },
	{ id: 286, template: Template286 },
	{ id: 287, template: Template287 },
	{ id: 288, template: Template288 },
	{ id: 289, template: Template289 },
	{ id: 290, template: Template290 },
	{ id: 291, template: Template291 },
	{ id: 293, template: Template293 },
	{ id: 294, template: Template294 },
	{ id: 295, template: Template295 },
	{ id: 296, template: Template296 },
	{ id: 297, template: Template297 },
	{ id: 298, template: Template298 },
	{ id: 299, template: Template299 },
	{ id: 300, template: Template300 },
	{ id: 301, template: Template301 },
	{ id: 302, template: Template302 },
	{ id: 303, template: Template303 },
	{ id: 304, template: Template304 },
	{ id: 305, template: Template305 },
	{ id: 309, template: Template309 },
	{ id: 310, template: Template310 },
	{ id: 311, template: Template311 },
	{ id: 312, template: Template312 },
	{ id: 313, template: Template313 },
	{ id: 314, template: Template314 },
	{ id: 315, template: Template315 },
	{ id: 316, template: Template316 },
	{ id: 317, template: Template317 },
	{ id: 318, template: Template318 },
	{ id: 319, template: Template319 },
	{ id: 324, template: Template324 },
	{ id: 325, template: Template325 },
	{ id: 326, template: Template326 },
	{ id: 327, template: Template327 },
	{ id: 328, template: Template328 },
	{ id: 330, template: Template330 },
	{ id: 331, template: Template331 },
	{ id: 332, template: Template332 },
	{ id: 333, template: Template333 },
	{ id: 334, template: Template334 },
	{ id: 335, template: Template335 },
	{ id: 336, template: Template336 },
	{ id: 337, template: Template337 },
	{ id: 338, template: Template338 },
	{ id: 339, template: Template339 },
	{ id: 340, template: Template340 },
];

const defaultPage = {
	id: -1 * new Date().getTime(),
	templateId: 0,
	order: 0,
	images: [null, null, null, null, null],
	texts: [
		{
			content: "Título de la página",
			isEditing: false,
		},
		{
			content: "",
			isEditing: false,
		},
		{
			content: "",
			isEditing: false,
		},
		{
			content: "",
			isEditing: false,
		},
		{
			content: "",
			isEditing: false,
		},
		{
			content: "",
			isEditing: false,
		},
		{
			content: "",
			isEditing: false,
		},
		{
			content: "",
			isEditing: false,
		},
	],
	canvasStickers: [
		/*{
			stickerId: 1,
			x: 1,
			y: 1,
			width: 1,
			height: 1,
			rotation: 0,
			scaleX: 1,
			scaleY: 1,
			skewX: 0,
			skewY: 0,
		},*/
	],
	canvasImages: [
		/*{
			stickerId: 1,
			x: 1,
			y: 1,
			width: 1,
			height: 1,
			rotation: 0,
			scaleX: 1,
			scaleY: 1,
			skewX: 0,
			skewY: 0,
		},*/
	],
	canvasTexts: [
		/*{
			stickerId: 1,
			x: 1,
			y: 1,
			width: 1,
			height: 1,
			rotation: 0,
			scaleX: 1,
			scaleY: 1,
			skewX: 0,
			skewY: 0,
		},*/
	],
	maps: ["", "", ""],
	transport: [],
	notes: [],
};

const AntSwitch = styled(Switch)(({ theme }) => ({
	width: 28,
	height: 16,
	padding: 0,
	display: "flex",
	"&.MuiSwitch-root": {
		transform: "rotate(90deg)",
		marginTop: "8px",
		marginBottom: "8px",
		marginLeft: "0!important",
	},
	"&:active": {
		"& .MuiSwitch-thumb": {
			width: 15,
		},
		"& .MuiSwitch-switchBase.Mui-checked": {
			transform: "translateX(9px)",
		},
	},
	"& .MuiSwitch-switchBase": {
		padding: 2,
		"&.Mui-checked": {
			transform: "translateX(12px)",
			color: "#fff",
			"& + .MuiSwitch-track": {
				opacity: 1,
				backgroundColor: theme.palette.mode === "dark" ? "#6366F1" : "#6366F1",
			},
		},
	},
	"& .MuiSwitch-thumb": {
		boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
		width: 12,
		height: 12,
		borderRadius: 6,
		transition: theme.transitions.create(["width"], {
			duration: 200,
		}),
	},
	"& .MuiSwitch-track": {
		borderRadius: 16 / 2,
		opacity: 1,
		backgroundColor:
			theme.palette.mode === "dark"
				? "rgba(255,255,255,.35)"
				: "rgba(0,0,0,.25)",
		boxSizing: "border-box",
	},
}));

const AntSwitchMobile = styled(Switch)(({ theme }) => ({
	width: 28,
	height: 16,
	padding: 0,
	display: "flex",
	"&.MuiSwitch-root": {
		transform: "rotate(0deg)",
		marginLeft: "8px!important",
		marginRight: "8px!important",
	},
	"&:active": {
		"& .MuiSwitch-thumb": {
			width: 15,
		},
		"& .MuiSwitch-switchBase.Mui-checked": {
			transform: "translateX(9px)",
		},
	},
	"& .MuiSwitch-switchBase": {
		padding: 2,
		"&.Mui-checked": {
			transform: "translateX(12px)",
			color: "#fff",
			"& + .MuiSwitch-track": {
				opacity: 1,
				backgroundColor: theme.palette.mode === "dark" ? "#6366F1" : "#6366F1",
			},
		},
	},
	"& .MuiSwitch-thumb": {
		boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
		width: 12,
		height: 12,
		borderRadius: 6,
		transition: theme.transitions.create(["width"], {
			duration: 200,
		}),
	},
	"& .MuiSwitch-track": {
		borderRadius: 16 / 2,
		opacity: 1,
		backgroundColor:
			theme.palette.mode === "dark"
				? "rgba(255,255,255,.35)"
				: "rgba(0,0,0,.25)",
		boxSizing: "border-box",
	},
}));

const StickerApp = () => {
	useEffect(() => {
		loadEditorFonts();
	}, []);
	const [stickers, setStickers] = useState([]);
	const { enqueueSnackbar } = useSnackbar();
	const {
		user,
		limits,
		handleLogout,
		readProjects,
		createProject,
		readProject,
		readPages,
		createPage,
		updatePage,
		updatePages,
		deletePage,
		getCurrentProject,
		setCurrentProject,
		updateProject,
		initialLoading,
		createImage,
		deleteImage,
		getImages,
		createSharedGuide,
		getSharedGuides,
		getPacks,
		purchasePack,
		purchaseSubscription,
	} = useFirebase();
	// Límite de páginas por guía según plan (FREE: 3 o base+3 si prebuilt; Pro: 99). Si el proyecto viene del API con maxPagesPerGuide, se usa ese valor.
	const rawMax = limits?.maxPagesPerGuide;
	const [showPageLimitModal, setShowPageLimitModal] = useState(false);
	// Pack que puede desbloquear más páginas para la guía prebuilt
	// actual (ej: Pack Japón para un proyecto con prebuiltGuideId=japon).
	// Se resuelve perezosamente cuando se abre el modal de límite.
	const [upgradePack, setUpgradePack] = useState(null);
	const [purchasingUpgradePack, setPurchasingUpgradePack] = useState(false);
	const [justInitSession, setJustInitSession] = useState(false);
	const [selectedTab, setSelectedTab] = useState(null);

	const [activeId, setActiveId] = useState(null);

	// Configurar sensores diferentes para móvil y desktop
	// En móvil, usar TouchSensor con delay para permitir que los taps funcionen primero
	// En desktop, usar PointerSensor con distancia mínima
	/*const sensors = useSensors(
		useSensor(PointerSensor, {
			activationConstraint: {
				distance: 8,
			},
		}),
		useSensor(TouchSensor, {
			activationConstraint: {
				delay: 250, // Delay de 250ms para permitir que los taps funcionen primero
				tolerance: 5, // Tolerancia de 5px de movimiento
			},
		}),
		useSensor(KeyboardSensor, {
			coordinateGetter: sortableKeyboardCoordinates,
		}),
	);*/

	const sensors = useSensors(
		useSensor(MouseSensor, {
			activationConstraint: {
				distance: 8,
			},
		}),
		useSensor(TouchSensor, {
			activationConstraint: {
				delay: 300,
				tolerance: 8,
			},
		}),
		useSensor(KeyboardSensor, {
			coordinateGetter: sortableKeyboardCoordinates,
		}),
	);

	const fontNames = [
		"Alfa Slab One",
		"Amatic SC",
		"Anton",
		"Archivo Black",
		"Arvo",
		"Bebas Neue",
		"Bungee",
		"Caveat",
		"Cinzel",
		"Concert One",
		"Indie Flower",
		"Lato",
		"Lilita One",
		"Lobster",
		"Lobster Two",
		"Luckiest Guy",
		"Merriweather Sans",
		"Montserrat",
		"Noto Sans",
		"Noto Sans JP",
		"Noto Sans Mono",
		"Noto Sans TC",
		"Nunito",
		"Nunito Sans",
		"Oswald",
		"Pacifico",
		"Poiret One",
		"Poppins",
		"Quicksand",
		"Raleway",
		"Roboto",
		"Roboto Slab",
		"Rubik Mono One",
		"Satisfy",
		"Sedgwick Ave Display",
		"Shadows Into Light",
		"Signika",
		"Titan One",
	].sort();

	// Sticker collections loaded from backend API
	const [stickerCollections, setStickerCollections] = useState([]);
	const [stickerCollectionsLoading, setStickerCollectionsLoading] =
		useState(false);
	const [loadedCollectionDetails, setLoadedCollectionDetails] = useState({});
	const [loadingCollectionId, setLoadingCollectionId] = useState(null);
	// Modal "¿Cómo quieres acceder?" al desbloquear pack de stickers
	const [purchaseModalOpen, setPurchaseModalOpen] = useState(false);
	// Modal de stickers personalizados (el usuario escribe su nombre y se integra
	// dinámicamente sobre una imagen base).
	const [customStickerModalOpen, setCustomStickerModalOpen] = useState(false);
	const STICKER_PACK_GUIDE = {
		name: "Packs de stickers",
		id: "stickers",
		price: 4.99,
	};

	const {
		getStickerCollections,
		getStickerCollection,
		getStickerAssetUrl,
		getCustomStickerAssetUrl,
		getAuthenticatedUrl,
	} = useFirebase();

	useEffect(() => {
		const html = document.documentElement;
		const body = document.body;
		html.style.overflow = "hidden";
		body.style.overflow = "hidden";
		return () => {
			html.style.overflow = "";
			body.style.overflow = "";
		};
	}, []);

	useEffect(() => {
		let cancelled = false;
		const loadCollections = async () => {
			setStickerCollectionsLoading(true);
			try {
				const collections = await getStickerCollections();
				if (!cancelled && Array.isArray(collections)) {
					setStickerCollections(collections);
					const emptyStickers = collections.map(() => []);
					// Only pre-load the first unlocked collection (index 0 by default)
					const firstIdx = collections.findIndex((c) => !c.isLocked);
					if (firstIdx >= 0) {
						const col = collections[firstIdx];
						const detail = await getStickerCollection(col.id);
						if (!cancelled && detail?.stickers) {
							setLoadedCollectionDetails((prev) => ({
								...prev,
								[col.id]: detail,
							}));
							emptyStickers[firstIdx] = detail.stickers.map((s, idx) => ({
								id: `${col.id}-${idx}`,
								x: 50,
								y: 50,
								width: 200,
								image: (() => {
									const img = new window.Image();
									img.crossOrigin = "anonymous";
									return img;
								})(),
								imagePath: getStickerAssetUrl(s.assetId),
								assetId: s.assetId,
								isFree: s.isFree !== false,
							}));
						}
					}
					if (!cancelled) setStickers(emptyStickers);
				}
			} catch (err) {
				console.error("Error loading sticker collections:", err);
			} finally {
				if (!cancelled) setStickerCollectionsLoading(false);
			}
		};
		loadCollections();
		return () => {
			cancelled = true;
		};
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const handleUnlockCollection = async (collectionIndex) => {
		const col = stickerCollections[collectionIndex];
		if (!col) return;
		try {
			const detail = await getStickerCollection(col.id);
			if (detail && !detail.isLocked && detail.stickers) {
				setLoadedCollectionDetails((prev) => ({ ...prev, [col.id]: detail }));
				setStickerCollections((prev) =>
					prev.map((c, i) =>
						i === collectionIndex ? { ...c, isLocked: false } : c,
					),
				);
				const newSetStickers = detail.stickers.map((s, idx) => ({
					id: `${col.id}-${idx}`,
					x: 50,
					y: 50,
					width: 200,
					image: (() => {
						const img = new window.Image();
						img.crossOrigin = "anonymous";
						return img;
					})(),
					imagePath: getStickerAssetUrl(s.assetId),
					assetId: s.assetId,
				}));
				setStickers((prev) => {
					const copy = [...prev];
					copy[collectionIndex] = newSetStickers;
					return copy;
				});
			}
		} catch (err) {
			console.error("Error unlocking collection:", err);
		}
	};

	const [scaleMode, setScaleMode] = useState("fit");

	const [width, setWidth] = useState(800);
	const [height, setHeight] = useState(760); // useState((800 * 29.7) / 21);
	const [selectedProject, setSelectedProject] = useState(null);
	// Límite de páginas: Pro = 99; FREE con guía en blanco = 3; FREE con guía desde prebuilt = base + 3 (viene en selectedProject.maxPagesPerGuide)
	const maxPagesAllowed =
		rawMax === -1 || rawMax === "-1"
			? MAX_PAGES_PER_GUIDE
			: Math.min(
					MAX_PAGES_PER_GUIDE,
					Number(selectedProject?.maxPagesPerGuide ?? rawMax) || 3,
				);
	const [selectedStickerIndex, setSelectedStickerIndex] = useState(null);
	const [selectedImageIndex, setSelectedImageIndex] = useState(null);
	const [selectedTextIndex, setSelectedTextIndex] = useState(null);
	const [editingTextIndex, setEditingTextIndex] = useState(null);
	const [isTransformingSticker, setIsTransformingSticker] = useState(false);
	//const [stickersOnCanvas, setStickersOnCanvas] = useState([]);
	const stickersRef = useRef(null);
	//const [textOnCanvas, setTextOnCanvas] = useState([]);
	const [newTextValue, setNewTextValue] = useState("");
	const [backgroundColor, setBackgroundColor] = useState("rgb(252, 252, 252)");
	const [textColor, setTextColor] = useState("#000000");
	const [headerBackgroundColor, setHeaderBackgroundColor] = useState("#6366F1");
	const [headerTextColor, setHeaderTextColor] = useState("#FFFFFF");
	const [fontFamily, setFontFamily] = useState("Montserrat");
	const [editTemplate, setEditTemplate] = useState(true);
	const [mainCanvasScale, setMainCanvasScale] = useState(1);
	// Escala del Stage respecto a pantalla: (tamaño mostrado del canvas) / (dimensiones internas).
	// Se usa para que handlers del Transformer y botones editar/eliminar tengan tamaño fijo en pantalla.
	const [stageScale, setStageScale] = useState(1);
	const mainCanvasRef = useRef(null);
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [selectedGroupSticker, setSelectedGroupSticker] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [mapFullscreenActive, setMapFullscreenActive] = useState(false);
	const pagesListScrollRef = useRef(null);
	const [pagesDrawerOpen, setPagesDrawerOpen] = useState(false);
	// Ref al contenedor con scroll del To-Do (template 100) para reenviar rueda/touch desde el canvas
	const template100ScrollRef = useRef(null);
	const template100TouchYRef = useRef(null);

	// Función para navegar a una página específica desde el menú (Template24)
	const handleNavigateToPage = (targetPageIdOrIndex) => {
		if (targetPageIdOrIndex === undefined || targetPageIdOrIndex === null) {
			return;
		}

		// Si es un número, asumimos que es un índice
		if (typeof targetPageIdOrIndex === "number") {
			if (targetPageIdOrIndex >= 0 && targetPageIdOrIndex < pages.length) {
				setCurrentPage(targetPageIdOrIndex);
			}
			return;
		}

		// Si es un string, buscar por ID
		const targetPageIndex = pages.findIndex(
			(page) =>
				page.id === targetPageIdOrIndex ||
				page.data?.id === targetPageIdOrIndex,
		);

		if (targetPageIndex !== -1) {
			setCurrentPage(targetPageIndex);
		}
	};

	const [selectedIndividualImage, setSelectedIndividualImage] = useState(0);
	const fileInputRef = useRef(null);
	const isProcessingImageRef = useRef(false);

	const [showProjects, setShowProjects] = useState(false);

	const [showSaveLoading, setShowSaveLoading] = useState(false);
	const [showExport, setShowExport] = useState(false);
	const [clickedX, setClickedX] = useState(null);
	const [clickedY, setClickedY] = useState(null);

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalText, setModalText] = useState("");
	const [modalTextFont, setModalTextFont] = useState("Montserrat");
	const [modalTextFontSize, setModalTextFontSize] = useState(32);
	const [modalTextColor, setModalTextColor] = useState("#000000");
	const [modalTextStrokeColor, setModalTextStrokeColor] = useState("#ffffff");
	const [modalTextStrokeWidth, setModalTextStrokeWidth] = useState(4);
	const [modalTextAlign, setModalTextAlign] = useState("left");

	// Estados para notas
	const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
	const [noteContent, setNoteContent] = useState("");
	const [noteEmoji, setNoteEmoji] = useState("");
	const [editingNote, setEditingNote] = useState(null);
	const [notePosition, setNotePosition] = useState({ x: 50, y: 50 });
	const [isAddingNote, setIsAddingNote] = useState(false);
	const [modalEditor, setModalEditor] = useState(null);
	const [textIndex, setTextIndex] = useState(-1);
	const [compressing, setCompressing] = useState(false);
	const [finishedLoading, setFinishedLoading] = useState(false);
	const [contextMenu, setContextMenu] = useState(null);
	const [canvasDimensions, setCanvasDimensions] = useState({
		width: 800,
		height: 800 * (29.7 / 21),
	});
	// Rects de bloques anclables [data-block-id] en coordenadas del Stage (mismo origen que canvasDimensions)
	const [blockRects, setBlockRects] = useState({});
	const previousCanvasDimensionsRef = useRef(null);
	const canvasContainerRef = useRef(null);
	const isPropagatingClickRef = useRef(false);

	// Refs para detectar scroll durante touch en el canvas
	const canvasTouchStartRef = useRef(null);
	const canvasHasMovedRef = useRef(false);
	// Evitar llamadas duplicadas a getProject/getProjects cuando el ref no ha cambiado
	const lastLoadedRefParamRef = useRef(null);
	const creatingGuideRef = useRef(false);

	const compressImage = async (file) => {
		setCompressing(true);
		const options = {
			maxSizeMB: 0.3, // (Max file size in MB)
			maxWidthOrHeight: 1280, // (Compressed file's maximum dimension in pixels)
			useWebWorker: true, // (Use a web worker to perform the compression in a background thread)
			maxIteration: 100,
		};

		try {
			const compressedFile = await imageCompression(file, options);
			console.log(compressedFile);
			setCompressing(false);
			return compressedFile; // This is the compressed image file
		} catch (error) {
			setCompressing(false);
			console.log(error);
			console.log(file);
			enqueueSnackbar(
				"La imagen no es compatible. Inténtalo con una distinta.",
				{ variant: "error" },
			);
			return null;
		}
	};

	const getBase64ImageFromUrl = async (imageUrl) => {
		return new Promise((resolve, reject) => {
			const img = new Image();
			img.crossOrigin = "anonymous";

			img.onload = () => {
				// Verificar que la imagen esté completamente cargada y no esté rota
				if (img.complete && img.naturalWidth > 0 && img.naturalHeight > 0) {
					try {
						const canvas = document.createElement("canvas");
						canvas.width = img.width;
						canvas.height = img.height;
						const ctx = canvas.getContext("2d");
						ctx.drawImage(img, 0, 0);
						const base64data = canvas.toDataURL("image/jpeg");
						return resolve(base64data);
					} catch (error) {
						console.error("Error drawing image to canvas:", error, imageUrl);
						return reject(new Error("Failed to draw image to canvas"));
					}
				} else {
					return reject(new Error("Image is in broken state"));
				}
			};
			img.onerror = (e) => {
				console.error("Error loading image:", imageUrl, e);
				return reject(new Error("Failed to load image"));
			};
			img.src = imageUrl;
		});
	};

	/* Data Structures and save */
	//const [images, setImages] = useState([null, null, null]);
	/*const [texts, setTexts] = useState([
		{
			content: "Título de la página",
			isEditing: false,
		},
		{
			content:
				"Esta guía es tu lienzo en blanco. Personalízala según tus intereses y preferencias. Marca los lugares que deseas visitar y agrega tus propias notas para recordar momentos especiales.",
			isEditing: false,
		},
		{
			content:
				"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
			isEditing: false,
		},
	]);*/

	const getMap = () => {
		if (!stickersRef.current) {
			// Initialize the Map on first usage.
			stickersRef.current = new Map();
		}
		return stickersRef.current;
	};

	const [projects, setProjects] = useState([
		{
			name:
				"Nuevo proyecto " +
				Intl.DateTimeFormat("es", {
					day: "2-digit",
					month: "long",
					year: "numeric",
				}).format(new Date()),
			backgroundColor: backgroundColor,
			textColor: textColor,
			headerBackgroundColor: headerBackgroundColor,
			headerTextColor: headerTextColor,
			createdAt: new Date().getTime(),
			updatedAt: new Date().getTime(),
		},
	]);
	const [pages, setPages] = useState([{ ...defaultPage }]);
	const [initialPages, setInitialPages] = useState([{ ...defaultPage }]);

	// Ref para que el handler de "añadir página" siempre use el count actual (evita closure obsoleta)
	const pagesLengthRef = useRef(pages.length);
	pagesLengthRef.current = pages.length;
	const selectedProjectRef = useRef(selectedProject);
	selectedProjectRef.current = selectedProject;

	// Página actual segura para templates: evita undefined o falta de .texts (p. ej. al cargar guía NY)
	let safeCurrentPage = pages[currentPage] ?? defaultPage;
	if (!Array.isArray(safeCurrentPage.texts)) {
		safeCurrentPage = {
			...defaultPage,
			...safeCurrentPage,
			templateId:
				safeCurrentPage?.templateId ??
				safeCurrentPage?.data?.templateId ??
				defaultPage.templateId,
			texts: safeCurrentPage?.data?.texts ?? defaultPage.texts,
		};
	}
	// Misma forma que en Viewer: fusionar data en la raíz para que templates reciban maps, images, sections, etc. en la raíz
	if (safeCurrentPage?.data != null) {
		safeCurrentPage = { ...safeCurrentPage, ...safeCurrentPage.data };
	}

	// En To-Do (template 100) y Travel Kit Info (102): capturar wheel en document (fase captura) para que el scroll llegue al contenido
	useEffect(() => {
		const templateId = pages[currentPage]?.templateId;
		const isScrollableTemplate = [100 /*, 101, 102*/].find(
			(id) => id === templateId,
		);
		if (!isScrollableTemplate) return;

		const scrollSelector = `[data-template${templateId}-scroll]`;
		const onWheel = (e) => {
			const scrollEl = document.querySelector(scrollSelector);
			if (!scrollEl) return;
			const templatesContainer = document.getElementById("templates-container");
			if (!templatesContainer || !templatesContainer.contains(e.target)) return;

			const maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
			if (maxScroll <= 0) return;
			const next = scrollEl.scrollTop + e.deltaY;
			scrollEl.scrollTop = Math.max(0, Math.min(next, maxScroll));
			e.preventDefault();
			e.stopPropagation();
		};

		document.addEventListener("wheel", onWheel, {
			capture: true,
			passive: false,
		});
		return () => {
			document.removeEventListener("wheel", onWheel, {
				capture: true,
				passive: false,
			});
		};
	}, [currentPage, pages]);

	const savePages = async (auxSelectedProject) => {
		setShowSaveLoading(true);
		trackEditorAction("guide_saved", auxSelectedProject?.id, {
			guide_name: auxSelectedProject?.name,
			prebuilt_guide_id: auxSelectedProject?.prebuiltGuideId || undefined,
		});

		try {
			let selectedProject = null;
			console.log();
			selectedProject = auxSelectedProject;
			let index = 0;
			let fixedPages = [[]];
			let fixedIndex = 0;
			let auxImages = [];

			console.log(initialPages.slice());
			console.log(pages.slice());

			// El array 'pages' ya refleja el orden visual correcto
			// Simplemente asignamos el order basado en la posición en el array
			// Esto asegura que el order en la base de datos refleje el orden visual actual
			const sortedPages = pages.map((page, index) => {
				const pageCopy = { ...page };
				pageCopy.order = index;
				if (pageCopy.data) {
					pageCopy.data = { ...pageCopy.data, order: index };
				} else if (
					pageCopy.templateId !== undefined ||
					pageCopy.images ||
					pageCopy.texts
				) {
					// Si no tiene data pero tiene otras propiedades, crear data
					pageCopy.data = {
						templateId: pageCopy.templateId,
						images: pageCopy.images,
						texts: pageCopy.texts,
						maps: pageCopy.maps,
						transport: pageCopy.transport,
						notes: pageCopy.notes,
						canvasStickers: pageCopy.canvasStickers,
						canvasImages: pageCopy.canvasImages,
						canvasTexts: pageCopy.canvasTexts,
						order: index,
					};
				}
				return pageCopy;
			});

			for (const auxPage of initialPages) {
				if (
					!sortedPages.find((p) => {
						console.log(p.id);
						return p.id === auxPage.id;
					})
				) {
					console.log("DELETING!!!!");
					await deletePage(selectedProject.id, auxPage.id);
					await new Promise((resolve) => setTimeout(() => resolve(true), 100));
					// TO CHANGE
					// delete images of the page
					for (const auxImage of auxPage.images) {
						const { id } = auxImage;
						await deleteImage(id, selectedProject.id);
					}
					for (const auxImage of auxPage.canvasImages) {
						const { id } = auxImage;
						await deleteImage(id, selectedProject.id);
					}
				}
			}
			for (let index = 0; index < sortedPages.length; index++) {
				const auxPage = sortedPages[index];
				const found = initialPages.find(
					(initialPage) => initialPage.id === auxPage.id,
				);
				const { docRef: originalDocRef, ...originalRest } = found || {};
				const { docRef, ...rest } = auxPage;

				// Normalizar arrays para comparación (eliminar propiedades temporales)
				const normalizeForComparison = (page) => {
					if (!page) return null;
					const normalized = { ...page };
					// Eliminar propiedades temporales que no se guardan
					delete normalized.docRef;
					// Normalizar arrays de canvas
					if (normalized.canvasStickers) {
						normalized.canvasStickers = normalized.canvasStickers.map((s) => {
							const { image, ...sticker } = s;
							return sticker;
						});
					}
					if (normalized.canvasImages) {
						normalized.canvasImages = normalized.canvasImages.map((img) => {
							const { image, imageUrl, ...imageData } = img;
							return imageData;
						});
					}
					if (normalized.canvasTexts) {
						normalized.canvasTexts = normalized.canvasTexts.map((text) => ({
							...text,
						}));
					}
					return normalized;
				};

				const normalizedOriginal = normalizeForComparison(found);
				const normalizedCurrent = normalizeForComparison(auxPage);
				const hasChanges =
					!found || !_.isEqual(normalizedOriginal, normalizedCurrent);

				if (index === 0) {
					console.log("Original:", normalizedOriginal);
					console.log("Current:", normalizedCurrent);
					console.log("Has changes:", hasChanges);
				}
				console.log(found);
				if (hasChanges) {
					console.log(auxPage);
					if (auxPage.id < 0) {
						// TO DO
						let docRef = auxPage.docRef;
						let fixedPage = _.cloneDeep({ ...auxPage });
						fixedPage.docRef = docRef;

						// Asegurar que templateId esté presente (si no está, usar 0 o el actual)
						if (
							fixedPage.templateId === undefined ||
							fixedPage.templateId === null
						) {
							fixedPage.templateId = 0;
						}

						// Asegurar que images y texts existan
						if (!fixedPage.images) {
							fixedPage.images = [null, null, null, null, null];
						}
						if (!fixedPage.texts) {
							fixedPage.texts = [
								{ content: "Título de la página", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
							];
						}
						if (!fixedPage.maps) {
							fixedPage.maps = ["", "", ""];
						}
						if (!fixedPage.transport) {
							fixedPage.transport = [];
						}
						if (!fixedPage.notes) {
							fixedPage.notes = [];
						}

						// Asegurar que canvasStickers, canvasImages y canvasTexts existan
						if (!fixedPage.canvasStickers) {
							fixedPage.canvasStickers = [];
						}
						if (!fixedPage.canvasImages) {
							fixedPage.canvasImages = [];
						}
						if (!fixedPage.canvasTexts) {
							fixedPage.canvasTexts = [];
						}

						fixedPage.canvasStickers = fixedPage.canvasStickers.map(
							(sticker) => {
								// CHANGE
								//auxImages.push({ pageId: auxPage.id, image: sticker.image });
								const { image, ...stickerData } = sticker;
								// Migrar a porcentajes si es necesario
								return migrateStickerToPercent(stickerData, 800, 1000);
							},
						);
						for (const auxImage of fixedPage.images) {
							// CHANGE
							if (auxImage && auxImage.id < 0) {
								// create image
								// add id
								try {
									// Validar que auxImage.src exista antes de crear la imagen
									if (!auxImage.src) {
										console.error("No image src found for image:", auxImage);
										continue;
									}
									console.log("SRC");
									console.log(auxImage.src);
									const image = await createImage(
										auxImage.src,
										selectedProject.id,
									);
									if (image && image.id) {
										console.log("IMAGE CREATED");
										console.log(image);
										auxImage.id = image.id;
									}
								} catch (error) {
									console.error("Error creating image:", error);
								}
								/*} else if (
							!initialPages
								.find((p) => p.id === auxPage.id)
								?.images.find((i) => i.id === auxImage.id)
						) {
							// delete image
							delete auxImage.src;
							try {
								await deleteImage(auxImage.id, selectedProject.id);
								console.log("DELETE IMAGE");
							} catch (error) {
								console.log(error);
							}*/
							}
						}
						// Migrar canvasImages a porcentajes
						fixedPage.canvasImages = fixedPage.canvasImages.map((img) => {
							return migrateStickerToPercent(img, 800, 1000);
						});
						for (const auxImage of fixedPage.canvasImages) {
							// CHANGE
							if (auxImage && auxImage.id < 0) {
								// create image
								// add id
								try {
									const imageData = auxImage.image?.src || auxImage.imageUrl;
									if (!imageData) {
										console.error(
											"No image data found for canvas image:",
											auxImage,
										);
										continue;
									}
									const image = await createImage(
										imageData,
										selectedProject.id,
									);
									if (image && image.id) {
										auxImage.id = image.id;
										auxImage.imageUrl = image.url || imageData;
									}
								} catch (error) {
									console.error("Error creating canvas image:", error);
								}
								delete auxImage.image;
							} else if (
								auxImage &&
								!initialPages
									.find((p) => p.id === auxPage.id)
									?.canvasImages.find((i) => i.id === auxImage.id)
							) {
								delete auxImage.image;
								delete auxImage.imageUrl;
								try {
									await deleteImage(auxImage.id, selectedProject.id);
								} catch (error) {
									console.log(error);
								}
							} else if (auxImage) {
								delete auxImage.image;
							}
						}

						// Asegurar que canvasTexts se preserve correctamente
						// SIEMPRE crear o actualizar data con los campos actuales (el backend guarda en data)
						if (!fixedPage.data) {
							fixedPage.data = {};
						}
						fixedPage.data.templateId = fixedPage.templateId;
						fixedPage.data.images = (fixedPage.images || []).map((img) => {
							if (
								!img ||
								typeof img !== "object" ||
								!img.src ||
								img.src.startsWith("data:")
							)
								return img;
							try {
								const u = new URL(img.src, window.location.origin);
								u.searchParams.delete("token");
								return { ...img, src: u.pathname + u.search };
							} catch {
								return img;
							}
						});
						fixedPage.data.texts = fixedPage.texts || [];
						fixedPage.data.maps = fixedPage.maps || ["", "", ""];
						fixedPage.data.transport = fixedPage.transport || [];
						fixedPage.data.notes = fixedPage.notes || [];
						fixedPage.data.canvasStickers = (
							fixedPage.canvasStickers || []
						).map((s) => {
							const cleaned = { ...s };
							if (cleaned.imagePath) {
								try {
									const u = new URL(cleaned.imagePath, window.location.origin);
									u.searchParams.delete("token");
									cleaned.imagePath = u.pathname + u.search;
								} catch {
									/* keep as is */
								}
							}
							delete cleaned.image;
							return cleaned;
						});
						fixedPage.data.canvasImages = fixedPage.canvasImages || [];
						fixedPage.data.canvasTexts = fixedPage.canvasTexts || [];

						// Limpiar tokens de dias/extras antes de guardar
						const stripTokenArr1 = (arr) => {
							if (!Array.isArray(arr)) return arr;
							return arr.map((item) => {
								if (
									!item?.image ||
									typeof item.image !== "string" ||
									item.image.startsWith("data:")
								)
									return item;
								try {
									const u = new URL(item.image, window.location.origin);
									u.searchParams.delete("token");
									return { ...item, image: u.pathname + u.search };
								} catch {
									return item;
								}
							});
						};
						if (fixedPage.data.dias)
							fixedPage.data.dias = stripTokenArr1(fixedPage.data.dias);
						if (fixedPage.data.extras)
							fixedPage.data.extras = stripTokenArr1(fixedPage.data.extras);

						// Usar el índice del array ordenado como order (ya actualizado arriba)
						// Esto asegura que el order coincida con la posición real en el array
						fixedPage.order = index;
						fixedPage.data.order = index;

						console.log("FIXED PAGES");
						console.log(fixedPage);
						delete fixedPage.docRef;
						const newPage = await createPage(selectedProject.id, fixedPage);

						console.log(newPage);

						if (!newPage || !newPage.id) {
							console.error(
								"createPage failed or returned no id for page at index",
								index,
							);
							setShowPageLimitModal(true);
							enqueueSnackbar(
								"No se pudo crear la página. Es posible que hayas alcanzado el límite de páginas de tu plan.",
								{ variant: "error" },
							);
							continue;
						}

						await new Promise((resolve) =>
							setTimeout(() => resolve(true), 100),
						);
						const auxPages = [...pages];
						console.log(auxPages);
						auxPages[index].id = newPage.id;
						setPages(auxPages);
						// set page with new id
					} else {
						console.log("AQUIIIII");
						let docRef = auxPage.docRef;
						let fixedPage = _.cloneDeep({ ...auxPage });
						fixedPage.docRef = docRef;

						// Asegurar que templateId esté presente
						if (
							fixedPage.templateId === undefined ||
							fixedPage.templateId === null
						) {
							fixedPage.templateId = 0;
						}

						// Asegurar que images y texts existan
						if (!fixedPage.images) {
							fixedPage.images = [null, null, null, null, null];
						}
						if (!fixedPage.texts) {
							fixedPage.texts = [
								{ content: "Título de la página", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
								{ content: "", isEditing: false },
							];
						}
						if (!fixedPage.maps) {
							fixedPage.maps = ["", "", ""];
						}
						if (!fixedPage.transport) {
							fixedPage.transport = [];
						}
						if (!fixedPage.notes) {
							fixedPage.notes = [];
						}

						// Asegurar que canvasStickers, canvasImages y canvasTexts existan
						if (!fixedPage.canvasStickers) {
							fixedPage.canvasStickers = [];
						}
						if (!fixedPage.canvasImages) {
							fixedPage.canvasImages = [];
						}
						if (!fixedPage.canvasTexts) {
							fixedPage.canvasTexts = [];
						}

						fixedPage.canvasStickers = fixedPage.canvasStickers.map(
							(sticker) => {
								const { image, ...stickerData } = sticker;
								// Migrar a porcentajes si es necesario
								return migrateStickerToPercent(stickerData, 800, 1000);
							},
						);
						console.log(fixedPage.images);
						for (const auxImage of fixedPage.images) {
							// CHANGE
							if (auxImage && auxImage.id < 0) {
								// create image
								// add id
								try {
									// Validar que auxImage.src exista antes de crear la imagen
									if (!auxImage.src) {
										console.error("No image src found for image:", auxImage);
										continue;
									}
									const image = await createImage(
										auxImage.src,
										selectedProject.id,
									);
									if (image && image.id) {
										console.log("IMAGE CREATED");
										console.log(image);
										auxImage.id = image.id;
									}
								} catch (error) {
									console.error("Error creating image:", error);
								}
								/*} else if (
							!initialPages
								.find((p) => p.id === auxPage.id)
								?.images.find((i) => i.id === auxImage.id)
						) {
							// delete image
							delete auxImage.image;
							delete auxImage.imageUrl;
							try {
								await deleteImage(auxImage.id, selectedProject.id);
								console.log("DELETE IMAGE");
							} catch (error) {
								console.log(error);
							}*/
							}
						}
						// Migrar canvasImages a porcentajes
						fixedPage.canvasImages = fixedPage.canvasImages.map((img) => {
							return migrateStickerToPercent(img, 800, 1000);
						});
						for (const auxImage of fixedPage.canvasImages) {
							// CHANGE
							if (auxImage && auxImage.id < 0) {
								// create image
								// add id
								try {
									// Usar image.src si existe, sino usar imageUrl
									const imageData = auxImage.image?.src || auxImage.imageUrl;
									if (!imageData) {
										console.error(
											"No image data found for canvas image:",
											auxImage,
										);
										continue;
									}
									const image = await createImage(
										imageData,
										selectedProject.id,
									);
									if (image && image.id) {
										auxImage.id = image.id;
										auxImage.imageUrl = image.url || imageData;
									}
								} catch (error) {
									console.error("Error creating canvas image:", error);
								}
								delete auxImage.image;
							} else if (
								auxImage &&
								!initialPages
									.find((p) => p.id === auxPage.id)
									?.canvasImages.find((i) => i.id === auxImage.id)
							) {
								delete auxImage.image;
								delete auxImage.imageUrl;
								try {
									await deleteImage(auxImage.id, selectedProject.id);
								} catch (error) {
									console.log(error);
								}
							} else if (auxImage) {
								delete auxImage.image;
							}
						}

						// Asegurar que canvasTexts se preserve correctamente
						// SIEMPRE crear o actualizar data con los campos actuales (el backend guarda en data)
						if (!fixedPage.data) {
							fixedPage.data = {};
						}
						fixedPage.data.templateId = fixedPage.templateId;
						fixedPage.data.images = (fixedPage.images || []).map((img) => {
							if (
								!img ||
								typeof img !== "object" ||
								!img.src ||
								img.src.startsWith("data:")
							)
								return img;
							try {
								const u = new URL(img.src, window.location.origin);
								u.searchParams.delete("token");
								return { ...img, src: u.pathname + u.search };
							} catch {
								return img;
							}
						});
						fixedPage.data.texts = fixedPage.texts || [];
						fixedPage.data.maps = fixedPage.maps || ["", "", ""];
						fixedPage.data.transport = fixedPage.transport || [];
						fixedPage.data.notes = fixedPage.notes || [];
						fixedPage.data.canvasStickers = (
							fixedPage.canvasStickers || []
						).map((s) => {
							const cleaned = { ...s };
							if (cleaned.imagePath) {
								try {
									const u = new URL(cleaned.imagePath, window.location.origin);
									u.searchParams.delete("token");
									cleaned.imagePath = u.pathname + u.search;
								} catch {
									/* keep as is */
								}
							}
							delete cleaned.image;
							return cleaned;
						});
						fixedPage.data.canvasImages = fixedPage.canvasImages || [];
						fixedPage.data.canvasTexts = fixedPage.canvasTexts || [];

						// Limpiar tokens de dias/extras antes de guardar
						const stripTokenArr2 = (arr) => {
							if (!Array.isArray(arr)) return arr;
							return arr.map((item) => {
								if (
									!item?.image ||
									typeof item.image !== "string" ||
									item.image.startsWith("data:")
								)
									return item;
								try {
									const u = new URL(item.image, window.location.origin);
									u.searchParams.delete("token");
									return { ...item, image: u.pathname + u.search };
								} catch {
									return item;
								}
							});
						};
						if (fixedPage.data.dias)
							fixedPage.data.dias = stripTokenArr2(fixedPage.data.dias);
						if (fixedPage.data.extras)
							fixedPage.data.extras = stripTokenArr2(fixedPage.data.extras);

						// Usar el índice del array ordenado como order (ya actualizado arriba)
						// Esto asegura que el order coincida con la posición real en el array
						fixedPage.order = index;
						fixedPage.data.order = index;

						fixedPages[fixedIndex].push(fixedPage);
						// ?
						if (fixedPages[fixedIndex].length > 9) {
							fixedIndex += 1;
							fixedPages[fixedIndex] = [];
						}
						//await updatePage(selectedProject.id, fixedPage.id, fixedPage);
					}
				}
			}
			console.log("UPDATED!!!");
			console.log(fixedPages);
			for (const auxFixedPage of fixedPages) {
				try {
					await updatePages(auxFixedPage);
					await new Promise((resolve) => setTimeout(() => resolve(true), 1000));
				} catch (error) {
					console.error("Error updating pages:", error);
				}
			}

			for (const auxImage of auxImages) {
				// TO CHANGE
				try {
					const { pageId, ...image } = auxImage;
					// Validar que image tenga un campo válido (src o image)
					if (!image.src && !image.image) {
						console.error("No image data found in auxImage:", auxImage);
						continue;
					}
					const imageData = image.src || image.image;
					await createImage(imageData, selectedProject.id);
				} catch (error) {
					console.error("Error creating image:", error);
				}
			}

			// Actualizar initialPages con el estado actual antes de recargar
			// Esto asegura que si hay un error, al menos tenemos el estado guardado
			setInitialPages(_.cloneDeep(pages));

			// Recargar las páginas desde el backend para sincronizar el estado (opcional, en background)
			// Hacerlo de forma asíncrona sin bloquear el guardado
			setTimeout(async () => {
				try {
					console.log("Recargando páginas desde el backend...");
					const reloadedPages = await readPages(selectedProject.id);
					console.log("Páginas recargadas:", reloadedPages);

					// Obtener todas las imágenes del proyecto una sola vez
					let projectImages = [];
					try {
						projectImages = await getImages(selectedProject.id);
					} catch (error) {
						console.error("Error loading project images:", error);
					}

					// Capturar src de las páginas actuales para usarlo como fallback
					const currentPagesById = {};
					for (const p of pages) {
						if (p && p.id != null) {
							currentPagesById[String(p.id)] = p;
						}
					}

					// Procesar las páginas recargadas de la misma manera que en getProject
					for (const userPage of reloadedPages) {
						const currentPage = currentPagesById[String(userPage.id)];
						let ind = 0;
						for (const s of userPage.images ?? []) {
							if (s && typeof s === "object" && s.id) {
								if (s.src) {
									if (!s.src.startsWith("data:")) {
										s.src = getAuthenticatedUrl(s.src);
									}
								} else {
									const found = projectImages.find(
										(i) => String(i.id) === String(s.id),
									);
									if (found && found.url) {
										s.src = found.url;
									} else {
										const fallbackSrc = currentPage?.images?.[ind]?.src;
										if (fallbackSrc) {
											s.src = fallbackSrc;
										}
									}
								}
							} else if (s === null || s === undefined) {
								userPage.images[ind] = null;
							} else {
								userPage.images[ind] = {
									id: -new Date().getTime() - ind,
									src: s,
								};
							}
							ind += 1;
						}
						if (userPage.data && userPage.images) {
							userPage.data.images = userPage.images;
						}

						// Autenticar URLs de imágenes en dias/extras (plan de viaje).
						// Resolver rutas relativas a API cuando el proyecto es de guía prebuilt.
						const prebuiltIdReload = selectedProject?.prebuiltGuideId;
						const resolveDiaExtraUrlReload = (url) => {
							if (!url || typeof url !== "string" || url.startsWith("data:"))
								return url;
							if (
								prebuiltIdReload &&
								(url.startsWith("/images") ||
									(url.startsWith("/") && !url.startsWith("http")))
							) {
								const p = url.startsWith("/") ? url.slice(1) : url;
								url = `${getApiOrigin()}/api/prebuilt-guides/${prebuiltIdReload}/assets/${p}`;
							}
							return getAuthenticatedUrl(url);
						};
						const authImgArr = (arr) => {
							if (!Array.isArray(arr)) return;
							for (const item of arr) {
								if (item?.image && typeof item.image === "string") {
									item.image = resolveDiaExtraUrlReload(item.image);
								}
							}
						};
						if (userPage.data) {
							authImgArr(userPage.data.dias);
							authImgArr(userPage.data.extras);
							if (userPage.data.data) {
								authImgArr(userPage.data.data.dias);
								authImgArr(userPage.data.data.extras);
							}
						}
						if (userPage.dias) authImgArr(userPage.dias);
						if (userPage.extras) authImgArr(userPage.extras);

						// Procesar canvasStickers: asignar image desde imagePath (no depender de stickers)
						userPage.canvasStickers = userPage.canvasStickers?.map((s) => {
							let migratedSticker = migrateStickerToPercent(s, 800, 1000);
							migratedSticker.image = new Image();
							migratedSticker.image.crossOrigin = "anonymous";
							if (migratedSticker.assetId) {
								migratedSticker.imagePath = getStickerAssetUrl(
									migratedSticker.assetId,
								);
								migratedSticker.image.src = migratedSticker.imagePath;
						} else if (migratedSticker.customStickerMeta) {
							const { countryId } = migratedSticker.customStickerMeta;
							const filename = migratedSticker.imagePath
								? migratedSticker.imagePath.split("/").pop().split("?")[0]
								: null;
							if (countryId && filename) {
								migratedSticker.imagePath = getCustomStickerAssetUrl(countryId, filename);
							}
							migratedSticker.image.src = migratedSticker.imagePath || "";
						} else if (migratedSticker.imagePath) {
							migratedSticker.image.src = migratedSticker.imagePath;
							} else {
								for (const originalStickers of stickers) {
									for (const originalSticker of originalStickers) {
										if (migratedSticker.id === originalSticker.id) {
											const path =
												originalSticker.imagePath || originalSticker.src;
											if (path) migratedSticker.image.src = path;
											break;
										}
									}
								}
							}
							return migratedSticker;
						});

						// Migrar canvasImages a porcentajes
						userPage.canvasImages =
							userPage.canvasImages?.map((img) => {
								return migrateStickerToPercent(img, 800, 1000);
							}) ?? [];
						for (const s of userPage.canvasImages ?? []) {
							s.image = new Image();
							s.image.crossOrigin = "anonymous";
							try {
								if (s.id != null && projectImages.length > 0) {
									const foundImage = projectImages.find(
										(img) => String(img.id) === String(s.id),
									);
									if (foundImage && foundImage.url) {
										s.imageUrl = foundImage.url;
									}
								}

								if (s.imageUrl) {
									s.image.src = s.imageUrl.startsWith("data:")
										? s.imageUrl
										: getAuthenticatedUrl(s.imageUrl);
								}
							} catch (error) {
								console.error("Error loading canvas image:", error, s.imageUrl);
								if (s.imageUrl) s.image.src = getAuthenticatedUrl(s.imageUrl);
							}
						}

						if (
							!userPage.maps ||
							(userPage.maps.every((m) => !m) &&
								userPage.data?.maps?.some((m) => m))
						) {
							userPage.maps = userPage.data?.maps || ["", "", ""];
						}
					}

					// Ordenar las páginas por order
					reloadedPages.sort((a, b) => {
						const orderA =
							a.data?.order !== undefined ? a.data.order : a.order || 0;
						const orderB =
							b.data?.order !== undefined ? b.data.order : b.order || 0;
						return orderA - orderB;
					});

					// Preservar páginas no guardadas (id negativo) que no se pudieron crear
					setPages((prevPages) => {
						const unsavedPages = prevPages.filter((p) => p.id < 0);
						const merged = [...reloadedPages, ...unsavedPages];
						return merged;
					});
					setInitialPages(_.cloneDeep(reloadedPages));

					// Actualizar currentPage si es necesario
					setPages((prevPages) => {
						if (currentPage >= prevPages.length) {
							setCurrentPage(prevPages.length - 1);
						}
						return prevPages;
					});
				} catch (error) {
					console.error("Error reloading pages:", error);
					// Si hay un error al recargar, no hacer nada, ya actualizamos initialPages antes
				}
			}, 100);

			await updateProject(
				selectedProject.id,
				selectedProject.name ?? "Nueva guía",
				backgroundColor,
				textColor,
				headerBackgroundColor,
				headerTextColor,
				fontFamily,
				false,
			);
		} catch (error) {
			console.error("Error saving pages:", error);
			// Asegurar que initialPages se actualice incluso si hay un error
			setInitialPages(_.cloneDeep(pages));
		} finally {
			// Siempre desactivar el loading, incluso si hay un error
			setShowSaveLoading(false);
		}
		/*setPages(async (prev) => {
			console.log(prev);
			const id = prev[index].id;
			prev[index] = {
				...pages[currentPage],
				/*templateId: templates[currentTemplateIndex].id,
				images: images,
				texts: texts,
				/*canvasStickers: stickers.map((sticker, index) => ({
					...stickersRef[index].attrs,
					stickerId: sticker.id,
				})),
				canvasImages: [
					{
						stickerId: 1,
						x: 1,
						y: 1,
						width: 1,
						height: 1,
						rotation: 0,
						scaleX: 1,
						scaleY: 1,
						skewX: 0,
						skewY: 0,
					},
				],
				canvasTexts: [
					{
						stickerId: 1,
						x: 1,
						y: 1,
						width: 1,
						height: 1,
						rotation: 0,
						scaleX: 1,
						scaleY: 1,
						skewX: 0,
						skewY: 0,
					}
				],
			};
			
			
			prev[index].id = id;
			return [...prev];
		});*/
	};

	const saveProjectToDB = () => {
		// save project to DB
	};

	const getProject = async (userId, projectId, skipPageCreation) => {
		try {
			let project = await readProject(userId, projectId);
			if (!project || !project.id) {
				console.error("getProject: proyecto no encontrado o sin id", {
					userId,
					projectId,
				});
				setFinishedLoading(true);
				return;
			}
			trackEditorAction("guide_loaded", project.id, {
				guide_name: project.name,
				prebuilt_guide_id: project.prebuiltGuideId || undefined,
			});
			let currentProject = 0;
			let userProjects = [project];
			let userPages = await readPages(project.id);
			console.log(userPages);
			if (userPages.length === 0) {
				for (let retry = 0; retry < 5 && userPages.length === 0; retry++) {
					await new Promise((r) => setTimeout(r, 600));
					userPages = await readPages(project.id);
				}
			}
			if (userPages.length === 0 && !skipPageCreation) {
				console.log("CREATING DEFAULT PAGE for empty project");
				const emptyTexts = defaultPage.texts.map((t) => ({
					...t,
					content: "",
				}));
				await createPage(project.id, {
					templateId: templates[currentTemplateIndex]?.id ?? 1,
					images: [null, null, null],
					texts: emptyTexts,
					maps: [...(defaultPage.maps || ["", "", ""])],
					transport: [],
				});
				userPages = await readPages(project.id);
			}
			// Obtener todas las imágenes del proyecto una sola vez (para canvasImages e images de página)
			let projectImages = [];
			try {
				projectImages = await getImages(project.id);
				console.log("getProject: projectImages loaded:", projectImages?.length);
			} catch (error) {
				console.error("getProject: error loading project images", error);
			}

			for (const userPage of userPages) {
				// Rellenar page.images[].src desde projectImages (pre-signed URLs de R2)
				if (
					userPage.images &&
					Array.isArray(userPage.images) &&
					projectImages.length > 0
				) {
					for (let i = 0; i < userPage.images.length; i++) {
						const img = userPage.images[i];
						if (img && typeof img === "object" && img.id != null && !img.src) {
							const found = projectImages.find(
								(p) => String(p.id) === String(img.id),
							);
							if (found && found.url) {
								userPage.images[i] = { ...img, src: found.url };
							}
						}
					}
				}
				// Autenticar URLs HTTP de imágenes (prebuilt guide assets)
				if (userPage.images && Array.isArray(userPage.images)) {
					for (let i = 0; i < userPage.images.length; i++) {
						const img = userPage.images[i];
						if (
							img &&
							typeof img === "object" &&
							img.src &&
							!img.src.startsWith("data:")
						) {
							userPage.images[i] = {
								...img,
								src: getAuthenticatedUrl(img.src),
							};
						}
					}
				}
				// Sincronizar data.images por si algo lee page.data.images
				if (userPage.data && userPage.images) {
					userPage.data.images = userPage.images;
				}
				// Autenticar URLs de imágenes en dias/extras (plan de viaje).
				// Si el proyecto viene de una guía prebuilt, las rutas relativas (/images/...)
				// deben resolverse a la URL del API antes de añadir el token.
				const prebuiltId = project.prebuiltGuideId;
				const resolveDiaExtraUrl = (url) => {
					if (!url || typeof url !== "string" || url.startsWith("data:"))
						return url;
					if (
						prebuiltId &&
						(url.startsWith("/images") ||
							(url.startsWith("/") && !url.startsWith("http")))
					) {
						const p = url.startsWith("/") ? url.slice(1) : url;
						url = `${getApiOrigin()}/api/prebuilt-guides/${prebuiltId}/assets/${p}`;
					}
					return getAuthenticatedUrl(url);
				};
				const authImageArray = (arr) => {
					if (!Array.isArray(arr)) return;
					for (const item of arr) {
						if (item?.image && typeof item.image === "string") {
							item.image = resolveDiaExtraUrl(item.image);
						}
					}
				};
				if (userPage.data) {
					authImageArray(userPage.data.dias);
					authImageArray(userPage.data.extras);
					// Por si vienen anidados en data.data (Template 129 / plan de viaje)
					if (userPage.data.data) {
						authImageArray(userPage.data.data.dias);
						authImageArray(userPage.data.data.extras);
					}
				}
				if (userPage.dias) authImageArray(userPage.dias);
				if (userPage.extras) authImageArray(userPage.extras);
				// Migrar canvasStickers a porcentajes y asignar image desde imagePath
				// (no depender de stickers ya cargados: al venir del dashboard stickers puede estar vacío)
				userPage.canvasStickers = userPage.canvasStickers?.map((s) => {
					let migratedSticker = migrateStickerToPercent(s, 800, 1000);
					migratedSticker.image = new Image();
					migratedSticker.image.crossOrigin = "anonymous";
					if (migratedSticker.imagePath) {
						migratedSticker.image.src = migratedSticker.imagePath;
					} else {
						// Fallback: buscar en el catálogo de stickers si ya está cargado
						for (const originalStickers of stickers) {
							for (const originalSticker of originalStickers) {
								if (migratedSticker.id === originalSticker.id) {
									const path = originalSticker.imagePath || originalSticker.src;
									if (path) migratedSticker.image.src = path;
									break;
								}
							}
						}
					}
					return migratedSticker;
				});
				// Migrar canvasImages a porcentajes
				userPage.canvasImages =
					userPage.canvasImages?.map((img) => {
						return migrateStickerToPercent(img, 800, 1000);
					}) ?? [];
				// Asignar imageUrl desde projectImages (siempre intentar si tiene id)
				for (const s of userPage.canvasImages ?? []) {
					s.image = new Image();
					try {
						// Siempre intentar obtener la imagen de projectImages si tiene id
						// (imageUrl puede no guardarse en la página, solo el id de la imagen)
						if (s.id != null && projectImages.length > 0) {
							const foundImage = projectImages.find(
								(img) => String(img.id) === String(s.id),
							);
							if (foundImage && foundImage.image) {
								let data = foundImage.image;
								// Asegurar formato data URL para que el navegador la cargue
								if (typeof data === "string" && !data.startsWith("data:")) {
									data = data.startsWith("base64,")
										? "data:image/jpeg;base64," + data.slice(7)
										: "data:image/jpeg;base64," + data;
								}
								s.imageUrl = data;
							}
						}

						// Autenticar URLs HTTP de canvasImages (prebuilt guide assets, uploads)
						if (s.imageUrl && !s.imageUrl.startsWith("data:")) {
							s.imageUrl = getAuthenticatedUrl(s.imageUrl);
						}

						// Si la imagen es una data URL o una ruta local, cargarla directamente
						if (
							s.imageUrl &&
							(s.imageUrl.startsWith("data:") ||
								s.imageUrl.startsWith("/") ||
								s.imageUrl.startsWith("./"))
						) {
							// Cargar la imagen de forma asíncrona y esperar a que esté lista
							await new Promise((resolve, reject) => {
								s.image.onload = () => {
									// Verificar que la imagen esté completamente cargada
									if (
										s.image.complete &&
										s.image.naturalWidth > 0 &&
										s.image.naturalHeight > 0
									) {
										resolve();
									} else {
										reject(new Error("Image is in broken state"));
									}
								};
								s.image.onerror = (e) => {
									console.error("Error loading canvas image:", s.imageUrl, e);
									reject(e);
								};
								s.image.src = s.imageUrl;
							});
						} else if (s.imageUrl) {
							try {
								s.image.src = await getBase64ImageFromUrl(s.imageUrl);
								// Esperar a que la imagen se cargue
								await new Promise((resolve, reject) => {
									s.image.onload = () => {
										if (
											s.image.complete &&
											s.image.naturalWidth > 0 &&
											s.image.naturalHeight > 0
										) {
											resolve();
										} else {
											reject(new Error("Image is in broken state"));
										}
									};
									s.image.onerror = reject;
								});
							} catch (error) {
								console.error(
									"Error converting image to base64:",
									error,
									s.imageUrl,
								);
								// Si falla la conversión, intentar cargar directamente
								if (s.imageUrl) {
									s.image.src = s.imageUrl;
								}
							}
						}
					} catch (error) {
						console.error("Error loading canvas image:", error, s.imageUrl);
						// Si falla, intentar cargar directamente pero sin esperar
						if (s.imageUrl) {
							s.image.src = s.imageUrl;
						}
					}
				}
				if (
					!userPage.maps ||
					(userPage.maps.every((m) => !m) &&
						userPage.data?.maps?.some((m) => m))
				) {
					userPage.maps = userPage.data?.maps || ["", "", ""];
				}
				// Sincronizar data.canvasImages con el array ya rellenado (imageUrl), por si algo lee page.data.canvasImages
				if (userPage.data) {
					userPage.data.canvasImages = userPage.canvasImages ?? [];
				}
			}
			setProjects([project]);
			setPages(userPages);
			// Usar siempre el backgroundColor del proyecto, no el estado previo del componente
			const projectBgColor = userProjects[currentProject].backgroundColor;
			const proj = userProjects[currentProject];
			const isKiotoGuide =
				proj?.prebuiltGuideId === "kioto" ||
				/kioto|kyoto/i.test(proj?.name ?? "");
			const defaultBg = isKiotoGuide ? "#f7f7f7" : "#d2ebf0"; // guia-kioto usa #f7f7f7
			setBackgroundColor(
				projectBgColor && projectBgColor.trim() !== ""
					? projectBgColor
					: defaultBg,
			);
			const projectTextColor = userProjects[currentProject].textColor;
			setTextColor(
				projectTextColor && projectTextColor.trim() !== ""
					? projectTextColor
					: "#000000",
			);
			const projectHeaderBgColor =
				userProjects[currentProject].headerBackgroundColor;
			setHeaderBackgroundColor(
				projectHeaderBgColor && projectHeaderBgColor.trim() !== ""
					? projectHeaderBgColor
					: "#24221a",
			);
			const projectHeaderTextColor =
				userProjects[currentProject].headerTextColor;
			setHeaderTextColor(
				projectHeaderTextColor && projectHeaderTextColor.trim() !== ""
					? projectHeaderTextColor
					: "#FFFFFF",
			);
			const projectFontFamily = userProjects[currentProject].fontFamily;
			setFontFamily(
				projectFontFamily && projectFontFamily.trim() !== ""
					? projectFontFamily
					: "Poppins",
			);
			setInitialPages(_.cloneDeep(userPages));
			setSelectedProject(userProjects[currentProject]);
			setFinishedLoading(true);
			setCurrentTemplateIndex(userPages[currentProject]?.templateId ?? 0);
		} catch (error) {
			console.error("getProject error:", error);
			setFinishedLoading(true);
		}
	};

	const getProjects = async (force = false, newProject = false) => {
		if (user) {
			setFinishedLoading(false);
			console.log("READING PROJECTS");
			const userProjects = await readProjects();
			console.log("READING PROJECTS 2", userProjects);
			let { id, ...auxDefaultPage } = defaultPage;
			let { id: auxId, ...auxFirstPage } = pages.length > 0 ? pages[0] : {};
			let projectInProgress = justInitSession;
			/*pages.length > 0 &&
				auxFirstPage &&
				(JSON.stringify(auxDefaultPage) !== JSON.stringify(auxFirstPage) ||
					pages.length > 1);*/

			console.log("SHOULD CREATE?");
			console.log(userProjects.length);
			console.log(projectInProgress);

			if (
				userProjects.length < 2 &&
				(userProjects.length === 0 || projectInProgress) &&
				!force
			) {
				setJustInitSession(false);
				console.log("CREATING PROJECTS");

				const docRef = await createProject();

				console.log(pages);
				if (projectInProgress) {
					console.log("SAVING PAGES");
					await savePages(docRef);
				} else {
					console.log("CREATING DEFAULT PAGE");
					// Guía nueva: textos en blanco (sin "Título de la página" ni otro contenido predefinido)
					const emptyTexts = defaultPage.texts.map((t) => ({
						...t,
						content: "",
					}));
					await createPage(docRef.id, {
						templateId: templates[currentTemplateIndex].id,
						images: [...defaultPage.images],
						texts: emptyTexts,
						maps: [...defaultPage.maps],
						transport: [],
					});
				}
				getProjects(true, projectInProgress);
			} else {
				setJustInitSession(false);
				let currentProject = newProject
					? userProjects.length - 1
					: await getCurrentProject();
				console.log(currentProject);
				if (currentProject > userProjects.length - 1) {
					currentProject = 0;
					await setCurrentProject(0);
				}
				console.log(currentProject);
				console.log(userProjects);
				let userPages = await readPages(userProjects[currentProject].id);
				console.log("PAGES!!!");
				console.log(userPages.slice());
				if (userPages.length === 0) {
					await new Promise((r) => setTimeout(r, 800));
					userPages = await readPages(userProjects[currentProject].id);
				}
				if (userPages.length === 0) {
					console.log("CREATING DEFAULT PAGE 2");
					const emptyTexts = defaultPage.texts.map((t) => ({
						...t,
						content: "",
					}));
					await createPage(userProjects[currentProject].id, {
						templateId: templates[currentTemplateIndex].id,
						images: [...defaultPage.images],
						texts: emptyTexts,
						maps: [...defaultPage.maps],
						transport: [],
					});
				}
				userPages = await readPages(userProjects[currentProject].id);
				console.log(userPages.slice());
				let userPageIndex = 0;
				const auxImages = await getImages(userProjects[currentProject].id);
				for (const userPage of userPages) {
					for (const s of userPage.canvasStickers ?? []) {
						for (const originalStickers of stickers) {
							for (const originalSticker of originalStickers) {
								if (s.id === originalSticker.id) {
									await new Promise((resolve) => {
										if (userPageIndex > 0) {
											s.image = new Image();
											s.image.src =
												!window.location.href.includes("localhost") &&
												!s.imagePath.includes("wp-content")
													? "https://www.viajesmolones.com/wp-content/themes/miss-sunshine/react-app" +
														(s.imagePath.charAt(0) === "/" ? "" : "/") +
														s.imagePath
													: s.imagePath;
											resolve();
										} else {
											s.image = new Image();
											console.log(s.imagePath);
											s.image.onload = () => {
												resolve();
											};
											s.image.onerror = () => {
												resolve();
											};
											s.image.src =
												!window.location.href.includes("localhost") &&
												!s.imagePath.includes("wp-content")
													? "https://www.viajesmolones.com/wp-content/themes/miss-sunshine/react-app" +
														(s.imagePath.charAt(0) === "/" ? "" : "/") +
														s.imagePath
													: s.imagePath;
										}
									});
								}
							}
						}
					}

					for (const s of userPage.canvasImages ?? []) {
						s.image = new Image();
						const found = auxImages.find((i) => i.id === s.id);
						s.imageUrl = found?.url || s.imageUrl;
						s.image.src = s.imageUrl;
					}
					let ind = 0;
					for (const s of userPage.images ?? []) {
						if (s && typeof s === "object" && s.id) {
							const found = auxImages.find((i) => i.id === s.id);
							s.src = found?.url || null;
							if (!s.src) {
								userPage.images[ind] = null;
							}
						} else if (s === null || s === undefined) {
							userPage.images[ind] = null;
						} else {
							userPage.images[ind] = {
								id: -new Date().getTime(),
								src: s,
							};
						}
						ind += 1;
					}
					if (
						!userPage.maps ||
						(userPage.maps.every((m) => !m) &&
							userPage.data?.maps?.some((m) => m))
					) {
						userPage.maps = userPage.data?.maps || ["", "", ""];
					}
					//return userPage;
					userPageIndex++;
				}
				setProjects(userProjects);
				setPages(userPages);
				const proj = userProjects[currentProject];
				const isKiotoGuide =
					proj?.prebuiltGuideId === "kioto" ||
					/kioto|kyoto/i.test(proj?.name ?? "");
				const defaultBg = isKiotoGuide ? "#f7f7f7" : "#d2ebf0";
				setBackgroundColor(
					userProjects[currentProject].backgroundColor ?? defaultBg,
				);
				setTextColor(userProjects[currentProject].textColor ?? textColor);
				setHeaderBackgroundColor(
					userProjects[currentProject].headerBackgroundColor ??
						headerBackgroundColor,
				);
				setHeaderTextColor(
					userProjects[currentProject].headerTextColor ?? headerTextColor,
				);
				setFontFamily(userProjects[currentProject].fontFamily ?? fontFamily);
				console.log(userPages.slice());
				setInitialPages(_.cloneDeep(userPages));
				setSelectedProject(userProjects[currentProject]);
				setFinishedLoading(true);
				console.log("FINISHED");
				setCurrentTemplateIndex(userPages[0].templateId ?? 0);
				setCurrentPage(0);
				//setImages(userPages[0].images);
				//setTexts(userPages[0].texts);
			}
		} else {
			setFinishedLoading(true);
		}
	};

	const { userId: pathUserId, projectId: pathProjectId } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const pageAlreadyCreated = location.state?.pageCreated === true;
	const isCreateRoute = location.pathname === "/crear-guia";

	const loadDemoBlankGuide = () => {
		const demoPage = {
			id: `demo-page-${Date.now()}`,
			templateId: 1,
			order: 0,
			images: [null, null, null],
			texts: defaultPage.texts.map((t) => ({
				...t,
				content: "",
			})),
			maps: ["", "", ""],
			transport: [],
			notes: [],
			canvasStickers: [],
			canvasImages: [],
			canvasTexts: [],
		};
		setSelectedProject({
			id: "demo-new-guide",
			name: "Nueva guía",
			isDemo: true,
		});
		setPages([demoPage]);
		setInitialPages(_.cloneDeep([demoPage]));
		setCurrentPage(0);
		setCurrentTemplateIndex(1);
		setBackgroundColor("rgb(252, 252, 252)");
		setTextColor("#000000");
		setHeaderBackgroundColor("#6366F1");
		setHeaderTextColor("#FFFFFF");
		setFontFamily("Montserrat");
		setFinishedLoading(true);
	};

	useEffect(() => {
		if (!initialLoading) {
			if (isCreateRoute) {
				if (!user) {
					loadDemoBlankGuide();
					return;
				}
				if (creatingGuideRef.current) return;
				creatingGuideRef.current = true;
				(async () => {
					try {
						const docRef = await createProject("Nueva guía");
						if (!docRef) throw new Error("No se pudo crear la guía");
						const emptyTexts = defaultPage.texts.map((t) => ({
							...t,
							content: "",
						}));
						await createPage(docRef.id, {
							templateId: 1,
							images: [null, null, null],
							texts: emptyTexts,
							maps: [...(defaultPage.maps || ["", "", ""])],
							transport: [],
						});
						const userId = docRef.userId ?? user?.id ?? user?.uid;
						navigate(`/usuarios/${userId}/guias/${docRef.id}`, {
							replace: true,
							state: { pageCreated: true },
						});
					} catch (err) {
						creatingGuideRef.current = false;
						enqueueSnackbar(err.message || "Error al crear la guía", {
							variant: "error",
						});
						navigate("/", { replace: true });
					}
				})();
				return;
			}

			// Preferir path /usuarios/:userId/guias/:projectId; si no, usar ?ref=userId*projectId
			let userId = pathUserId;
			let projectId = pathProjectId;
			if (!userId || !projectId) {
				const queryParams = new URLSearchParams(window.location.search);
				const refParam = queryParams.get("ref");
				if (refParam && typeof refParam === "string") {
					const parts = refParam.split("*");
					if (parts.length >= 2) {
						userId = parts[0];
						projectId = parts[1];
						// Redirigir a URL limpia para enlaces legacy
						navigate(`/usuarios/${userId}/guias/${projectId}`, {
							replace: true,
						});
					}
				}
			}
			const refKey = userId && projectId ? `${userId}*${projectId}` : null;
			if (refKey) {
				if (lastLoadedRefParamRef.current === refKey) {
					return;
				}
				lastLoadedRefParamRef.current = refKey;
				getProject(userId, projectId, pageAlreadyCreated);
				return;
			}
			lastLoadedRefParamRef.current = null;
			getProjects();
		}
	}, [initialLoading, user, stickers, pathUserId, pathProjectId, navigate, isCreateRoute]);

	// Al desmontar (p. ej. al volver al dashboard), resetear para que al reabrir se vuelva a cargar
	useEffect(() => {
		return () => {
			lastLoadedRefParamRef.current = null;
			creatingGuideRef.current = false;
		};
	}, []);
	/* End of Data Structures and save */

	const [page, setPage] = useState(1);
	const itemsPerPage = 5;

	const [currentTemplateIndex, setCurrentTemplateIndex] = useState(0);

	const [isDrawerOpen, setIsDrawerOpen] = useState(false);

	const [showLogin, setShowLogin] = useState(false);

	const size = useWindowSize();
	// Detectar Safari
	const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	// Safari 26+ (iOS 26 / 2025): diseño compacto, barra de URL ocupa menos espacio
	const safariVersionMatch = navigator.userAgent.match(/Version\/(\d+)/);
	const newSafari =
		isSafari && safariVersionMatch && parseInt(safariVersionMatch[1], 10) >= 26;

	const smallScreen = size.width < 1200;
	// Detectar móvil: user agent (dispositivo real) o pantalla pequeña (responsive)
	const isMobile =
		/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			navigator.userAgent,
		); /*||
		size.width < 768*/

	useEffect(() => {
		if (mainCanvasRef.current) {
			let scale = 1;

			if (smallScreen) {
				scale = Math.min(
					size.width / mainCanvasRef.current.offsetWidth,
					size.height / mainCanvasRef.current.offsetHeight,
				);
				const w = Math.min((848.57 + 88) * (21 / 29.7), size.width - 16);
				const h = Math.min(848.57 + 88, size.height - 16);

				const factoredH = w * (29.7 / 21);
				setHeight(h < w || factoredH > h ? h : factoredH);
				setWidth(w < h ? w : w * (21 / 29.7)); // change it

				setMainCanvasScale(Math.min(1, scale));
			} else {
				scale = Math.min(
					size.width / mainCanvasRef.current.offsetWidth,
					size.height / mainCanvasRef.current.offsetHeight,
				);
				const w = Math.min((848.57 + 88) * (21 / 29.7), size.width - 24);
				const h = Math.min(848.57 + 88, size.height - 24);

				const factoredH = w * (29.7 / 21);
				setHeight(h < w || factoredH > h ? h : factoredH);
				setWidth(w < h ? w : w * (21 / 29.7)); // change it

				setMainCanvasScale(Math.min(1, scale));
			}
		}
	}, [size, mainCanvasRef]);

	const handleDrawerOpen = () => {
		setIsDrawerOpen(true);
	};

	const handleDrawerClose = () => {
		setIsDrawerOpen(false);
	};
	const updateCurrentPage = (updatedPage) => {
		setPages((prevPages) => {
			return prevPages.map((auxPage, pageIndex) => {
				if (pageIndex === currentPage) {
					const updatedImages = [
						...(updatedPage.images || auxPage.images || []),
					];
					const updatedTexts = [...(updatedPage.texts || auxPage.texts || [])];
					const updatedStickers = [
						...(updatedPage.canvasStickers || auxPage.canvasStickers || []),
					];
					const updatedCanvasImages = [
						...(updatedPage.canvasImages || auxPage.canvasImages || []),
					];
					const updatedCanvasTexts = [
						...(updatedPage.canvasTexts || auxPage.canvasTexts || []),
					];
					const updatedTransport = [
						...(updatedPage.transport || auxPage.transport || []),
					];
					const updatedNotes = updatedPage.notes || auxPage.notes || [];
					const updatedMaps = [...(updatedPage.maps || auxPage.maps || [])];

					const mergedFields = {
						images: updatedImages,
						texts: updatedTexts,
						canvasStickers: updatedStickers,
						canvasImages: updatedCanvasImages,
						canvasTexts: updatedCanvasTexts,
						transport: updatedTransport,
						notes: updatedNotes,
						maps: updatedMaps,
					};

					const result = {
						...auxPage,
						...updatedPage,
						...mergedFields,
					};

					if (auxPage.data) {
						result.data = {
							...auxPage.data,
							...mergedFields,
						};
					}

					return result;
				} else {
					return { ...auxPage };
				}
			});
		});
	};
	const handleTemplateClick = (index) => {
		updateCurrentPage({ templateId: index });
		setCurrentTemplateIndex(index);
		trackEditorAction("template_selected", selectedProject?.id, {
			template_id: index,
			page_index: currentPage,
		});
	};

	// Añadir página respetando límite del plan; si ya está al límite, muestra la modal y no añade. Retorna true si añadió, false si mostró modal.
	const tryAddPage = useCallback(() => {
		if (pagesLengthRef.current >= maxPagesAllowed) {
			setShowPageLimitModal(true);
			trackEditorAction("page_limit_reached", selectedProjectRef.current?.id, {
				max_pages: maxPagesAllowed,
			});
			return false;
		}
		trackEditorAction("page_added", selectedProjectRef.current?.id, {
			page_count: pagesLengthRef.current + 1,
		});
		setPages((prev) => {
			if (prev.length >= maxPagesAllowed) return prev;
			const maxOrder = prev.reduce((max, page) => {
				const pageOrder =
					page.data?.order !== undefined ? page.data.order : (page.order ?? -1);
				return Math.max(max, pageOrder);
			}, -1);
			const newPage = {
				id: -1 * new Date().getTime(),
				templateId: 0,
				order: maxOrder + 1,
				images: [null, null, null, null, null],
				texts: [
					{ content: "Título de la página", isEditing: false },
					{ content: "", isEditing: false },
					{ content: "", isEditing: false },
					{ content: "", isEditing: false },
				],
				canvasStickers: [],
				canvasTexts: [],
				canvasImages: [],
				maps: ["", "", ""],
				transport: [],
				notes: [],
			};
			const newPageIndex = prev.length;
			setCurrentPage(newPageIndex);
			setCurrentTemplateIndex(0);
			return [...prev, newPage];
		});
		return true;
	}, [maxPagesAllowed]);

	// Actualizar dimensiones del canvas basadas en templates-container
	useEffect(() => {
		const updateCanvasDimensions = () => {
			const templatesContainer = document.getElementById("templates-container");
			if (!templatesContainer) return;

			// Usar siempre el primer hijo (contenido de la template) para que el Stage coincida exactamente con el contenido
			// y las coordenadas de drop coincidan con lo que ve el usuario (centro de imagen = centro del Stage)
			const targetElement =
				templatesContainer.firstElementChild || templatesContainer;

			if (targetElement) {
				const width = targetElement.offsetWidth;
				const height = targetElement.offsetHeight;
				if (width > 0 && height > 0) {
					setCanvasDimensions({ width, height });

					setTimeout(() => {
						const konvajsContent =
							templatesContainer.querySelector(".konvajs-content");
						if (konvajsContent) {
							konvajsContent.style.width = `${width}px`;
							konvajsContent.style.height = `${height}px`;
						}
					}, 0);
				}
			}

			// PASO 0: Medir rects de bloques en coordenadas del STAGE (0..canvasWidth, 0..canvasHeight)
			// Así hitTestBlock y getStickerPositionFromAnchor usan el mismo sistema que Konva (x,y del drop).
			const updateBlockRects = () => {
				const container = document.getElementById("templates-container");
				if (!container) return;
				const target = container.firstElementChild || container;
				if (!target) return;
				const stageW = target.offsetWidth;
				const stageH = target.offsetHeight;
				if (stageW <= 0 || stageH <= 0) return;
				const blocks = target.querySelectorAll("[data-block-id]");
				const targetRect = target.getBoundingClientRect();
				const next = {};
				blocks.forEach((el) => {
					const id = el.getAttribute("data-block-id");
					if (!id) return;
					const r = el.getBoundingClientRect();
					// Convertir DOM (getBoundingClientRect) → Stage: mismo rango que canvasDimensions
					const left = ((r.left - targetRect.left) / targetRect.width) * stageW;
					const top = ((r.top - targetRect.top) / targetRect.height) * stageH;
					const width = (r.width / targetRect.width) * stageW;
					const height = (r.height / targetRect.height) * stageH;
					next[id] = { left, top, width, height };
				});
				console.log(
					"[PASO 0 - updateBlockRects] Stage size (mismo que canvasDimensions):",
					{ stageW, stageH },
					"blockRects (en coords Stage):",
					next,
				);
				setBlockRects((prev) => {
					const same =
						Object.keys(prev).length === Object.keys(next).length &&
						Object.keys(next).every(
							(k) =>
								prev[k] &&
								prev[k].left === next[k].left &&
								prev[k].top === next[k].top &&
								prev[k].width === next[k].width &&
								prev[k].height === next[k].height,
						);
					return same ? prev : next;
				});
			};
			updateBlockRects();
		};

		updateCanvasDimensions();

		let cancelled = false;
		const rafIds = [];
		const timeoutIds = [];

		const pollUntilReady = (attemptsLeft) => {
			if (cancelled) return;
			const container = document.getElementById("templates-container");
			const target = container?.firstElementChild || container;
			if (target && target.offsetWidth > 0 && target.offsetHeight > 0) {
				updateCanvasDimensions();
			} else if (attemptsLeft > 0) {
				rafIds.push(
					requestAnimationFrame(() => pollUntilReady(attemptsLeft - 1)),
				);
			}
		};

		rafIds.push(requestAnimationFrame(() => pollUntilReady(10)));

		timeoutIds.push(
			setTimeout(() => {
				if (!cancelled) updateCanvasDimensions();
			}, 200),
		);
		timeoutIds.push(
			setTimeout(() => {
				if (!cancelled) updateCanvasDimensions();
			}, 500),
		);
		timeoutIds.push(
			setTimeout(() => {
				if (!cancelled) updateCanvasDimensions();
			}, 1000),
		);

		const templatesContainer = document.getElementById("templates-container");
		let resizeObserver = null;

		if (templatesContainer) {
			const setupObserver = () => {
				const targetElement =
					templatesContainer.firstElementChild || templatesContainer;

				if (targetElement && resizeObserver) {
					resizeObserver.disconnect();
				}

				if (targetElement) {
					resizeObserver = new ResizeObserver(() => {
						updateCanvasDimensions();
					});
					resizeObserver.observe(targetElement);
				}
			};

			setupObserver();

			if (smallScreen) {
				const mutationObserver = new MutationObserver(() => {
					setupObserver();
					updateCanvasDimensions();
				});
				mutationObserver.observe(templatesContainer, {
					childList: true,
					subtree: false,
				});

				return () => {
					cancelled = true;
					rafIds.forEach(cancelAnimationFrame);
					timeoutIds.forEach(clearTimeout);
					if (resizeObserver) {
						resizeObserver.disconnect();
					}
					mutationObserver.disconnect();
				};
			}

			return () => {
				cancelled = true;
				rafIds.forEach(cancelAnimationFrame);
				timeoutIds.forEach(clearTimeout);
				if (resizeObserver) {
					resizeObserver.disconnect();
				}
			};
		}

		return () => {
			cancelled = true;
			rafIds.forEach(cancelAnimationFrame);
			timeoutIds.forEach(clearTimeout);
		};
	}, [currentPage, pages, smallScreen]);

	// Actualizar stageScale cuando el canvas cambie de tamaño (para handlers y botones de tamaño fijo en pantalla)
	useEffect(() => {
		const updateStageScale = () => {
			const canvas = document.querySelector(".konvajs-content > canvas");
			if (!canvas || !canvasDimensions.width || !canvasDimensions.height) {
				setStageScale(1);
				return;
			}
			const rect = canvas.getBoundingClientRect();
			const scaleX = rect.width / canvasDimensions.width;
			const scaleY = rect.height / canvasDimensions.height;
			const scale = Math.min(scaleX, scaleY) || 1;
			setStageScale(scale);
		};

		updateStageScale();
		const canvas = document.querySelector(".konvajs-content > canvas");
		if (!canvas) return;
		const ro = new ResizeObserver(updateStageScale);
		ro.observe(canvas);
		return () => ro.disconnect();
	}, [canvasDimensions.width, canvasDimensions.height, currentPage]);

	// Base URL para imágenes en plantillas (Template71, etc.) cuando el proyecto es guía prebuilt
	const editorImageBaseUrl = useMemo(() => {
		const prebuiltGuideId = selectedProject?.prebuiltGuideId;
		if (!prebuiltGuideId) return null;
		const prebuiltAssetsFolder =
			prebuiltGuideId === "tokio" || prebuiltGuideId === "kioto"
				? "japon"
				: prebuiltGuideId === "seul"
					? "seul"
					: prebuiltGuideId === "ny"
						? "ny"
						: prebuiltGuideId === "londres"
							? "londres"
							: prebuiltGuideId === "paris"
								? "paris"
								: prebuiltGuideId === "bangkok"
									? "bangkok"
									: prebuiltGuideId === "osaka"
										? "japon"
										: "ny";
		return `${getApiOrigin()}/api/prebuilt-guides/${prebuiltGuideId}/assets/images/${prebuiltAssetsFolder}/`;
	}, [selectedProject?.prebuiltGuideId]);

	// Resolver perezosamente un pack que desbloquea páginas extra para la
	// guía prebuilt del proyecto actual (ej. Pack Japón para prebuiltGuideId=japon).
	// Sólo se lanza cuando el usuario abre el modal de límite alcanzado,
	// y si ya tiene acceso al pack (Pro incluido o comprado) no lo proponemos.
	useEffect(() => {
		if (!showPageLimitModal) return;
		const prebuiltGuideId = selectedProject?.prebuiltGuideId;
		if (!prebuiltGuideId || !getPacks) return;
		let cancelled = false;
		(async () => {
			try {
				const packs = await getPacks();
				if (cancelled) return;
				const match = (packs || []).find((p) => {
					const extras = p?.entitlements?.extraPagesPerGuide || {};
					return (
						Object.keys(extras).includes(prebuiltGuideId) &&
						Number(extras[prebuiltGuideId]) > 0
					);
				});
				// Si ya lo tiene o está incluido en Pro no hay nada que ofrecer.
				if (match && (match.hasAccess || match.isUnlockedByPro)) {
					setUpgradePack(null);
					return;
				}
				setUpgradePack(match || null);
			} catch {
				if (!cancelled) setUpgradePack(null);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [showPageLimitModal, selectedProject?.prebuiltGuideId, getPacks]);

	// Ocultar el overlay cuando se muestra cualquier modal
	useEffect(() => {
		if (
			showLogin ||
			showProjects ||
			showExport ||
			isModalOpen ||
			isNoteModalOpen
		) {
			// Ocultar el overlay y cerrar cualquier tab abierto
			if (selectedTab) {
				setSelectedTab(null);
			}
		}
	}, [
		showLogin,
		showProjects,
		showExport,
		isModalOpen,
		isNoteModalOpen,
		selectedTab,
	]);

	// Al cambiar tamaño de pantalla o primera carga: recalcular x,y de stickers y textos desde su anclaje.
	// Así se adaptan automáticamente a cualquier tamaño de canvas.
	useEffect(() => {
		const cw = canvasDimensions.width;
		const ch = canvasDimensions.height;
		const prev = previousCanvasDimensionsRef.current;
		previousCanvasDimensionsRef.current = { width: cw, height: ch };

		// Saltar si el canvas aún no tiene dimensiones válidas
		if (cw <= 0 || ch <= 0) return;
		// Saltar si las dimensiones no cambiaron (y no es primera carga)
		if (prev != null && prev.width === cw && prev.height === ch) return;

		const page = pages[currentPage];
		if (!page) return;

		const cwGet = getCanvasWidth();
		const chGet = getCanvasHeight();
		let auxPage = { ...page };
		let hasChanges = false;

		// Recalcular posiciones de stickers usando tamaño escalado
		if (page.canvasStickers?.length) {
			const updatedStickers = page.canvasStickers.map((sticker) => {
				if (
					!(sticker.anchorType === "block" && sticker.anchorBlockId) &&
					sticker.anchorType !== "page"
				) {
					return sticker;
				}
				// Usar tamaño escalado manteniendo aspect ratio
				const stickerW =
					sticker.widthPercent != null && cwGet > 0
						? (sticker.widthPercent / 100) * cwGet
						: (sticker.width ?? 80);
				const stickerH =
					sticker.aspectRatio != null
						? stickerW * sticker.aspectRatio
						: (sticker.height ?? 80);
				const pos = getStickerPositionFromAnchor(
					sticker,
					stickerW,
					stickerH,
					blockRects,
					cwGet,
					chGet,
				);
				return { ...sticker, x: pos.x, y: pos.y };
			});
			auxPage.canvasStickers = updatedStickers;
			hasChanges = true;
		}

		// Recalcular posiciones de textos (misma lógica)
		if (page.canvasTexts?.length) {
			const updatedTexts = page.canvasTexts.map((text) => {
				if (
					!(text.anchorType === "block" && text.anchorBlockId) &&
					text.anchorType !== "page"
				) {
					return text;
				}
				let newX, newY;
				if (
					text.anchorType === "block" &&
					text.anchorBlockId &&
					blockRects[text.anchorBlockId]
				) {
					const r = blockRects[text.anchorBlockId];
					newX = r.left + (r.width * (text.blockOffsetXPercent ?? 0)) / 100;
					newY = r.top + (r.height * (text.blockOffsetYPercent ?? 0)) / 100;
				} else if (text.anchorType === "page" && text.anchor) {
					const textW =
						text.widthPercent != null
							? (text.widthPercent / 100) * cwGet
							: (text.width ?? 100);
					const textH =
						text.heightPercent != null
							? (text.heightPercent / 100) * chGet
							: (text.height ?? 20);
					const pos = getPositionFromAnchor(
						text.anchor,
						text.offsetX ?? 0,
						text.offsetY ?? 0,
						textW,
						textH,
						cwGet,
						chGet,
						text.offsetInPixels ?? false,
					);
					newX = pos.x;
					newY = pos.y;
				} else {
					return text;
				}
				return { ...text, x: newX, y: newY };
			});
			auxPage.canvasTexts = updatedTexts;
			hasChanges = true;
		}

		if (hasChanges) {
			updateCurrentPage(auxPage);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [canvasDimensions.width, canvasDimensions.height]);

	// Sincronizar scrollTop entre templates-container y el contenedor del canvas
	// Funciona tanto en desktop como en móvil
	useEffect(() => {
		const setupScrollSync = () => {
			const templatesContainer = document.getElementById("templates-container");
			const canvasContainer = canvasContainerRef.current;

			if (!templatesContainer || !canvasContainer) return null;

			// Determinar qué elemento tiene scroll en el lado de las templates
			const tid = pages[currentPage]?.templateId;
			let templateScrollEl = null;

			if ([100 /*, 101, 102, 103, 104*/].find((id) => id === tid)) {
				templateScrollEl = document.querySelector(
					`[data-template${tid}-scroll]`,
				);
			} else {
				// Buscar el elemento que realmente tiene scroll
				if (templatesContainer.scrollHeight > templatesContainer.clientHeight) {
					templateScrollEl = templatesContainer;
				} else {
					const firstChild = templatesContainer.firstElementChild;
					if (firstChild && firstChild.scrollHeight > firstChild.clientHeight) {
						templateScrollEl = firstChild;
					} else {
						templateScrollEl = templatesContainer;
					}
				}
			}

			if (!templateScrollEl) return null;

			let scrollSource = null;

			const handleTemplatesScroll = () => {
				if (scrollSource === "canvas") {
					scrollSource = null;
					return;
				}
				scrollSource = "template";
				canvasContainer.scrollTop = templateScrollEl.scrollTop;
			};

			const handleCanvasScroll = () => {
				if (scrollSource === "template") {
					scrollSource = null;
					return;
				}
				scrollSource = "canvas";
				templateScrollEl.scrollTop = canvasContainer.scrollTop;
			};

			templateScrollEl.addEventListener("scroll", handleTemplatesScroll, {
				passive: true,
			});
			canvasContainer.addEventListener("scroll", handleCanvasScroll, {
				passive: true,
			});

			return () => {
				templateScrollEl.removeEventListener("scroll", handleTemplatesScroll);
				canvasContainer.removeEventListener("scroll", handleCanvasScroll);
			};
		};

		// Intentar setup después de un delay para asegurar que el DOM está listo
		const timeoutId = setTimeout(() => {
			setupScrollSync();
		}, 300);

		return () => {
			clearTimeout(timeoutId);
		};
	}, [smallScreen, currentPage, pages]);

	// Función auxiliar para obtener el ancho del canvas o un valor alternativo
	const getCanvasWidth = () => {
		const canvas = document.querySelector(".konvajs-content > canvas");
		if (canvas) {
			return canvas.offsetWidth;
		}
		// Para páginas sin canvas (Template23, 24, 25, 26), usar el ancho del contenedor o un valor por defecto
		const templateContainer = document.getElementById("templates-container");
		if (templateContainer) {
			return templateContainer.offsetWidth || 800;
		}
		return 800; // Valor por defecto
	};

	// Función auxiliar para obtener el alto del canvas o un valor alternativo
	const getCanvasHeight = () => {
		const canvas = document.querySelector(".konvajs-content > canvas");
		if (canvas) {
			return canvas.offsetHeight;
		}
		// Para páginas sin canvas (Template23, 24, 25, 26), usar el alto del contenedor o un valor por defecto
		const templateContainer = document.getElementById("templates-container");
		if (templateContainer) {
			return templateContainer.offsetHeight || 1000;
		}
		return 1000; // Valor por defecto
	};

	// Solo 8 puntos del borde (4 esquinas + 4 centros de lado), sin centro del canvas
	const detectAnchor = (
		pixelX,
		pixelY,
		stickerWidth,
		stickerHeight,
		canvasWidth,
		canvasHeight,
	) => {
		const centerX = pixelX + stickerWidth / 2;
		const centerY = pixelY + stickerHeight / 2;
		const borderPoints = [
			{ anchor: "top-left", x: 0, y: 0 },
			{ anchor: "top-center", x: canvasWidth / 2, y: 0 },
			{ anchor: "top-right", x: canvasWidth, y: 0 },
			{ anchor: "center-left", x: 0, y: canvasHeight / 2 },
			{ anchor: "center-right", x: canvasWidth, y: canvasHeight / 2 },
			{ anchor: "bottom-left", x: 0, y: canvasHeight },
			{ anchor: "bottom-center", x: canvasWidth / 2, y: canvasHeight },
			{ anchor: "bottom-right", x: canvasWidth, y: canvasHeight },
		];
		let minD2 = Infinity;
		let best = borderPoints[0];
		for (const p of borderPoints) {
			const d2 = (centerX - p.x) ** 2 + (centerY - p.y) ** 2;
			if (d2 < minD2) {
				minD2 = d2;
				best = p;
			}
		}
		return best.anchor;
	};

	// Para textos: convertir posición a anchor + offsets en PÍXELES (distancia al punto de anclaje más cercano)
	const pixelToAnchorForText = (
		pixelX,
		pixelY,
		elementWidth,
		elementHeight,
		canvasWidth,
		canvasHeight,
	) => {
		const anchor = detectAnchor(
			pixelX,
			pixelY,
			elementWidth,
			elementHeight,
			canvasWidth,
			canvasHeight,
		);
		let offsetX, offsetY;
		if (anchor.includes("left")) {
			offsetX = pixelX;
		} else if (anchor.includes("right")) {
			offsetX = canvasWidth - (pixelX + elementWidth);
		} else if (anchor.includes("center") || anchor === "center") {
			offsetX = pixelX + elementWidth / 2 - canvasWidth / 2;
		} else {
			offsetX = pixelX;
		}
		if (anchor.includes("top")) {
			offsetY = pixelY;
		} else if (anchor.includes("bottom")) {
			offsetY = canvasHeight - (pixelY + elementHeight);
		} else if (anchor === "center" || anchor.includes("center")) {
			offsetY = pixelY + elementHeight / 2 - canvasHeight / 2;
		} else {
			offsetY = pixelY;
		}
		return { anchor, offsetX, offsetY };
	};

	// Función para migrar stickers al nuevo sistema con anchorType, offsets en % y widthPercent/aspectRatio
	const migrateStickerToPercent = (
		sticker,
		canvasWidth = 800,
		canvasHeight = 1000,
	) => {
		// Si ya tiene el nuevo formato completo, no hacer nada
		if (
			sticker.anchorType &&
			sticker.widthPercent != null &&
			sticker.aspectRatio != null
		) {
			return sticker;
		}

		const stickerWidth = sticker.width || 80;
		const stickerHeight = sticker.height || 80;

		// Calcular widthPercent y aspectRatio si no existen
		const widthPercent =
			sticker.widthPercent ??
			(canvasWidth > 0 ? (stickerWidth / canvasWidth) * 100 : null);
		const aspectRatio =
			sticker.aspectRatio ??
			(stickerWidth > 0 ? stickerHeight / stickerWidth : 1);

		// Si ya tiene anchorType, solo añadir widthPercent/aspectRatio
		if (sticker.anchorType) {
			return {
				...sticker,
				widthPercent,
				aspectRatio,
			};
		}

		// Si tiene x e y en píxeles, convertir a anclaje + offsets en PORCENTAJE
		if (sticker.x !== undefined && sticker.y !== undefined) {
			const anchorData = pixelToAnchorForText(
				sticker.x,
				sticker.y,
				stickerWidth,
				stickerHeight,
				canvasWidth,
				canvasHeight,
			);
			return {
				...sticker,
				anchorType: "page",
				anchor: anchorData.anchor,
				offsetX: canvasWidth > 0 ? (anchorData.offsetX / canvasWidth) * 100 : 0,
				offsetY:
					canvasHeight > 0 ? (anchorData.offsetY / canvasHeight) * 100 : 0,
				offsetInPixels: false,
				widthPercent,
				aspectRatio,
			};
		}

		// Si tiene xPercent/yPercent pero no anclaje, convertir a anchor + offsets en porcentaje
		if (sticker.xPercent !== undefined && sticker.yPercent !== undefined) {
			const pixelX = (sticker.xPercent / 100) * canvasWidth;
			const pixelY = (sticker.yPercent / 100) * canvasHeight;
			const anchorData = pixelToAnchorForText(
				pixelX,
				pixelY,
				stickerWidth,
				stickerHeight,
				canvasWidth,
				canvasHeight,
			);
			return {
				...sticker,
				anchorType: "page",
				anchor: anchorData.anchor,
				offsetX: canvasWidth > 0 ? (anchorData.offsetX / canvasWidth) * 100 : 0,
				offsetY:
					canvasHeight > 0 ? (anchorData.offsetY / canvasHeight) * 100 : 0,
				offsetInPixels: false,
				widthPercent,
				aspectRatio,
			};
		}

		// Si no tiene posición, usar valores por defecto
		return {
			...sticker,
			anchorType: "page",
			anchor: "top-left",
			offsetX: 0,
			offsetY: 0,
			offsetInPixels: false,
			widthPercent,
			aspectRatio,
		};
	};

	// Helper: calcular posición en píxeles desde anchor/offset (stickers y overlays)
	// offsetInPixels: si true, offsetX/offsetY son píxeles; si no, porcentaje (compat)
	const getPositionFromAnchor = (
		anchor,
		offsetX,
		offsetY,
		elementWidth,
		elementHeight,
		canvasWidth,
		canvasHeight,
		offsetInPixels,
	) => {
		const px = (val, dim) => (offsetInPixels ? val : (val / 100) * dim);
		let pixelX, pixelY;
		if (anchor.includes("left")) {
			pixelX = px(offsetX, canvasWidth);
		} else if (anchor.includes("right")) {
			const rightEdge = canvasWidth - px(offsetX, canvasWidth);
			pixelX = rightEdge - elementWidth;
		} else if (anchor.includes("center") || anchor === "center") {
			const centerX = canvasWidth / 2 + px(offsetX, canvasWidth);
			pixelX = centerX - elementWidth / 2;
		} else {
			pixelX = px(offsetX, canvasWidth);
		}
		if (anchor.includes("top")) {
			pixelY = px(offsetY, canvasHeight);
		} else if (anchor.includes("bottom")) {
			const bottomEdge = canvasHeight - px(offsetY, canvasHeight);
			pixelY = bottomEdge - elementHeight;
		} else if (anchor === "center" || anchor.includes("center")) {
			const centerY = canvasHeight / 2 + px(offsetY, canvasHeight);
			pixelY = centerY - elementHeight / 2;
		} else {
			pixelY = px(offsetY, canvasHeight);
		}
		return { x: pixelX, y: pixelY };
	};

	const getAnchoredPixelPosition = (el, elementWidth, elementHeight) => {
		const canvasWidth = getCanvasWidth();
		const canvasHeight = getCanvasHeight();
		if (el?.anchor && el?.offsetX !== undefined && el?.offsetY !== undefined) {
			return getPositionFromAnchor(
				el.anchor,
				el.offsetX,
				el.offsetY,
				elementWidth,
				elementHeight,
				canvasWidth,
				canvasHeight,
				el.offsetInPixels,
			);
		}
		if (el?.xPercent !== undefined && el?.yPercent !== undefined) {
			return {
				x: (el.xPercent / 100) * canvasWidth,
				y: (el.yPercent / 100) * canvasHeight,
			};
		}
		return { x: el?.x || 0, y: el?.y || 0 };
	};

	// ========== FLUJO POSICIÓN STICKER (paso a paso para depurar) ==========
	// PASO 0: updateBlockRects() — mide [data-block-id] y guarda rects en coords Stage (mismo rango que canvasDimensions).
	// PASO 1: Sticker onDragEnd — Konva e.target.x()/y() = posición en Stage; envía al padre (x, y) en ese sistema.
	// PASO 2: StickerApp onChange — recibe stageX, stageY; hitTestBlock(stageX, stageY); guarda x,y + anchorType/block/page.
	// PASO 3: getStickerPixelPosition — al pintar: si sticker tiene x,y numéricos → devolverlos; si no → getStickerPositionFromAnchor.
	// Resize: efecto con [canvasDimensions] recalcula x,y desde anclaje y actualiza estado.
	// ========================================================================

	// Hit-test: punto (x,y) en coordenadas Stage → bloque que lo contiene o el más cercano; null si no hay bloques
	const hitTestBlock = (x, y) => {
		const rects = blockRects;
		const ids = Object.keys(rects);
		console.log(
			"[hitTestBlock] Entrada (coords Stage):",
			{ x, y },
			"bloques disponibles:",
			ids.length,
			"rects:",
			rects,
		);
		if (ids.length === 0) return null;
		// Primero: ¿está dentro de algún bloque?
		for (const blockId of ids) {
			const r = rects[blockId];
			if (
				x >= r.left &&
				x <= r.left + r.width &&
				y >= r.top &&
				y <= r.top + r.height
			) {
				console.log(
					"[hitTestBlock] Punto DENTRO del bloque:",
					blockId,
					"rect:",
					r,
				);
				return { blockId, rect: r };
			}
		}
		// Segundo: bloque más cercano (distancia al centro del rect)
		let minD2 = Infinity;
		let best = null;
		for (const blockId of ids) {
			const r = rects[blockId];
			const cx = r.left + r.width / 2;
			const cy = r.top + r.height / 2;
			const d2 = (x - cx) ** 2 + (y - cy) ** 2;
			if (d2 < minD2) {
				minD2 = d2;
				best = { blockId, rect: r };
			}
		}
		console.log(
			"[hitTestBlock] Punto fuera de bloques → más cercano:",
			best ? best.blockId : null,
			best ? "rect:" : "",
			best?.rect,
		);
		return best;
	};

	// Calcular posición en píxeles SOLO desde anclaje (para resize/reload). No usa x,y guardados.
	const getStickerPositionFromAnchor = (
		sticker,
		stickerWidth,
		stickerHeight,
		rects,
		cw,
		ch,
	) => {
		if (
			sticker.anchorType === "block" &&
			sticker.anchorBlockId &&
			rects[sticker.anchorBlockId]
		) {
			const r = rects[sticker.anchorBlockId];
			const px = r.left + (r.width * (sticker.blockOffsetXPercent ?? 0)) / 100;
			const py = r.top + (r.height * (sticker.blockOffsetYPercent ?? 0)) / 100;
			console.log(
				"[getStickerPositionFromAnchor] block:",
				sticker.anchorBlockId,
				"rect:",
				r,
				"%:",
				sticker.blockOffsetXPercent,
				sticker.blockOffsetYPercent,
				"→ px,py:",
				px,
				py,
			);
			return { x: px, y: py };
		}
		const anchor = sticker.anchor || "top-left";
		const offsetX = sticker.offsetX ?? 0;
		const offsetY = sticker.offsetY ?? 0;
		const offsetInPixels = sticker.offsetInPixels ?? false;
		const pos = getPositionFromAnchor(
			anchor,
			offsetX,
			offsetY,
			stickerWidth,
			stickerHeight,
			cw,
			ch,
			offsetInPixels,
		);
		console.log(
			"[getStickerPositionFromAnchor] page anchor:",
			anchor,
			"offset:",
			offsetX,
			offsetY,
			"→",
			pos,
		);
		return pos;
	};

	// Posición para PINTAR: siempre calcular desde anclaje (igual que TextSticker)
	// Así la posición se adapta automáticamente al tamaño actual del canvas
	const getStickerPixelPosition = (sticker, stickerWidth, stickerHeight) => {
		const cw = getCanvasWidth();
		const ch = getCanvasHeight();

		// Si tiene anclaje a bloque, calcular desde bloque
		if (
			sticker.anchorType === "block" &&
			sticker.anchorBlockId &&
			blockRects[sticker.anchorBlockId]
		) {
			const r = blockRects[sticker.anchorBlockId];
			const px = r.left + (r.width * (sticker.blockOffsetXPercent ?? 0)) / 100;
			const py = r.top + (r.height * (sticker.blockOffsetYPercent ?? 0)) / 100;
			return { x: px, y: py };
		}

		// Si tiene anclaje a página, calcular desde anclaje
		if (sticker.anchorType === "page" && sticker.anchor) {
			return getPositionFromAnchor(
				sticker.anchor,
				sticker.offsetX ?? 0,
				sticker.offsetY ?? 0,
				stickerWidth,
				stickerHeight,
				cw,
				ch,
				sticker.offsetInPixels ?? false,
			);
		}

		// Fallback: usar x,y guardados o 0
		return { x: sticker.x ?? 0, y: sticker.y ?? 0 };
	};

	// Tamaño escalado del sticker: usa widthPercent y aspectRatio para mantener proporciones
	const getScaledStickerSize = (sticker) => {
		const cw = getCanvasWidth();

		// Si tiene widthPercent y aspectRatio, calcular manteniendo proporción
		if (
			typeof sticker.widthPercent === "number" &&
			!isNaN(sticker.widthPercent) &&
			typeof sticker.aspectRatio === "number" &&
			!isNaN(sticker.aspectRatio) &&
			cw > 0
		) {
			const width = (sticker.widthPercent / 100) * cw;
			const height = width * sticker.aspectRatio;
			if (!isNaN(width) && !isNaN(height) && width > 0 && height > 0) {
				return { width, height };
			}
		}

		// Fallback: tamaño fijo (con verificación de NaN)
		const fallbackW = sticker.width ?? 80;
		const fallbackH = sticker.height ?? 80;
		return {
			width: isNaN(fallbackW) ? 80 : fallbackW,
			height: isNaN(fallbackH) ? 80 : fallbackH,
		};
	};

	// Dimensiones del canvasText en píxeles: widthPercent/heightPercent respecto al Stage actual (200*350/550 en móvil)
	const getCanvasTextDimensions = (text) => {
		const canvasWidth = canvasDimensions.width;
		const canvasHeight = canvasDimensions.height;
		const width =
			text?.widthPercent != null && canvasWidth > 0
				? (text.widthPercent / 100) * canvasWidth
				: (text?.width ?? 100);
		const height =
			text?.heightPercent != null && canvasHeight > 0
				? (text.heightPercent / 100) * canvasHeight
				: (text?.height ?? 10);
		return { width, height };
	};

	// Posición del texto: igual que stickers, si tiene x,y guardados usarlos; si no, calcular desde anclaje
	const getTextPixelPosition = (text, textWidth, textHeight) => {
		const hasStoredXY =
			typeof text.x === "number" && typeof text.y === "number";
		if (hasStoredXY) {
			return { x: text.x, y: text.y };
		}
		// Calcular desde anclaje (bloque o página)
		const cw = getCanvasWidth();
		const ch = getCanvasHeight();
		if (
			text.anchorType === "block" &&
			text.anchorBlockId &&
			blockRects[text.anchorBlockId]
		) {
			const r = blockRects[text.anchorBlockId];
			const px = r.left + (r.width * (text.blockOffsetXPercent ?? 0)) / 100;
			const py = r.top + (r.height * (text.blockOffsetYPercent ?? 0)) / 100;
			return { x: px, y: py };
		}
		// Fallback: anclaje a página o porcentajes
		if (
			text.anchor &&
			text.offsetX !== undefined &&
			text.offsetY !== undefined
		) {
			const offsetInPixels = text.offsetInPixels ?? false;
			return getPositionFromAnchor(
				text.anchor,
				text.offsetX,
				text.offsetY,
				textWidth,
				textHeight,
				cw,
				ch,
				offsetInPixels,
			);
		}
		if (text.xPercent !== undefined && text.yPercent !== undefined) {
			return { x: (text.xPercent / 100) * cw, y: (text.yPercent / 100) * ch };
		}
		return { x: text.x || 0, y: text.y || 0 };
	};

	const handleSelectSticker = (index, auxIndex) => {
		if (selectedGroupSticker !== null && index !== selectedGroupSticker) {
			return; // Si hay un grupo seleccionado y no es el actual, no hacer nada
		}

		const stickerData = stickers[index][auxIndex];
		const canvasWidth = getCanvasWidth();
		const originalWidth = 120;

		// Función para añadir el sticker con el aspect ratio correcto
		const addStickerWithAspectRatio = (naturalAspectRatio, imgElement) => {
			const originalHeight = originalWidth * naturalAspectRatio;

			const selectedSticker = {
				...stickerData,
				uniqueId: new Date().getTime(),
				width: originalWidth,
				height: originalHeight,
				widthPercent:
					canvasWidth > 0 ? (originalWidth / canvasWidth) * 100 : 15,
				aspectRatio: naturalAspectRatio,
				anchorType: "page",
				anchor: "top-left",
				offsetX: 0,
				offsetY: 0,
				offsetInPixels: false,
				x: 0,
				y: 0,
				image: imgElement, // Usar la imagen ya cargada
			};

			const auxPage = { ...pages[currentPage] };
			if (!auxPage.canvasStickers) {
				auxPage.canvasStickers = [];
			}
			auxPage.canvasStickers.push(selectedSticker);
			updateCurrentPage(auxPage);

			if (!tabbar) {
				setDrawerOpen(false);
			}
			document.querySelector("html").scrollTop = 0;

			// Mostrar alert de sticker añadido
			enqueueSnackbar("Sticker añadido!", {
				variant: "success",
				anchorOrigin: {
					vertical: "top",
					horizontal: "center",
				},
				autoHideDuration: 2000,
			});
		};

		// Si la imagen ya está cargada (en caché), usar directamente
		if (
			stickerData.image &&
			stickerData.image.complete &&
			stickerData.image.naturalWidth > 0
		) {
			const naturalAspectRatio =
				stickerData.image.naturalHeight / stickerData.image.naturalWidth;
			addStickerWithAspectRatio(naturalAspectRatio, stickerData.image);
			return;
		}

		// Crear imagen para obtener dimensiones naturales
		const img = new Image();
		img.onload = () => {
			const naturalAspectRatio = img.naturalHeight / img.naturalWidth;
			addStickerWithAspectRatio(naturalAspectRatio, img);
		};
		img.onerror = () => {
			// Fallback: usar dimensiones del catálogo si la imagen no carga
			const fallbackWidth = stickerData.width || 100;
			const fallbackHeight = stickerData.height || 100;
			const fallbackAspectRatio = fallbackHeight / fallbackWidth;
			addStickerWithAspectRatio(fallbackAspectRatio, img);
		};
		img.src = stickerData.imagePath;
	};

	/**
	 * Añade un sticker personalizado al canvas actual. La imagen base se
	 * carga desde el backend protegido (API custom-stickers). Adjuntamos
	 * `customText` para que Sticker.js y Viewer.js la pinten por encima.
	 */
	const handleAddCustomSticker = (payload) => {
		if (!payload) return;
		const { baseImage, aspectRatio, customText, meta } = payload;
		const canvasWidth = getCanvasWidth();
		const originalWidth = 140;

		const addWithAspect = (naturalAspectRatio, imgElement) => {
			const originalHeight = originalWidth * naturalAspectRatio;
			const selectedSticker = {
				id: `custom-${meta.countryId}-${meta.stickerId}`,
				uniqueId: new Date().getTime(),
				imagePath: baseImage,
				width: originalWidth,
				height: originalHeight,
				widthPercent:
					canvasWidth > 0 ? (originalWidth / canvasWidth) * 100 : 18,
				aspectRatio: naturalAspectRatio,
				anchorType: "page",
				anchor: "top-left",
				offsetX: 0,
				offsetY: 0,
				offsetInPixels: false,
				x: 0,
				y: 0,
				image: imgElement,
				customText,
				customStickerMeta: meta,
				isFree: true,
			};

			const auxPage = { ...pages[currentPage] };
			if (!auxPage.canvasStickers) auxPage.canvasStickers = [];
			auxPage.canvasStickers.push(selectedSticker);
			updateCurrentPage(auxPage);

			if (!tabbar) setDrawerOpen(false);
			document.querySelector("html").scrollTop = 0;

			enqueueSnackbar("Sticker personalizado añadido!", {
				variant: "success",
				anchorOrigin: { vertical: "top", horizontal: "center" },
				autoHideDuration: 2000,
			});
		};

		const img = new Image();
		img.crossOrigin = "anonymous";
		img.onload = () => {
			const naturalAspectRatio =
				img.naturalHeight && img.naturalWidth
					? img.naturalHeight / img.naturalWidth
					: aspectRatio || 1;
			addWithAspect(naturalAspectRatio, img);
		};
		img.onerror = () => {
			addWithAspect(aspectRatio || 1, img);
		};
		img.src = baseImage;
	};

	const handleGroupCoverClick = async (groupIndex) => {
		setSelectedGroupSticker(groupIndex);
		setPage(1);
		const col = stickerCollections[groupIndex];
		trackEditorAction("sticker_pack_opened", selectedProject?.id, {
			collection_id: col?.id,
			collection_name: col?.name,
		});
		if (
			col &&
			!col.isLocked &&
			(!stickers[groupIndex] || stickers[groupIndex].length === 0)
		) {
			setLoadingCollectionId(col.id);
			try {
				const detail = await getStickerCollection(col.id);
				if (detail?.stickers) {
					setLoadedCollectionDetails((prev) => ({ ...prev, [col.id]: detail }));
					const newSet = detail.stickers.map((s, idx) => ({
						id: `${col.id}-${idx}`,
						x: 50,
						y: 50,
						width: 200,
						image: new window.Image(),
						imagePath: getStickerAssetUrl(s.assetId),
						assetId: s.assetId,
						isFree: s.isFree !== false,
					}));
					setStickers((prev) => {
						const copy = [...prev];
						while (copy.length <= groupIndex) copy.push([]);
						copy[groupIndex] = newSet;
						return copy;
					});
				}
			} catch (err) {
				console.error("Error loading collection stickers:", err);
			} finally {
				setLoadingCollectionId(null);
			}
		}
	};

	const handleAddText = () => {
		const canvas = document.querySelector(".konvajs-content > canvas");
		const context = canvas?.getContext("2d");

		// Si no hay canvas, crear un canvas temporal para medir el texto
		let measureContext = context;
		if (!measureContext) {
			const tempCanvas = document.createElement("canvas");
			measureContext = tempCanvas.getContext("2d");
		}

		if (measureContext) {
			measureContext.font = `32px ${fontFamily}`;
			measureContext.textBaseline = "top";
		}

		const inputText = newTextValue || "Nuevo Texto";
		const longestSubstring = (value) => {
			// Dividir la cadena por los saltos de línea
			let substrings = value.split("\n");
			// Encontrar la subcadena más larga
			let longest = substrings.reduce((a, b) => (a.length > b.length ? a : b));
			return longest;
		};
		const finalText = longestSubstring(inputText);

		// Bounding box ajustada a lo que ocupa el texto (padding mínimo)
		const textWidth = measureContext?.measureText(finalText).width || 200;
		const strokeWidth = modalTextStrokeWidth || 0;
		const width = textWidth + strokeWidth * 2 + 10;

		const lineHeight = 32 * 1.2;
		const numLines = inputText.split("\n").length;
		const height = lineHeight * numLines + strokeWidth * 2 + 6;

		const canvasW = getCanvasWidth();
		const canvasH = getCanvasHeight();
		const newText = {
			id: new Date().getTime(),
			x: canvasW - width - 40,
			y: 100,
			text: inputText,
			fontSize: 32,
			fontFamily: fontFamily,
			width: width,
			height: height,
			// Ligados a la template: width/height/fontSize escalan al redimensionar
			widthPercent: canvasW > 0 ? (width / canvasW) * 100 : null,
			heightPercent: canvasH > 0 ? (height / canvasH) * 100 : null,
			fontSizePercent: canvasW > 0 ? (32 / canvasW) * 100 : null,
			scaleX: 1,
			scaleY: 1,
			rotation: 0,
			stroke: modalTextStrokeColor,
			strokeWidth: modalTextStrokeWidth,
			fill: modalTextColor,
			align: "left",
		};
		// Anchor + offset en PÍXELES para que "50px de la esquina" se mantenga al redimensionar
		const pixelX = canvasW - width - 40;
		const pixelY = 100;
		const anchorData = pixelToAnchorForText(
			pixelX,
			pixelY,
			width,
			height,
			canvasW,
			canvasH,
		);
		const anchoredText = {
			...newText,
			anchor: anchorData.anchor,
			offsetX: anchorData.offsetX,
			offsetY: anchorData.offsetY,
			offsetInPixels: true,
			xPercent: canvasW > 0 ? (pixelX / canvasW) * 100 : null,
			yPercent: canvasH > 0 ? (pixelY / canvasH) * 100 : null,
		};
		const auxPage = { ...pages[currentPage] };
		if (!auxPage.canvasTexts) {
			auxPage.canvasTexts = [];
		}
		auxPage.canvasTexts.push(anchoredText);
		updateCurrentPage(auxPage);
		if (!tabbar) {
			setDrawerOpen(false);
		}
		document.querySelector("html").scrollTop = 0;

		//setTextOnCanvas((prevText) => [...prevText, newText]);
		setNewTextValue("");
	};

	// Funciones para manejar notas
	const handleAddNoteMode = () => {
		setIsAddingNote(true);
		if (selectedTab) {
			setSelectedTab(null);
		}
	};

	const handleNoteClick = (e) => {
		if (!isAddingNote) return;

		const container = document.getElementById("templates-container");
		if (!container) return;

		const nativeEvt = e.evt;
		const clientX =
			nativeEvt.clientX ?? nativeEvt.changedTouches?.[0]?.clientX;
		const clientY =
			nativeEvt.clientY ?? nativeEvt.changedTouches?.[0]?.clientY;
		if (clientX == null || clientY == null) return;

		const rect = container.getBoundingClientRect();
		const x = ((clientX - rect.left) / rect.width) * 100;
		const scrollTop = container.scrollTop || 0;
		const fullHeight = container.scrollHeight || rect.height;
		const y = ((clientY - rect.top + scrollTop) / fullHeight) * 100;

		setNotePosition({
			x: Math.max(0, Math.min(100, x)),
			y: Math.max(0, Math.min(100, y)),
		});
		setNoteContent("");
		setNoteEmoji("");
		setEditingNote(null);
		setIsNoteModalOpen(true);
		setIsAddingNote(false);
	};

	const handleSaveNote = () => {
		const auxPage = { ...pages[currentPage] };
		if (!auxPage.notes) {
			auxPage.notes = [];
		}

		if (editingNote) {
			const noteIndex = auxPage.notes.findIndex((n) => n.id === editingNote.id);
			if (noteIndex !== -1) {
				auxPage.notes[noteIndex] = {
					...auxPage.notes[noteIndex],
					content: noteContent,
					emoji: noteEmoji || undefined,
				};
			}
		} else {
			auxPage.notes.push({
				id: Date.now(),
				content: noteContent,
				emoji: noteEmoji || undefined,
				x: notePosition.x,
				y: notePosition.y,
			});
		}

		updateCurrentPage(auxPage);
		setIsNoteModalOpen(false);
		setNoteContent("");
		setNoteEmoji("");
		setEditingNote(null);
	};

	const handleEditNote = (note) => {
		setEditingNote(note);
		setNoteContent(note.content);
		setNoteEmoji(note.emoji || "");
		setNotePosition({ x: note.x, y: note.y });
		setIsNoteModalOpen(true);
	};

	const handleDeleteNote = (noteId) => {
		const auxPage = { ...pages[currentPage] };
		if (auxPage.notes) {
			auxPage.notes = auxPage.notes.filter((n) => n.id !== noteId);
			updateCurrentPage(auxPage);
		}
	};

	const handleCancelNote = () => {
		setIsNoteModalOpen(false);
		setNoteContent("");
		setNoteEmoji("");
		setEditingNote(null);
		setIsAddingNote(false);
	};

	const isClickInsideElementV2 = (cX, cY, element) => {
		const canvas = document.querySelector(".konvajs-content > canvas");
		const bounds = canvas.getBoundingClientRect();
		const clickX = cX; // - bounds.left;
		const clickY = cY; // - bounds.top;

		// Convertimos la rotación a radianes y calculamos la matriz de transformación inversa
		console.log(element.rotation);
		const rotationRadians = (-(element.rotation || 0) * Math.PI) / 180;
		const sin = Math.sin(rotationRadians);
		const cos = Math.cos(rotationRadians);

		// Puntos centrales después de aplicar las transformaciones
		const centerX = element.x + element.width / 2;
		const centerY = element.y + element.height / 2;

		// Coordenadas del clic trasladadas al centro del rectángulo
		let translatedX = clickX - centerX;
		let translatedY = clickY - centerY;

		// Aplicamos la transformación inversa (rotación y escala)
		let transformedX =
			(translatedX * cos + translatedY * sin) / (element.scaleX || 1);
		let transformedY =
			(-translatedX * sin + translatedY * cos) / (element.scaleY || 1);

		console.log(element);
		console.log(centerX);
		console.log(centerY);
		console.log(cos);
		console.log(sin);
		console.log(translatedX);
		console.log(translatedY);
		console.log(transformedX);
		console.log(-element.width / 2);
		console.log(transformedY);
		console.log(element.height / 2);
		// Verificamos si las coordenadas transformadas están dentro de los límites del rectángulo original
		if (
			transformedX >= -element.width / 2 &&
			transformedX <= element.width / 2 &&
			transformedY >= -element.height / 2 &&
			transformedY <= element.height / 2
		) {
			return true;
		} else {
			return false;
		}
	};

	const isClickInsideElement = (x, y, element, elementType) => {
		/*console.log(x + ", " + y);
		console.log(element);*/
		// Calculate the center of the element
		const centerX = element.x + element.width / 2;
		const centerY =
			element.y +
			(elementType === "image" ? element.image.height : element.height) / 2;

		// Calculate the angle of rotation
		const angle = element.rotation || 0;
		console.log(angle);

		// Calculate the scale factors
		const scaleX = element.scaleX || 1;
		const scaleY = element.scaleY || 1;

		// Convert click position to element's coordinate system
		const clickX = x - centerX;
		const clickY = y - centerY;
		const cosAngle = Math.cos(-angle);
		const sinAngle = Math.sin(-angle);
		const rotatedX = clickX * cosAngle - clickY * sinAngle;
		const rotatedY = clickX * sinAngle + clickY * cosAngle;
		const scaledX = rotatedX / scaleX;
		const scaledY = rotatedY / scaleY;

		// Check if the click is inside the element
		console.log(element);
		console.log(scaledX);
		console.log(-element.width / 2);
		console.log(scaledY);
		console.log(element.height / 2);
		return (
			scaledX >= -parseFloat(element.width) / 2 &&
			scaledX <= parseFloat(element.width) / 2 &&
			scaledY >=
				-parseFloat(
					elementType === "image" ? element.image.height : element.height,
				) /
					2 &&
			scaledY <=
				parseFloat(
					elementType === "image" ? element.image.height : element.height,
				) /
					2
		);
	};

	useEffect(() => {
		if (
			clickedX !== null &&
			clickedY !== null /*&&
			selectedTextIndex === null &&
			selectedStickerIndex === null*/
		) {
			//setTimeout(() => {
			if (
				selectedTextIndex === null &&
				selectedStickerIndex === null &&
				selectedImageIndex === null
			) {
				// clickedX y clickedY ya son coordenadas absolutas (clientX, clientY)
				// No necesitamos sumar getBoundingClientRect() porque ya están en coordenadas de la ventana
				let x = clickedX;
				let y = clickedY;

				// Validar que las coordenadas sean números finitos válidos
				if (x == null || y == null || !isFinite(x) || !isFinite(y)) {
					console.warn("Invalid coordinates:", x, y);
					return;
				}

				// Si ya estamos propagando un clic, no hacer nada más
				if (isPropagatingClickRef.current) {
					return;
				}

				// Verificar primero si el clic fue en un botón u otro elemento interactivo
				// Usar elementsFromPoint para obtener todos los elementos en ese punto (incluyendo los que están por encima)
				const elementsAtPoint = document.elementsFromPoint(x, y);
				console.log(
					"Elements at point:",
					elementsAtPoint.length,
					elementsAtPoint,
				);

				// Filtrar el canvas y elementos de Konva
				const elementsWithoutCanvas = elementsAtPoint.filter((el) => {
					if (el.tagName === "CANVAS") return false;
					if (el.classList.contains("konvajs-content")) return false;
					if (
						el.querySelector("canvas") ||
						el.querySelector(".konvajs-content")
					)
						return false;
					if (el.closest(".konvajs-content")) return false;
					if (
						el === canvasContainerRef.current ||
						canvasContainerRef.current?.contains(el)
					)
						return false;
					return true;
				});

				// Buscar el primer elemento que tenga data-template-item o sea un botón
				// Priorizar elementos más específicos como ImagePlaceholder o divs con onClick
				let foundInteractiveElement = null;
				let isButtonElement = false;
				for (const element of elementsWithoutCanvas) {
					const isButton =
						element.tagName === "BUTTON" ||
						element.closest("button") ||
						element.closest('[role="button"]') ||
						element.closest(".MuiButton-root");

					const hasTemplateItem =
						element.hasAttribute("data-template-item") ||
						element.classList.contains("template-item") ||
						element.hasAttribute("data-image-placeholder");

					// Priorizar elementos con data-image-placeholder o que tengan onClick
					const isImagePlaceholder = element.hasAttribute(
						"data-image-placeholder",
					);

					if (isButton || hasTemplateItem) {
						foundInteractiveElement = element;
						isButtonElement = isButton;
						// Si es un ImagePlaceholder, usarlo directamente
						if (isImagePlaceholder) {
							break;
						}
					}
				}

				if (foundInteractiveElement) {
					console.log("Found interactive element:", foundInteractiveElement);

					// Marcar que estamos propagando un clic
					isPropagatingClickRef.current = true;

					// Usar setTimeout para evitar interferencia con el evento original
					setTimeout(() => {
						// Si es un botón, encontrar el botón real (puede ser un hijo)
						if (isButtonElement) {
							const button =
								foundInteractiveElement.closest("button") ||
								foundInteractiveElement;
							if (
								button &&
								(button.tagName === "BUTTON" ||
									button.classList.contains("MuiButton-root"))
							) {
								console.log("Clicking button:", button);
								button.click();
								isPropagatingClickRef.current = false;
								return;
							}
						}

						// Si es un elemento con data-template-item o data-image-placeholder, disparar el click
						let clickableElement = foundInteractiveElement;

						// Si el elemento encontrado tiene data-image-placeholder, usarlo directamente
						if (
							foundInteractiveElement.hasAttribute("data-image-placeholder")
						) {
							clickableElement = foundInteractiveElement;
						} else {
							// Buscar el elemento clickeable más cercano
							clickableElement =
								foundInteractiveElement.closest(
									"[data-image-placeholder], [data-template-item], .template-item",
								) || foundInteractiveElement;
						}

						if (clickableElement) {
							console.log(
								"Clicking element:",
								clickableElement,
								"tag:",
								clickableElement.tagName,
							);
							// Solo usar el método click() nativo, no dispatchEvent para evitar doble ejecución
							if (typeof clickableElement.click === "function") {
								clickableElement.click();
							}
						}

						// Resetear el flag después de un breve delay
						setTimeout(() => {
							isPropagatingClickRef.current = false;
						}, 100);
					}, 0);
					return;
				}

				console.log("NOT FOUND");
				setEditingTextIndex(null);
				setSelectedTextIndex(null);
				setSelectedStickerIndex(null);
				setSelectedImageIndex(null);

				let found = false;
				document
					.querySelectorAll(".template-item, *[data-template-item]")
					.forEach((element) => {
						console.log(x + ", " + y);
						console.log(element.getBoundingClientRect());
						if (
							x >= element.getBoundingClientRect().x &&
							x <=
								element.getBoundingClientRect().x +
									element.getBoundingClientRect().width &&
							y >= element.getBoundingClientRect().y &&
							y <=
								element.getBoundingClientRect().y +
									element.getBoundingClientRect().height &&
							!found
						) {
							found = true;
							const ev = document.createEvent("MouseEvent");
							ev.initMouseEvent(
								"click",
								true /* bubble */,
								true /* cancelable */,
								window, //document.querySelector("#templates-container"),
								null,
								x,
								y,
								0,
								0 /* coordinates */,
								false,
								false,
								false,
								false /* modifier keys */,
								0 /*left*/,
								null,
							);
							element.dispatchEvent(ev);
						}
					});
			}
			//}, 750);
		}
	}, [
		clickedX,
		clickedY,
		selectedTextIndex,
		selectedStickerIndex,
		selectedImageIndex,
	]);

	// Función helper para verificar si un elemento es interactivo (botón, ImagePlaceholder, etc.)
	const isInteractiveElement = (elementAtPoint) => {
		if (!elementAtPoint) return false;

		// Verificar si es un botón o está dentro de un botón
		const isButton =
			elementAtPoint.tagName === "BUTTON" ||
			elementAtPoint.closest("button") ||
			elementAtPoint.closest('[role="button"]') ||
			elementAtPoint.closest(".MuiButton-root") ||
			elementAtPoint.closest(".MuiCard-root");

		// Verificar si es un ImagePlaceholder o está dentro de uno
		const isImagePlaceholder =
			elementAtPoint.hasAttribute("data-image-placeholder") ||
			elementAtPoint.closest("[data-image-placeholder]");

		// Verificar si tiene data-template-item o la clase template-item
		const hasTemplateItem =
			elementAtPoint.hasAttribute("data-template-item") ||
			elementAtPoint.classList.contains("template-item") ||
			elementAtPoint.closest("[data-template-item]") ||
			elementAtPoint.closest(".template-item");

		// Verificar si tiene un z-index alto (elementos por encima del canvas)
		const computedStyle = window.getComputedStyle(elementAtPoint);
		const zIndex = parseInt(computedStyle.zIndex) || 0;
		const isHighZIndex = zIndex > 1000;

		// Verificar si tiene pointerEvents: auto y está por encima
		const pointerEvents = computedStyle.pointerEvents;
		const isInteractive = pointerEvents === "auto" && isHighZIndex;

		// Verificar si el elemento o sus padres tienen z-index alto
		let parent = elementAtPoint.parentElement;
		let hasHighZIndexParent = false;
		while (parent && parent !== document.body) {
			const parentStyle = window.getComputedStyle(parent);
			const parentZIndex = parseInt(parentStyle.zIndex) || 0;
			if (parentZIndex > 1000) {
				hasHighZIndexParent = true;
				break;
			}
			parent = parent.parentElement;
		}

		return (
			isButton ||
			isImagePlaceholder ||
			hasTemplateItem ||
			isInteractive ||
			hasHighZIndexParent
		);
	};

	const handleCanvasClick = (e) => {
		console.log("handleCanvasClick called", e);

		// Si hubo movimiento significativo (scroll), no ejecutar el click
		if (canvasHasMovedRef.current) {
			canvasHasMovedRef.current = false;
			canvasTouchStartRef.current = null;
			return;
		}

		// Si estamos en modo de añadir nota, manejar el clic para añadir nota
		if (isAddingNote) {
			handleNoteClick(e);
			return;
		}

		// Verificar si el clic fue en un elemento interactivo (botón, enlace, etc.)
		// Usar las coordenadas del evento para encontrar el elemento real
		let clientX = null;
		let clientY = null;

		// Para eventos táctiles, obtener coordenadas de touches o changedTouches
		if (e.evt instanceof TouchEvent) {
			const touch = e.evt.touches?.[0] || e.evt.changedTouches?.[0];
			if (touch) {
				clientX = touch.clientX;
				clientY = touch.clientY;
			}
		} else {
			// Para eventos de mouse, usar clientX/clientY directamente
			clientX = e.evt?.clientX ?? e.evt?.x ?? null;
			clientY = e.evt?.clientY ?? e.evt?.y ?? null;
		}

		if (
			clientX !== null &&
			clientY !== null &&
			isFinite(clientX) &&
			isFinite(clientY)
		) {
			// Usar elementsFromPoint para obtener todos los elementos en ese punto
			// y filtrar el canvas de Konva y sus contenedores
			const elementsAtPoint = document.elementsFromPoint(clientX, clientY);
			// Filtrar el canvas, elementos de Konva y sus contenedores
			const elementsWithoutCanvas = elementsAtPoint.filter((el) => {
				// Excluir canvas
				if (el.tagName === "CANVAS") return false;
				// Excluir elementos con clase konvajs-content
				if (el.classList.contains("konvajs-content")) return false;
				// Excluir elementos que contengan canvas o konvajs-content
				if (el.querySelector("canvas") || el.querySelector(".konvajs-content"))
					return false;
				// Excluir si está dentro de un contenedor de Konva
				if (el.closest(".konvajs-content")) return false;
				// Excluir el contenedor del canvas (el Box con ref canvasContainerRef)
				if (
					el === canvasContainerRef.current ||
					canvasContainerRef.current?.contains(el)
				)
					return false;
				return true;
			});

			console.log("Elements without canvas:", elementsWithoutCanvas);

			// Buscar el primer elemento interactivo que no sea el canvas
			for (const element of elementsWithoutCanvas) {
				if (isInteractiveElement(element)) {
					// Si es un elemento interactivo, no procesar el clic del canvas
					e.evt.preventDefault();
					e.evt.stopPropagation();
					console.log("INTERACTIVE ELEMENT FOUND (non-canvas):", element);

					// Usar un flag para evitar doble ejecución
					if (isPropagatingClickRef.current) {
						return;
					}
					isPropagatingClickRef.current = true;

					// Usar setTimeout para asegurar que el evento original no interfiera
					setTimeout(() => {
						// Solo usar click() nativo para evitar doble ejecución (p. ej. selector de imagen abierto dos veces).
						// No usar dispatchEvent + click() a la vez.
						if (typeof element.click === "function") {
							element.click();
						}
						// Resetear el flag después de un breve delay
						setTimeout(() => {
							isPropagatingClickRef.current = false;
						}, 100);
					}, 0);
					return;
				}
			}
		}

		console.log("CANVAS SELECTING");
		// Obtener coordenadas del evento - manejar tanto eventos de mouse como táctiles
		let x = null;
		let y = null;

		// Para eventos táctiles, obtener coordenadas de touches o changedTouches
		if (e.evt instanceof TouchEvent) {
			const touch = e.evt.touches?.[0] || e.evt.changedTouches?.[0];
			if (touch) {
				x = touch.clientX;
				y = touch.clientY;
			}
		} else {
			// Para eventos de mouse, usar clientX/clientY directamente
			x = e.evt?.clientX ?? e.evt?.x ?? null;
			y = e.evt?.clientY ?? e.evt?.y ?? null;
		}

		// Validar que las coordenadas sean válidas antes de establecerlas
		if (x == null || y == null || !isFinite(x) || !isFinite(y)) {
			console.warn("Invalid click coordinates:", x, y, e.evt);
			return;
		}

		//if (selectedTextIndex === null && selectedStickerIndex === null) {
		setClickedX(x);
		setClickedY(y);
		setSelectedTextIndex(null);
		setSelectedStickerIndex(null);
		setSelectedImageIndex(null);
		//}
		console.log("Click coordinates:", x, y);

		// const clickedTextIndex = textOnCanvas.findIndex(
		// TO DO: MIRAR SI ESTÀ ROTAT O ESCALAT L'STICKER
		//const clickedTextIndex = pages[currentPage].canvasTexts.findIndex(
		//	(text) => isClickInsideElementV2(x, y, text)
		/*x >= text.x &&
				x <= text.x + text.width &&
				y >= text.y &&
				y <= text.y + text.height*/
		//);

		// const clickedStickerIndex = stickersOnCanvas.findIndex((sticker) => {
		//const clickedStickerIndex = pages[currentPage].canvasStickers.findIndex(
		//	(sticker) => {
		// TO DO: MIRAR SI ESTÀ ROTAT O ESCALAT L'STICKER
		//console.log(sticker);
		//return (
		//	sticker.image && isClickInsideElementV2(x, y, sticker /*, "image"*/)
		//);
		/*x >= sticker.x &&
					x <= sticker.x + sticker.width &&
					y >= sticker.y &&
					y <= sticker.y + sticker.image.height*/
		//}
		//);

		/*if (clickedTextIndex !== -1) {
			//setEditingTextIndex(clickedTextIndex);
			//setSelectedStickerIndex(null);
			console.log("TEXT FOUND");
		} else if (clickedStickerIndex !== -1) {
			console.log("STICKER FOUND");
		} else {*/
		return;
		/*setTimeout(() => {
			if (selectedTextIndex === null && selectedStickerIndex === null) {
				console.log("NOT FOUND");
				setEditingTextIndex(null);
				setSelectedTextIndex(null);
				setSelectedStickerIndex(null);

				if (document.querySelector("canvas")) {
					x = x + document.querySelector("canvas").getBoundingClientRect().x;
					y = y + document.querySelector("canvas").getBoundingClientRect().y;
					let found = false;
					document
						.querySelectorAll(".template-item, *[data-template-item]")
						.forEach((element) => {
							if (
								x >= element.getBoundingClientRect().x &&
								x <=
									element.getBoundingClientRect().x +
										element.getBoundingClientRect().width &&
								y >= element.getBoundingClientRect().y &&
								y <=
									element.getBoundingClientRect().y +
										element.getBoundingClientRect().height &&
								!found
							) {
								found = true;
								const ev = document.createEvent("MouseEvent");
								ev.initMouseEvent(
									"click",
									true,
									true,
									window, //document.querySelector("#templates-container"),
									null,
									x,
									y,
									0,
									0,
									false,
									false,
									false,
									false,
									0,
									null
								);
								element.dispatchEvent(ev);
							}
						});
				}
			}
		}, 300);*/
	};

	const handleTextClick = (
		index,
		text,
		font,
		color,
		strokeColor,
		strokeWidth,
		align,
		fontSize,
	) => {
		setTextIndex(index);
		setModalText(text);
		setModalTextFont(font);
		setModalTextFontSize(fontSize ?? 32);
		setModalTextColor(color);
		setModalTextStrokeColor(strokeColor);
		setModalTextStrokeWidth(strokeWidth);
		setModalTextAlign(align || "left");
		setIsModalOpen(true);
	};

	const handleModalTextChange = (content, delta, source, editor) => {
		setModalText(content);
		setModalEditor(editor.getText(content));
		console.log(editor.getText(content));
	};

	const handleModalSave = () => {
		const auxPage = { ...pages[currentPage] };
		const updatedTexts = auxPage.canvasTexts.slice();
		const existing = updatedTexts[textIndex] || {};
		const canvasW = getCanvasWidth();

		// Bounding box y fontSize van por separado: no recalcular width/height desde el texto.
		// El usuario cambia texto, fuente y tamaño en el modal; la box se cambia con el transformer.
		const fontSize = Math.min(120, Math.max(8, Number(modalTextFontSize) || 8));
		const fontSizePercent = canvasW > 0 ? (fontSize / canvasW) * 100 : null;

		const currentText = {
			...existing,
			text: modalText || "",
			fontFamily: modalTextFont,
			fill: modalTextColor,
			stroke: modalTextStrokeColor,
			strokeWidth: modalTextStrokeWidth,
			align: modalTextAlign,
			fontSize,
			fontSizePercent,
		};
		updatedTexts.splice(textIndex, 1);

		auxPage.canvasTexts = [...updatedTexts];
		updateCurrentPage(auxPage);

		setIsModalOpen(false);

		setTimeout(() => {
			updatedTexts.push(currentText);
			auxPage.canvasTexts = [...updatedTexts];
			updateCurrentPage(auxPage);
		}, 250);
	};

	const handleModalCancel = () => {
		setIsModalOpen(false);
	};

	function handleDragStart(event) {
		const { active } = event;

		document.querySelector("html").style.overflow = "hidden";

		setActiveId(active.id);
	}

	function handleDragEnd(event) {
		const { active, over } = event;

		document.querySelector("html").style.overflow = "hidden";

		if (over && active.id !== over.id) {
			const oldIndex = pages.findIndex((p) => p.id === active.id);
			const newIndex = pages.findIndex((p) => p.id === over.id);

			if (oldIndex !== -1 && newIndex !== -1) {
				setPages((items) => {
					const oldIdx = items.findIndex((p) => p.id === active.id);
					const newIdx = items.findIndex((p) => p.id === over.id);

					if (oldIdx === -1 || newIdx === -1) {
						return items;
					}

					let newItems = arrayMove(items, oldIdx, newIdx);
					newItems.forEach((newItem, index) => {
						newItem.order = index;
					});
					newItems.sort((a, b) => a.order - b.order);

					// Guardar los cambios en el backend
					updatePages(newItems);

					return newItems;
				});

				// Actualizar la página actual si es necesario
				if (currentPage === oldIndex) {
					setCurrentPage(newIndex);
				} else if (oldIndex < currentPage && newIndex >= currentPage) {
					setCurrentPage(currentPage - 1);
				} else if (oldIndex > currentPage && newIndex <= currentPage) {
					setCurrentPage(currentPage + 1);
				}
			}
		}

		setActiveId(null);
	}

	const handleClose = () => {
		setContextMenu(null);
	};

	const tabbar = smallScreen; //size.width < 1200 && size.width / size.height < 21 / 29.7;
	// Bloquear cambio de plantilla solo cuando la página usa plantilla 23+ (predefinidas/menú).
	// Páginas con templateId 0, null o 1–22 (incl. páginas nuevas vacías) sí pueden cambiar.
	const tid =
		pages[currentPage]?.templateId ?? pages[currentPage]?.data?.templateId;
	const isTemplatesBlocked =
		selectedProject && pages[currentPage] && tid != null && tid >= 23;

	// No mostrar nada del editor hasta que Firebase y la guía estén cargados
	const guideNotLoaded = !selectedProject && !finishedLoading;
	if (initialLoading || guideNotLoaded) {
		return (
			<Box
				sx={{
					backgroundColor: "white",
					position: "fixed",
					top: 0,
					bottom: 0,
					left: 0,
					right: 0,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
					zIndex: 1000,
				}}
			>
				<CircularProgress size={32} sx={{ color: "#6366F1" }} />
				<Typography variant="body1" sx={{ marginTop: 2, fontWeight: "bold" }}>
					Cargando guía...
				</Typography>
			</Box>
		);
	}

	const handleProjectNameChange = async (newName) => {
		const name =
			(newName || "").trim() || (selectedProject?.name ?? "Nueva guía");
		if (!selectedProject?.id || name === (selectedProject?.name ?? "")) return;
		const prevName = selectedProject.name;
		setSelectedProject((prev) => (prev ? { ...prev, name } : null));
		if (selectedProject.isDemo || !user) return;
		try {
			await updateProject(
				selectedProject.id,
				name,
				backgroundColor,
				textColor,
				headerBackgroundColor,
				headerTextColor,
				fontFamily,
				false,
			);
		} catch (err) {
			console.error("Error updating project name:", err);
			setSelectedProject((prev) => (prev ? { ...prev, name: prevName } : null));
			enqueueSnackbar("No se pudo cambiar el título", { variant: "error" });
		}
	};

	return (
		<>
			{/* Barra superior coherente con el Dashboard */}
			<EditorHeader
				user={user}
				projectName={selectedProject?.name ?? "Mi guía"}
				isSaved={!showSaveLoading}
				isSaving={showSaveLoading}
				onProjectNameChange={handleProjectNameChange}
				onSave={() => (user ? savePages(selectedProject) : setShowLogin(true))}
				onPreview={async () => {
					if (!user) {
						setShowLogin(true);
						return;
					}
					if (!selectedProject?.id) {
						enqueueSnackbar("No hay proyecto seleccionado", {
							variant: "error",
						});
						return;
					}
					const previewWindow = window.open("about:blank", "_blank");
					if (previewWindow) {
						previewWindow.document.write(
							'<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">' +
							"<title>Cargando vista previa\u2026</title>" +
							'<link rel="preconnect" href="https://fonts.googleapis.com">' +
							'<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>' +
							'<link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap" rel="stylesheet">' +
							"</head>" +
							'<body style="margin:0;height:100vh;display:flex;align-items:center;justify-content:center;' +
							"background:linear-gradient(135deg,#f8fafc 0%,#e2e8f0 50%,#f1f5f9 100%);" +
							"font-family:'Poppins',system-ui,-apple-system,sans-serif;overflow:hidden\">" +
							'<div style="text-align:center;position:relative;z-index:1">' +
							'<div style="display:flex;align-items:center;justify-content:center;gap:8px;margin-bottom:16px">' +
							'<span class="d" style="animation-delay:0s"></span>' +
							'<span class="d" style="animation-delay:.15s"></span>' +
							'<span class="d" style="animation-delay:.3s"></span>' +
							'<span class="d" style="animation-delay:.45s"></span></div>' +
							'<p style="margin:0;font-size:13px;font-weight:500;color:#94a3b8;letter-spacing:.05em;' +
							'animation:f 1s ease-out both">Preparando vista previa\u2026</p></div>' +
							"<style>" +
							".d{width:8px;height:8px;border-radius:50%;background:linear-gradient(135deg,#6366F1,#8B5CF6);" +
							"animation:dot 1.4s ease-in-out infinite}" +
							"@keyframes dot{0%,80%,100%{transform:scale(.6);opacity:.4}40%{transform:scale(1);opacity:1}}" +
							"@keyframes f{0%{opacity:0;transform:translateY(10px)}100%{opacity:1;transform:translateY(0)}}" +
							"</style></body></html>",
						);
						previewWindow.document.close();
					}
					try {
						await savePages(selectedProject);
						const list = await getSharedGuides();
						const privateLink = Array.isArray(list)
							? list.find(
									(s) =>
										s.projectId === selectedProject.id && s.isPublic === false,
								)
							: null;
						const url = privateLink?.url;
						if (url) {
							if (previewWindow && !previewWindow.closed) {
								previewWindow.opener = null;
								previewWindow.location.href = url;
							}
							return;
						}
						const result = await createSharedGuide(selectedProject.id, false);
						const newUrl = result?.url ?? result?.shareUrl;
						if (newUrl) {
							if (previewWindow && !previewWindow.closed) {
								previewWindow.opener = null;
								previewWindow.location.href = newUrl;
							}
						} else {
							if (previewWindow && !previewWindow.closed) previewWindow.close();
							enqueueSnackbar("Error al generar la vista previa", {
								variant: "error",
							});
						}
					} catch (err) {
						if (previewWindow && !previewWindow.closed) previewWindow.close();
						console.error("Error opening preview:", err);
						enqueueSnackbar("Error al abrir la vista previa", {
							variant: "error",
						});
					}
				}}
				onShare={() => { if (user) { trackEditorAction("export_opened", selectedProject?.id); setShowExport(true); } else { setShowLogin(true); } }}
				onLogin={() => setShowLogin(true)}
				onLogout={handleLogout}
			/>

			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					//padding: 1,
					// Centrado horizontal, pero sin centrar verticalmente en desktop
					margin: smallScreen ? "auto" : "2px auto",
					justifyContent: smallScreen ? "center" : "flex-start",
					height: smallScreen ? "auto" : "calc(100vh - 61px)",
					overflow: "hidden",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						padding: 1,
						// Evita el centrado vertical (margin auto) en pantallas grandes
						margin: smallScreen ? "auto" : "0 auto",
						justifyContent: "center",
						gap: 2,
						"@media (max-width: 740px)": {
							width: "100%",
						},
						borderRadius: "20px",
						border: smallScreen ? "none" : "1px solid rgba(0, 0, 0, 0.04)",
					}}
				>
					<Box
						sx={{
							width: smallScreen ? "100%" : "undefined",
							display: "flex",
							flexDirection: size.width < 740 ? "column" : "row",
							//padding: 2,
							// Mantén el centrado horizontal sin centrar en vertical
							margin: smallScreen ? 0 : "0 auto",
							justifyContent: "center",
							//background: "linear-gradient(135deg, rgba(248, 250, 252, 0.9) 0%, rgba(241, 245, 249, 0.9) 100%)",
							borderRadius: "20px",
							position: "relative",
							maxHeight: "min(770px, calc(100vh - 80px))",
							maxWidth: smallScreen
								? "calc(min(100vw - 16px, 550px))"
								: "calc(100vw - 64px)",
							overflow: drawerOpen && tabbar ? "visible" : "hidden",
						}}
					>
						<Box
							sx={{
								display:
									drawerOpen &&
									size.width < 1200 &&
									size.width / size.height >= 21 / 29.7
										? "block"
										: "none",
								backgroundColor: "rgba(0,0,0,0.3)",
								position: "absolute",
								top: 0,
								left: 0,
								right: 0,
								bottom: 0,
								zIndex: 2,
							}}
							onClick={() => {
								setDrawerOpen(false);
							}}
						></Box>
						<Box
							sx={{
								width:
									size.width < 1200 ? (tabbar ? "100%" : "320px") : "460px",
								aspectRatio: size.width >= 1200 ? 21 / 29.7 : undefined,
								backgroundColor: "#fff",
								overflow: "auto",
								marginRight: tabbar ? 0 : 2,
								position: tabbar
									? "fixed"
									: size.width < 1200
										? "absolute"
										: "relative",
								top: tabbar ? (tabbar && selectedTab ? "auto" : "100%") : 0,
								bottom: tabbar && selectedTab ? 0 : "auto",
								left: 0,
								right: tabbar ? 0 : "auto",
								zIndex: tabbar && selectedTab ? 10000 : 2,
								height:
									size.width < 1200
										? tabbar
											? tabbar && selectedTab
												? "auto"
												: "auto"
											: "100%"
										: "auto",
								maxHeight: tabbar && selectedTab ? "80vh" : "none",
								transition: tabbar
									? "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease"
									: "transform 0.35s ease-in",
								transform: tabbar
									? selectedTab
										? "translateY(0)"
										: "translateY(100%)"
									: `translateX(${
											!drawerOpen && size.width < 1200 ? "-320px" : 0
										})`,
								opacity: tabbar ? (selectedTab ? 1 : 0) : 1,
								pointerEvents: tabbar
									? selectedTab
										? "auto"
										: "none"
									: "auto",
								boxShadow:
									tabbar && selectedTab
										? "0 -4px 20px rgba(0, 0, 0, 0.15), 0 -8px 40px rgba(0, 0, 0, 0.1)"
										: size.width < 1200 &&
											  drawerOpen &&
											  size.width / size.height >= 21 / 29.7
											? "5px 0 5px -2px rgba(0,0,0,0.05)"
											: "none",
								borderTopLeftRadius: tabbar && selectedTab ? "28px" : 0,
								borderTopRightRadius: tabbar && selectedTab ? "28px" : 0,
							}}
						>
							<Box
								sx={{
									padding: tabbar ? "24px 16px 110px" : 3,
								}}
							>
								{(!tabbar || (tabbar && selectedTab === "options")) && (
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											gap: 2,
											marginBottom: 3,
										}}
									>
										{/* Título de sección en tabbar */}
										{tabbar && (
											<Typography
												sx={{
													fontSize: 15,
													fontWeight: 600,
													color: "#64748b",
													marginBottom: 0.5,
												}}
											>
												Opciones
											</Typography>
										)}
										{/* Botones temporales para desarrollo - REMOVER EN PRODUCCIÓN 
										<Box
											sx={{
												display: "flex",
												flexDirection: "column",
												gap: 1,
												mb: 2,
											}}
										>
													<Link to="/home" style={{ textDecoration: "none" }}>
												<Button
													variant="contained"
													sx={{
														background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
														color: "white",
														textTransform: "none",
														fontWeight: 600,
														"&:hover": {
															background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
														},
													}}
													fullWidth
												>
													🏠 Home / Explorar
												</Button>
											</Link>
											<Link
												to="/pricing-demo"
													style={{ textDecoration: "none" }}
											>
												<Button
													variant="contained"
													sx={{
														backgroundColor: "#ff6b6b",
														color: "white",
														textTransform: "none",
														fontWeight: 600,
														"&:hover": {
															backgroundColor: "#ee5a5a",
														},
													}}
													fullWidth
												>
													🚀 Pricing Demo
												</Button>
											</Link>
										</Box>*/}
									</Box>
								)}
								{!tabbar && <Divider sx={{ margin: "16px 0px" }} />}
								{/* Mostrar plantillas siempre; en guías predefinidas se ven pero bloqueadas */}
								{(!tabbar || (tabbar && selectedTab === "templates")) && (
									<Box>
										{/* Título en modo tabbar */}
										{tabbar && (!selectedProject || isTemplatesBlocked) && (
											<Typography
												sx={{
													fontSize: 15,
													fontWeight: 600,
													color: "#1e293b",
													marginBottom: 1.5,
												}}
											>
												Plantillas
											</Typography>
										)}
										{!tabbar && (
											<Typography
												variant="h4"
												sx={{
													fontSize: 13,
													fontWeight: 600,
													color: "#475569",
													marginBottom: 2,
												}}
											>
												Plantillas{isTemplatesBlocked ? " (solo lectura)" : ""}
											</Typography>
										)}
										<Box sx={{ position: "relative" }}>
											{/* Overlay cuando es guía predefinida: se ven pero no se pueden elegir */}
											{isTemplatesBlocked && (
												<Box
													sx={{
														position: "absolute",
														top: 0,
														left: 0,
														right: 0,
														bottom: 0,
														backgroundColor: "rgba(255, 255, 255, 0.75)",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
														zIndex: 1,
														borderRadius: "8px",
														backdropFilter: "blur(2px)",
													}}
												>
													<Typography
														sx={{
															fontSize: 12,
															fontWeight: 600,
															color: "#64748b",
															textAlign: "center",
															px: 1,
														}}
													>
														{tid === 24
															? "Plantilla de menú — no se puede cambiar por otra"
															: "Guía predefinida — plantillas bloqueadas"}
													</Typography>
												</Box>
											)}
											<Box
												sx={{
													display: "flex",
													flexDirection: "row",
													overflow: "auto",
													paddingBottom: 2,
													gap: 2,
													pointerEvents: isTemplatesBlocked ? "none" : "auto",
													opacity: isTemplatesBlocked ? 0.85 : 1,
												}}
											>
												{/* Tarjeta "Menú" como primera opción cuando aún no hay página de menú */}
												{selectedProject &&
													!pages.some((p) => p.templateId === 24) && (
														<Box
															onClick={() => {
																if (pages.length >= maxPagesAllowed) {
																	setShowPageLimitModal(true);
																	return;
																}
																setPages((prevPages) => {
																	if (prevPages.length >= maxPagesAllowed)
																		return prevPages;
																	const maxOrder = prevPages.reduce(
																		(max, page) => {
																			const pageOrder =
																				page.data?.order !== undefined
																					? page.data.order
																					: (page.order ?? -1);
																			return Math.max(max, pageOrder);
																		},
																		-1,
																	);
																	const newMenuPage = {
																		id: -1 * new Date().getTime(),
																		templateId: 24,
																		order: maxOrder + 1,
																		images: [],
																		texts: [
																			{
																				content: "Plan de viaje",
																				isEditing: false,
																			},
																		],
																		canvasStickers: [],
																		canvasImages: [],
																		canvasTexts: [],
																		maps: [],
																		transport: [],
																		data: {
																			days: [],
																			infoLinks: [],
																			order: maxOrder + 1,
																		},
																	};
																	setCurrentPage(prevPages.length);
																	return [...prevPages, newMenuPage];
																});
															}}
															sx={{
																width: 70,
																height: 93,
																flexShrink: 0,
																borderRadius: "8px",
																display: "flex",
																flexDirection: "column",
																alignItems: "center",
																justifyContent: "center",
																gap: 0.5,
																background:
																	"linear-gradient(135deg, rgba(99, 102, 241, 0.12) 0%, rgba(139, 92, 246, 0.08) 100%)",
																border: "1px solid rgba(99, 102, 241, 0.25)",
																cursor: "pointer",
																transition: "all 0.2s ease",
																"&:hover": {
																	background:
																		"linear-gradient(135deg, rgba(99, 102, 241, 0.18) 0%, rgba(139, 92, 246, 0.12) 100%)",
																	borderColor: "rgba(99, 102, 241, 0.4)",
																	boxShadow:
																		"0 4px 12px rgba(99, 102, 241, 0.2)",
																},
															}}
														>
															<AddIcon
																sx={{ fontSize: 28, color: "#6366F1" }}
															/>
															<Typography
																sx={{
																	fontSize: 11,
																	fontWeight: 600,
																	color: "#4F46E5",
																}}
															>
																Menú
															</Typography>
														</Box>
													)}
												{[
													Template1,
													Template2,
													Template3,
													Template4,
													Template5,
													Template6,
													Template7,
													Template8,
													Template9,
													Template10,
													Template11,
													Template12,
													Template13,
													Template14,
													Template15,
													Template16,
													Template17,
													Template18,
													Template19,
													Template20,
													Template21,
													Template22,
												].map((Template, index) => (
													<Box
														onClick={() => handleTemplateClick(index)}
														sx={{
															position: "relative",
														}}
														key={Template.thumbnail + "-" + index}
													>
														<img
															key={index}
															src={Template.thumbnail}
															alt={`Template ${index + 1}`}
															style={{
																width: 70,
																cursor: "pointer",
																objectFit: "cover",
																borderRadius: 6,
															}}
														/>
														<Box
															sx={{
																width: 70,
																height: "100%",
																border:
																	index === currentTemplateIndex
																		? "5px solid #6366F1"
																		: "none",
																borderRadius: "6px",
																position: "absolute",
																top: 0,
																left: 0,
																padding: "12px",
																transition:
																	"border 0.3s ease-out, box-shadow 0.3s ease-out",
																boxShadow:
																	index === currentTemplateIndex
																		? "0 0 0 2px rgba(99, 102, 241, 0.2)"
																		: "none",
															}}
														></Box>
													</Box>
												))}
											</Box>
										</Box>
									</Box>
								)}
								{!tabbar && <Divider sx={{ margin: "0px 0px 20px" }} />}
								{(!tabbar || (tabbar && selectedTab === "stickers")) && (
									<>
										{tabbar && (
											<Typography
												sx={{
													fontSize: 15,
													fontWeight: 600,
													color: "#64748b",
													marginBottom: 1.5,
												}}
											>
												Stickers
											</Typography>
										)}
										{!tabbar && (
											<Typography
												variant="h4"
												sx={{
													fontSize: 13,
													fontWeight: 600,
													color: "#475569",
													marginBottom: 2,
												}}
											>
												Stickers
											</Typography>
										)}
										{/* CTA para abrir la modal de stickers personalizados */}
										<Box
											role="button"
											tabIndex={0}
											onClick={() => setCustomStickerModalOpen(true)}
											onKeyDown={(e) => {
												if (e.key === "Enter" || e.key === " ") {
													e.preventDefault();
													setCustomStickerModalOpen(true);
												}
											}}
											sx={{
												mb: 2,
												p: 1.25,
												display: "flex",
												alignItems: "center",
												gap: 1.25,
												borderRadius: 2,
												cursor: "pointer",
												background:
													"linear-gradient(135deg, #EEF2FF 0%, #F5F3FF 100%)",
												border: "1px solid #E0E7FF",
												transition: "transform 0.15s ease, box-shadow 0.15s ease",
												"&:hover": {
													transform: "translateY(-1px)",
													boxShadow: "0 6px 16px rgba(99,102,241,0.18)",
												},
												"&:focus-visible": {
													outline: "2px solid #6366F1",
													outlineOffset: 2,
												},
											}}
										>
											<Box
												sx={{
													width: 36,
													height: 36,
													borderRadius: "50%",
													background:
														"linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													color: "#fff",
													flexShrink: 0,
													boxShadow: "0 4px 10px rgba(99,102,241,0.35)",
												}}
											>
												<AutoAwesomeIcon sx={{ fontSize: 18 }} />
											</Box>
											<Box sx={{ minWidth: 0, flex: 1 }}>
												<Typography
													sx={{
														fontSize: 13,
														fontWeight: 700,
														color: "#312E81",
														lineHeight: 1.2,
													}}
												>
													Stickers personalizados
												</Typography>
												<Typography
													sx={{
														fontSize: 11,
														color: "#64748b",
														lineHeight: 1.3,
														whiteSpace: "nowrap",
														overflow: "hidden",
														textOverflow: "ellipsis",
													}}
												>
													Añade tu nombre al sticker
												</Typography>
											</Box>
											<Box
												sx={{
													fontSize: 10,
													fontWeight: 700,
													textTransform: "uppercase",
													letterSpacing: "0.06em",
													color: "#6366F1",
													backgroundColor: "#fff",
													px: 0.75,
													py: 0.25,
													borderRadius: 1,
													border: "1px solid #E0E7FF",
													flexShrink: 0,
												}}
											>
												Nuevo
											</Box>
										</Box>
										<Box
											sx={{
												display: "flex",
												overflowX: "auto",
												overflowY: "hidden",
												flexDirection: "column",
												width: "100%",
												minWidth: 0,
											}}
										>
											{stickerCollectionsLoading ? (
												<Box
													sx={{
														display: "flex",
														justifyContent: "center",
														width: "100%",
														py: 3,
													}}
												>
													<CircularProgress size={28} />
												</Box>
											) : (
												(() => {
													const cols = stickerCollections;
													const colsPerRow = Math.ceil(cols.length / 2) || 1;
													const cellWidth = 90 + 12;
													const row1 = cols.slice(0, colsPerRow);
													const row2 = cols.slice(colsPerRow);
													const renderCover = (col, colIdx) => (
														<Box
															key={col.id}
															sx={{
																position: "relative",
																cursor: "pointer",
																marginRight: "12px",
																flexShrink: 0,
																width: "90px",
															}}
															onClick={() => handleGroupCoverClick(colIdx)}
														>
															<img
																src={
																	col.coverUrl
																		? col.coverUrl.startsWith("http")
																			? col.coverUrl
																			: `${getApiOrigin()}${col.coverUrl}`
																		: ""
																}
																alt={col.title}
																style={{
																	width: "90px",
																	height: "90px",
																	borderRadius: "8px",
																	objectFit: "cover",
																}}
																onError={(e) => {
																	e.target.style.display = "none";
																}}
															/>
															<Box
																sx={{
																	width: "90px",
																	height: "90px",
																	border:
																		selectedGroupSticker === colIdx
																			? "5px solid #6366F1"
																			: "none",
																	borderRadius: "8px",
																	position: "absolute",
																	top: 0,
																	left: 0,
																	transition:
																		"border 0.3s ease-out, box-shadow 0.3s ease-out",
																	boxShadow:
																		selectedGroupSticker === colIdx
																			? "0 0 0 2px rgba(99, 102, 241, 0.2)"
																			: "none",
																	display: "flex",
																	alignItems: "flex-start",
																	justifyContent: "space-between",
																	pointerEvents: "none",
																}}
															>
																{!col.isPremium && (
																	<Box
																		sx={{
																			mt: 0.5,
																			ml: 0.5,
																			px: 0.75,
																			py: 0.25,
																			borderRadius: 1,
																			backgroundColor: "rgba(34, 197, 94, 0.9)",
																			fontSize: 9,
																			fontWeight: 700,
																			color: "white",
																			lineHeight: 1.1,
																			textTransform: "uppercase",
																			letterSpacing: "0.02em",
																		}}
																	>
																		Incluido gratis
																	</Box>
																)}
																{col.accessLevel === "sample" && (
																	<Box
																		sx={{
																			mt: 0.5,
																			ml: 0.5,
																			px: 0.75,
																			py: 0.25,
																			borderRadius: 1,
																			backgroundColor:
																				"rgba(99, 102, 241, 0.9)",
																			fontSize: 9,
																			fontWeight: 700,
																			color: "white",
																			lineHeight: 1.1,
																		}}
																	>
																		{col.freeStickerCount ?? 3} gratis
																	</Box>
																)}
																{col.isLocked && (
																	<Box sx={{ mt: 0.5, mr: 0.5 }}>
																		<LockIcon
																			sx={{
																				color: "white",
																				fontSize: 16,
																				filter:
																					"drop-shadow(0 1px 2px rgba(0,0,0,0.6))",
																			}}
																		/>
																	</Box>
																)}
															</Box>
														</Box>
													);
													const emptyCell = (key) => (
														<Box
															key={key}
															sx={{
																width: "90px",
																marginRight: "12px",
																flexShrink: 0,
															}}
														/>
													);
													const row2WithPlaceholders = [...row2];
													while (row2WithPlaceholders.length < colsPerRow) {
														row2WithPlaceholders.push(null);
													}
													return (
														<Box
															sx={{
																display: "flex",
																flexDirection: "column",
																flexShrink: 0,
																width: colsPerRow * cellWidth,
															}}
														>
															<Box
																sx={{
																	display: "flex",
																	flexDirection: "row",
																	flexShrink: 0,
																	marginBottom: "12px",
																}}
															>
																{row1.map((col, i) => renderCover(col, i))}
															</Box>
															<Box
																sx={{
																	display: "flex",
																	flexDirection: "row",
																	flexShrink: 0,
																}}
															>
																{row2WithPlaceholders.map((col, i) =>
																	col
																		? renderCover(col, colsPerRow + i)
																		: emptyCell(`empty-${i}`),
																)}
															</Box>
														</Box>
													);
												})()
											)}
										</Box>
										{/* Pack premium sin suscripción: bloque compacto */}
										{stickerCollections[selectedGroupSticker]?.isLocked &&
											(() => {
												const lockedCol =
													stickerCollections[selectedGroupSticker];
												const total = lockedCol?.totalStickers ?? 0;
												const previews = lockedCol?.previewUrls ?? [];
												return (
													<Box sx={{ mt: 2 }}>
														<Typography
															sx={{
																fontSize: 12,
																textTransform: "uppercase",
																fontWeight: 700,
																mb: 1,
																color: "#475569",
															}}
														>
															{lockedCol?.title}
														</Typography>
														<Box
															sx={{
																display: "flex",
																alignItems: "center",
																gap: "8px",
																overflowX: "auto",
																overflowY: "hidden",
																minWidth: 0,
																py: 1.5,
																px: 1.5,
																backgroundColor: "#f8f9fb",
																borderRadius: 2,
																userSelect: "none",
																WebkitOverflowScrolling: "touch",
															}}
														>
															{previews.map((url, i) => (
																<Box
																	key={i}
																	sx={{
																		position: "relative",
																		width: 48,
																		height: 48,
																		flexShrink: 0,
																	}}
																>
																	<img
																		src={
																			url.startsWith("http")
																				? url
																				: `${getApiOrigin()}${url}`
																		}
																		alt="preview"
																		style={{
																			width: 48,
																			height: 48,
																			objectFit: "contain",
																			borderRadius: 6,
																		}}
																		draggable={false}
																	/>
																	<Box
																		sx={{
																			position: "absolute",
																			inset: 0,
																			borderRadius: "6px",
																			background: "rgba(0,0,0,0.15)",
																			display: "flex",
																			alignItems: "center",
																			justifyContent: "center",
																		}}
																	>
																		<LockIcon
																			sx={{
																				color: "rgba(255,255,255,0.95)",
																				fontSize: 18,
																			}}
																		/>
																	</Box>
																</Box>
															))}
															<Box
																sx={{
																	width: 48,
																	height: 48,
																	borderRadius: "6px",
																	backgroundColor: "#e2e4f0",
																	display: "flex",
																	alignItems: "center",
																	justifyContent: "center",
																	flexShrink: 0,
																}}
															>
																<Typography
																	sx={{
																		fontSize: 14,
																		fontWeight: 700,
																		color: "#6366F1",
																		lineHeight: 1,
																	}}
																>
																	+{total}
																</Typography>
															</Box>
														</Box>
														<Box
															sx={{
																display: "flex",
																alignItems: "center",
																gap: 1,
																mt: 1.5,
															}}
														>
															<Button
																variant="contained"
																size="small"
																sx={{
																	textTransform: "none",
																	borderRadius: "16px",
																	backgroundColor: "#6366F1",
																	"&:hover": { backgroundColor: "#4F46E5" },
																	fontSize: 11,
																	px: 1.5,
																	py: 0.5,
																	lineHeight: 1.2,
																	minHeight: 0,
																	boxShadow: "none",
																}}
																onClick={() => setPurchaseModalOpen(true)}
															>
																Desbloquear pack
															</Button>
															<Typography
																sx={{ fontSize: 11, color: "#94a3b8" }}
															>
																{total} stickers con suscripción
															</Typography>
														</Box>
													</Box>
												);
											})()}
										{/* Sticker thumbnails (unlocked packs) */}
										{!stickerCollections[selectedGroupSticker]?.isLocked &&
											(() => {
												const currentCol =
													stickerCollections[selectedGroupSticker];
												const currentStickers =
													stickers[selectedGroupSticker] ?? [];
												const totalStickers =
													currentCol?.totalStickers ?? currentStickers.length;
												const detail = loadedCollectionDetails[currentCol?.id];
												const isSamplePack = detail?.accessLevel === "sample";
												let lockedPreviews = [];
												if (isSamplePack && detail) {
													const allPreviews = detail.previewUrls ?? [];
													const isFreeArr = detail.previewIsFree ?? [];
													lockedPreviews = allPreviews.filter(
														(_, i) => !isFreeArr[i],
													);
												}
												if (currentStickers.length === 0) {
													if (loadingCollectionId === currentCol?.id) {
														return (
															<Box
																sx={{
																	display: "flex",
																	justifyContent: "center",
																	width: "100%",
																	py: 3,
																}}
															>
																<CircularProgress size={24} />
															</Box>
														);
													}
													if (!isSamplePack) return null;
												}
												const visibleCount =
													currentStickers.length + lockedPreviews.length;
												const remaining = totalStickers - visibleCount;
												return (
													<Box sx={{ mt: 2 }}>
														<Typography
															sx={{
																fontSize: 12,
																textTransform: "uppercase",
																fontWeight: 700,
																mb: 1,
																color: "#475569",
															}}
														>
															{currentCol?.title}
														</Typography>
														<Box
															sx={{
																overflowX: "auto",
																overflowY: "hidden",
																display: "flex",
																alignItems: "center",
																gap: "8px",
																py: 1.5,
																px: 1.5,
																backgroundColor: "#f8f9fb",
																borderRadius: 2,
																userSelect: "none",
																WebkitOverflowScrolling: "touch",
															}}
														>
															{currentStickers.map((img, auxIndex) => (
																<img
																	key={img.id || auxIndex}
																	src={img.imagePath}
																	alt={`Sticker ${auxIndex + 1}`}
																	style={{
																		width: 48,
																		height: 48,
																		cursor: "pointer",
																		objectFit: "contain",
																		flexShrink: 0,
																		borderRadius: 6,
																	}}
																	crossOrigin="anonymous"
																	onClick={() =>
																		handleSelectSticker(
																			selectedGroupSticker,
																			auxIndex,
																		)
																	}
																	onContextMenu={(e) => e.preventDefault()}
																/>
															))}
															{isSamplePack &&
																lockedPreviews.map((url, i) => (
																	<Box
																		key={`locked-preview-${i}`}
																		sx={{
																			position: "relative",
																			width: 48,
																			height: 48,
																			flexShrink: 0,
																		}}
																	>
																		<img
																			src={
																				url.startsWith("http")
																					? url
																					: `${getApiOrigin()}${url}`
																			}
																			alt="preview"
																			style={{
																				width: 48,
																				height: 48,
																				objectFit: "contain",
																				borderRadius: 6,
																			}}
																			draggable={false}
																		/>
																		<Box
																			sx={{
																				position: "absolute",
																				inset: 0,
																				borderRadius: "6px",
																				background: "rgba(0,0,0,0.15)",
																				display: "flex",
																				alignItems: "center",
																				justifyContent: "center",
																			}}
																		>
																			<LockIcon
																				sx={{
																					color: "rgba(255,255,255,0.95)",
																					fontSize: 18,
																				}}
																			/>
																		</Box>
																	</Box>
																))}
															{remaining > 0 && (
																<Box
																	sx={{
																		width: 48,
																		height: 48,
																		borderRadius: "6px",
																		backgroundColor: "#e2e4f0",
																		display: "flex",
																		alignItems: "center",
																		justifyContent: "center",
																		flexShrink: 0,
																	}}
																>
																	<Typography
																		sx={{
																			fontSize: 14,
																			fontWeight: 700,
																			color: "#6366F1",
																			lineHeight: 1,
																		}}
																	>
																		+{remaining}
																	</Typography>
																</Box>
															)}
														</Box>
														{isSamplePack && (
															<Box
																sx={{
																	display: "flex",
																	alignItems: "center",
																	gap: 1,
																	mt: 1.5,
																}}
															>
																<Button
																	variant="contained"
																	size="small"
																	sx={{
																		textTransform: "none",
																		borderRadius: "16px",
																		backgroundColor: "#6366F1",
																		"&:hover": { backgroundColor: "#4F46E5" },
																		fontSize: 11,
																		px: 1.5,
																		py: 0.5,
																		lineHeight: 1.2,
																		minHeight: 0,
																		boxShadow: "none",
																	}}
																	onClick={() => setPurchaseModalOpen(true)}
																>
																	Desbloquear pack
																</Button>
																<Typography
																	sx={{ fontSize: 11, color: "#94a3b8" }}
																>
																	{totalStickers} stickers con suscripción
																</Typography>
															</Box>
														)}
													</Box>
												);
											})()}
									</>
								)}
								{!tabbar && <Divider sx={{ margin: "20px 0px" }} />}
								{/* OLD STICKER COVERS REMOVED - now loaded from API */}
								{false && "REMOVED_OLD_STICKER_COVERS"}
								{(!tabbar || (tabbar && selectedTab === "appearance")) && (
									<>
										{tabbar && (
											<Typography
												sx={{
													fontSize: 15,
													fontWeight: 600,
													color: "#64748b",
													marginBottom: 1.5,
												}}
											>
												Estilo
											</Typography>
										)}
										{!tabbar && (
											<Typography
												variant="h4"
												sx={{
													fontSize: 13,
													fontWeight: 600,
													color: "#475569",
													marginBottom: 2,
												}}
											>
												Apariencia
											</Typography>
										)}
										<Box
											sx={{
												display: "flex",
												flexDirection: "column",
												gap: 2.5,
												marginTop: !tabbar ? 2 : 0,
											}}
										>
											{/* Colores */}
											<Box
												sx={{
													display: "grid",
													gridTemplateColumns: {
														xs: "repeat(2, 1fr)",
														sm: "repeat(2, 1fr)",
														md: "repeat(4, 1fr)",
													},
													gap: 2,
												}}
											>
												{/* Color de fondo */}
												<Box
													sx={{
														display: "flex",
														flexDirection: "column",
														gap: 1.5,
													}}
												>
													<Typography
														variant="body2"
														sx={{
															fontSize: 10,
															textTransform: "uppercase",
															letterSpacing: 1.2,
															fontWeight: 600,
															color: "#475569",
														}}
													>
														Color de fondo
													</Typography>
													<Box
														sx={{
															position: "relative",
															width: "100%",
															height: 56,
															borderRadius: 2,
															overflow: "hidden",
															border: "2px solid rgba(148,163,184,0.2)",
															boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
															cursor: "pointer",
															transition: "all 0.2s ease",
															"&:hover": {
																borderColor: "rgba(99, 102, 241,0.4)",
																boxShadow: "0 4px 12px rgba(99, 102, 241,0.15)",
															},
														}}
													>
														<input
															type="color"
															value={backgroundColor}
															onChange={(e) =>
																setBackgroundColor(e.target.value)
															}
															style={{
																position: "absolute",
																top: 0,
																left: 0,
																width: "100%",
																height: "100%",
																border: "none",
																padding: 0,
																cursor: "pointer",
																opacity: 0,
															}}
														/>
														<Box
															sx={{
																position: "absolute",
																top: 0,
																left: 0,
																width: "100%",
																height: "100%",
																backgroundColor: backgroundColor,
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																pointerEvents: "none",
															}}
														/>
													</Box>
												</Box>

												{/* Color del texto */}
												<Box
													sx={{
														display: "flex",
														flexDirection: "column",
														gap: 1.5,
													}}
												>
													<Typography
														variant="body2"
														sx={{
															fontSize: 10,
															textTransform: "uppercase",
															letterSpacing: 1.2,
															fontWeight: 600,
															color: "#475569",
														}}
													>
														Color del texto
													</Typography>
													<Box
														sx={{
															position: "relative",
															width: "100%",
															height: 56,
															borderRadius: 2,
															overflow: "hidden",
															border: "2px solid rgba(148,163,184,0.2)",
															boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
															cursor: "pointer",
															transition: "all 0.2s ease",
															"&:hover": {
																borderColor: "rgba(99, 102, 241,0.4)",
																boxShadow: "0 4px 12px rgba(99, 102, 241,0.15)",
															},
														}}
													>
														<input
															type="color"
															value={textColor}
															onChange={(e) => setTextColor(e.target.value)}
															style={{
																position: "absolute",
																top: 0,
																left: 0,
																width: "100%",
																height: "100%",
																border: "none",
																padding: 0,
																cursor: "pointer",
																opacity: 0,
															}}
														/>
														<Box
															sx={{
																position: "absolute",
																top: 0,
																left: 0,
																width: "100%",
																height: "100%",
																backgroundColor: textColor,
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																pointerEvents: "none",
															}}
														/>
													</Box>
												</Box>

												{/* Fondo del encabezado */}
												<Box
													sx={{
														display: "flex",
														flexDirection: "column",
														gap: 1.5,
													}}
												>
													<Typography
														variant="body2"
														sx={{
															fontSize: 10,
															textTransform: "uppercase",
															letterSpacing: 1.2,
															fontWeight: 600,
															color: "#475569",
														}}
													>
														Fondo del encabezado
													</Typography>
													<Box
														sx={{
															position: "relative",
															width: "100%",
															height: 56,
															borderRadius: 2,
															overflow: "hidden",
															border: "2px solid rgba(148,163,184,0.2)",
															boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
															cursor: "pointer",
															transition: "all 0.2s ease",
															"&:hover": {
																borderColor: "rgba(99, 102, 241,0.4)",
																boxShadow: "0 4px 12px rgba(99, 102, 241,0.15)",
															},
														}}
													>
														<input
															type="color"
															value={headerBackgroundColor}
															onChange={(e) =>
																setHeaderBackgroundColor(e.target.value)
															}
															style={{
																position: "absolute",
																top: 0,
																left: 0,
																width: "100%",
																height: "100%",
																border: "none",
																padding: 0,
																cursor: "pointer",
																opacity: 0,
															}}
														/>
														<Box
															sx={{
																position: "absolute",
																top: 0,
																left: 0,
																width: "100%",
																height: "100%",
																backgroundColor: headerBackgroundColor,
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																pointerEvents: "none",
															}}
														/>
													</Box>
												</Box>

												{/* Texto del encabezado */}
												<Box
													sx={{
														display: "flex",
														flexDirection: "column",
														gap: 1.5,
													}}
												>
													<Typography
														variant="body2"
														sx={{
															fontSize: 10,
															textTransform: "uppercase",
															letterSpacing: 1.2,
															fontWeight: 600,
															color: "#475569",
														}}
													>
														Texto del encabezado
													</Typography>
													<Box
														sx={{
															position: "relative",
															width: "100%",
															height: 56,
															borderRadius: 2,
															overflow: "hidden",
															border: "2px solid rgba(148,163,184,0.2)",
															boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
															cursor: "pointer",
															transition: "all 0.2s ease",
															"&:hover": {
																borderColor: "rgba(99, 102, 241,0.4)",
																boxShadow: "0 4px 12px rgba(99, 102, 241,0.15)",
															},
														}}
													>
														<input
															type="color"
															value={headerTextColor}
															onChange={(e) =>
																setHeaderTextColor(e.target.value)
															}
															style={{
																position: "absolute",
																top: 0,
																left: 0,
																width: "100%",
																height: "100%",
																border: "none",
																padding: 0,
																cursor: "pointer",
																opacity: 0,
															}}
														/>
														<Box
															sx={{
																position: "absolute",
																top: 0,
																left: 0,
																width: "100%",
																height: "100%",
																backgroundColor: headerTextColor,
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																pointerEvents: "none",
															}}
														/>
													</Box>
												</Box>
											</Box>

											{/* Fuente */}
											<Box
												sx={{
													display: "flex",
													flexDirection: "column",
													gap: 1.5,
												}}
											>
												<Typography
													variant="body2"
													sx={{
														fontSize: 10,
														textTransform: "uppercase",
														letterSpacing: 1.2,
														fontWeight: 600,
														color: "#475569",
													}}
												>
													Fuente
												</Typography>
												{tabbar ? (
													<TextField
														select
														size="small"
														fullWidth
														value={fontFamily}
														onChange={(event) =>
															setFontFamily(event.target.value)
														}
														sx={{
															"& .MuiOutlinedInput-root": {
																borderRadius: "14px",
																backgroundColor: "rgba(255, 255, 255, 0.8)",
																border: "1px solid rgba(148, 163, 184, 0.2)",
																transition: "all 0.2s ease",
																"&:hover": {
																	borderColor: "rgba(99, 102, 241, 0.4)",
																	backgroundColor: "rgba(255, 255, 255, 0.95)",
																},
																"&.Mui-focused": {
																	borderColor: "#6366F1",
																	backgroundColor: "white",
																	boxShadow:
																		"0 0 0 3px rgba(99, 102, 241, 0.1)",
																},
															},
															"& .MuiOutlinedInput-notchedOutline": {
																border: "none",
															},
														}}
														SelectProps={{
															displayEmpty: true,
															MenuProps: {
																disablePortal: !tabbar,
																sx: tabbar ? { zIndex: 10002 } : undefined,
																anchorOrigin: {
																	vertical: "top",
																	horizontal: "left",
																},
																transformOrigin: {
																	vertical: "bottom",
																	horizontal: "left",
																},
																onOpen: () => {
																	// Pausar transiciones del overlay y panel cuando se abre el menú
																	if (tabbar) {
																		// Buscar overlay por su z-index y background
																		const allBoxes =
																			document.querySelectorAll(
																				'[style*="z-index"]',
																			);
																		allBoxes.forEach((box) => {
																			const style =
																				window.getComputedStyle(box);
																			if (
																				style.zIndex === "9998" &&
																				style.backgroundColor.includes(
																					"rgba(0, 0, 0, 0.4)",
																				)
																			) {
																				box.style.transition = "none";
																			}
																			if (
																				style.zIndex === "10000" &&
																				style.backgroundColor ===
																					"rgb(255, 255, 255)"
																			) {
																				box.style.transition = "none";
																			}
																		});
																	}

																	// Ajustar la posición del menú y hacer scroll a la fuente seleccionada
																	requestAnimationFrame(() => {
																		const menu =
																			document.querySelector(
																				".MuiPopover-paper",
																			);
																		if (menu && tabbar) {
																			const tabBarSpace = 96;
																			const availableHeight =
																				window.innerHeight - tabBarSpace - 40;
																			const desiredHeight = Math.min(
																				availableHeight,
																				window.innerHeight * 0.55,
																			);

																			menu.style.position = "fixed";
																			menu.style.bottom = "auto";
																			menu.style.top = "20px";
																			menu.style.left = "16px";
																			menu.style.right = "16px";
																			menu.style.width = "auto";
																			menu.style.maxHeight = `${desiredHeight}px`;
																			menu.style.transform = "none";
																			menu.style.opacity = "1";

																			setTimeout(() => {
																				const selectedItem = menu.querySelector(
																					`[data-value="${fontFamily}"]`,
																				);
																				if (selectedItem) {
																					selectedItem.scrollIntoView({
																						block: "center",
																						behavior: "smooth",
																					});
																				} else {
																					menu.scrollTop = 0;
																				}
																			}, 50);
																		}
																	});
																},
																onClose: () => {
																	// Restaurar transiciones del overlay y panel cuando se cierra el menú
																	if (tabbar) {
																		setTimeout(() => {
																			const allBoxes =
																				document.querySelectorAll(
																					'[style*="z-index"]',
																				);
																			allBoxes.forEach((box) => {
																				const style =
																					window.getComputedStyle(box);
																				if (
																					style.zIndex === "9998" &&
																					style.backgroundColor.includes(
																						"rgba(0, 0, 0, 0.4)",
																					)
																				) {
																					box.style.transition = "";
																				}
																				if (
																					style.zIndex === "10000" &&
																					style.backgroundColor ===
																						"rgb(255, 255, 255)"
																				) {
																					box.style.transition = "";
																				}
																			});
																		}, 100);
																	}
																},
																PaperProps: {
																	sx: {
																		zIndex: 10002,
																		maxHeight: "calc(100vh - 180px)",
																		overflow: "auto",
																	},
																},
															},
															renderValue: (value) =>
																value ? (
																	<Typography
																		sx={{
																			fontFamily: value + "!important",
																			fontSize: 13,
																		}}
																	>
																		{value}
																	</Typography>
																) : (
																	<em
																		style={{ color: "#94a3b8", fontSize: 13 }}
																	>
																		Seleccionar fuente
																	</em>
																),
														}}
													>
														{fontNames.map((fontName) => (
															<MenuItem
																key={fontName}
																value={fontName}
																data-value={fontName}
																sx={{ fontFamily: fontName + "!important" }}
															>
																{fontName}
															</MenuItem>
														))}
													</TextField>
												) : (
													<TextField
														select
														size="small"
														fullWidth
														value={fontFamily}
														onChange={(event) =>
															setFontFamily(event.target.value)
														}
														sx={{
															"& .MuiOutlinedInput-root": {
																borderRadius: "14px",
																backgroundColor: "rgba(255, 255, 255, 0.8)",
																border: "1px solid rgba(148, 163, 184, 0.2)",
																transition: "all 0.2s ease",
																"&:hover": {
																	borderColor: "rgba(99, 102, 241, 0.4)",
																	backgroundColor: "rgba(255, 255, 255, 0.95)",
																},
																"&.Mui-focused": {
																	borderColor: "#6366F1",
																	backgroundColor: "white",
																	boxShadow:
																		"0 0 0 3px rgba(99, 102, 241, 0.1)",
																},
															},
															"& .MuiOutlinedInput-notchedOutline": {
																border: "none",
															},
														}}
														SelectProps={{
															displayEmpty: true,
															MenuProps: {
																PaperProps: {
																	sx: {
																		maxHeight: "50vh",
																		overflow: "auto",
																	},
																},
															},
															renderValue: (value) =>
																value ? (
																	<Typography
																		sx={{
																			fontFamily: value + "!important",
																			fontSize: 13,
																		}}
																	>
																		{value}
																	</Typography>
																) : (
																	<em
																		style={{ color: "#94a3b8", fontSize: 13 }}
																	>
																		Seleccionar fuente
																	</em>
																),
														}}
													>
														{fontNames.map((fontName) => (
															<MenuItem
																key={fontName}
																value={fontName}
																sx={{ fontFamily: fontName + "!important" }}
															>
																{fontName}
															</MenuItem>
														))}
													</TextField>
												)}
											</Box>
										</Box>
									</>
								)}
								{!tabbar && <Divider sx={{ margin: "20px 0px" }} />}
								{(!tabbar || (tabbar && selectedTab === "add")) && (
									<>
										{tabbar && (
											<Typography
												sx={{
													fontSize: 15,
													fontWeight: 600,
													color: "#1e293b",
													marginBottom: 1.5,
												}}
											>
												Añadir contenido
											</Typography>
										)}
										{tabbar && (
											<Typography
												sx={{
													fontSize: 13,
													fontWeight: 600,
													color: "#64748b",
													marginBottom: 1,
												}}
											>
												Texto
											</Typography>
										)}
										{!tabbar && (
											<Typography
												variant="h4"
												sx={{
													fontSize: 13,
													fontWeight: 600,
													color: "#475569",
													marginBottom: 2,
												}}
											>
												Texto
											</Typography>
										)}
										<Box
											sx={{
												display: "flex",
												flexDirection: "column",
												gap: 1.5,
												marginTop: !tabbar ? 2 : 0,
											}}
										>
											<Box
												sx={{
													display: "flex",
													gap: 1.5,
													alignItems: "flex-start",
												}}
											>
												<TextField
													InputLabelProps={{ shrink: false }}
													variant="outlined"
													label=""
													placeholder="Escribe tu texto aquí..."
													multiline
													rows={3}
													size="small"
													fullWidth
													value={newTextValue}
													onChange={(e) => setNewTextValue(e.target.value)}
													sx={{
														"& .MuiOutlinedInput-root": {
															borderRadius: "14px",
															backgroundColor: "rgba(255, 255, 255, 0.8)",
															border: "1px solid rgba(148, 163, 184, 0.2)",
															transition: "all 0.2s ease",
															"&:hover": {
																borderColor: "rgba(99, 102, 241, 0.4)",
																backgroundColor: "rgba(255, 255, 255, 0.95)",
															},
															"&.Mui-focused": {
																borderColor: "#6366F1",
																backgroundColor: "white",
																boxShadow: "0 0 0 3px rgba(99, 102, 241, 0.1)",
															},
														},
														"& .MuiOutlinedInput-notchedOutline": {
															border: "none",
														},
													}}
												/>
												<Button
													variant="contained"
													onClick={handleAddText}
													disabled={!newTextValue || newTextValue.trim() === ""}
													sx={{
														minWidth: "auto",
														width: 48,
														height: 48,
														borderRadius: "14px",
														background:
															"linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
														boxShadow: "0 4px 12px rgba(99, 102, 241, 0.25)",
														"&:hover": {
															backgroundColor: "rgb(37, 99, 235)",
															boxShadow: "0 6px 16px rgba(99, 102, 241, 0.3)",
															transform: "translateY(-1px)",
														},
														"&:active": {
															transform: "scale(0.95)",
														},
														"&:disabled": {
															backgroundColor: "rgba(148, 163, 184, 0.15)",
															color: "rgba(148, 163, 184, 0.5)",
														},
														transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
													}}
												>
													<AddCircleOutlineIcon />
												</Button>
											</Box>
										</Box>
									</>
								)}
								{!tabbar && <Divider sx={{ margin: "20px 0px" }} />}
								{(!tabbar ||
									(tabbar &&
										(selectedTab === "notes" ||
											selectedTab === "add"))) && (
									<>
										{tabbar && (
											<Typography
												sx={{
													fontSize: 13,
													fontWeight: 600,
													color: "#64748b",
													marginBottom: 1,
													marginTop: 2,
												}}
											>
												Notas
											</Typography>
										)}
										{!tabbar && (
											<Typography
												variant="h4"
												sx={{
													fontSize: 13,
													fontWeight: 600,
													color: "#475569",
													marginBottom: 2,
												}}
											>
												Notas
											</Typography>
										)}
										<Box
											sx={{
												display: "flex",
												flexDirection: "column",
												gap: 1.5,
												marginTop: !tabbar ? 2 : 0,
											}}
										>
											<Button
												variant={isAddingNote ? "contained" : "outlined"}
												onClick={handleAddNoteMode}
												startIcon={<NoteIcon />}
												sx={{
													textTransform: "none",
													borderRadius: 2,
													backgroundColor: isAddingNote
														? "#6366F1"
														: "transparent",
													borderColor: "#6366F1",
													color: isAddingNote ? "white" : "#6366F1",
													"&:hover": {
														backgroundColor: isAddingNote
															? "rgb(37, 99, 235)"
															: "rgba(99, 102, 241, 0.1)",
														borderColor: "#6366F1",
													},
												}}
											>
												{isAddingNote
													? "Haz clic en la página para añadir nota"
													: "Añadir nota"}
											</Button>
											{isAddingNote && (
												<Typography
													variant="caption"
													sx={{
														fontSize: 11,
														color: "#64748b",
														fontStyle: "italic",
													}}
												>
													Haz clic en cualquier parte de la página para colocar
													la nota
												</Typography>
											)}
										</Box>
									</>
								)}
								{!tabbar && <Divider sx={{ margin: "20px 0px" }} />}
								{(!tabbar || (tabbar && selectedTab === "add")) && (
									<>
										{tabbar && (
											<Typography
												sx={{
													fontSize: 13,
													fontWeight: 600,
													color: "#64748b",
													marginBottom: 1,
													marginTop: 2,
												}}
											>
												Fotos
											</Typography>
										)}
										{!tabbar && (
											<Typography
												variant="h4"
												sx={{
													fontSize: 13,
													fontWeight: 600,
													color: "#475569",
													marginBottom: 2,
												}}
											>
												Imágenes
											</Typography>
										)}
										<Box
											sx={{
												display: "flex",
												flexDirection: "column",
												gap: 1.5,
												marginTop: !tabbar ? 2 : 0,
											}}
										>
											<input
												type="file"
												accept="image/*"
												onChange={async (event) => {
													// Prevenir múltiples ejecuciones simultáneas
													if (compressing || isProcessingImageRef.current) {
														event.target.value = "";
														return;
													}

													const rawFile = event.target.files[0];
													if (!rawFile) {
														event.target.value = "";
														return;
													}

													// Marcar que estamos procesando
													isProcessingImageRef.current = true;

													try {
														const file = await compressImage(rawFile);

														const toBase64 = (file) =>
															new Promise((resolve, reject) => {
																const reader = new FileReader();
																reader.readAsDataURL(file);
																reader.onload = () => resolve(reader.result);
																reader.onerror = reject;
															});

														if (file) {
															const base64Image = await toBase64(file);
															const imageId = -new Date().getTime();
															const selectedImage = {
																id: imageId,
																image: new Image(),
																imageUrl: base64Image,
																x:
																	document.querySelector(
																		".konvajs-content > canvas",
																	)?.offsetWidth - 240 || 560,
																y: 50,
																width: 200,
																height: 200,
																rotation: 0,
																scaleX: 1,
																scaleY: 1,
																skewX: 0,
																skewY: 0,
															};

															// Flag para evitar que onload se ejecute múltiples veces
															const imageAddedRef = { current: false };

															selectedImage.image.onload = async () => {
																// Verificar que la imagen no se haya añadido ya
																if (imageAddedRef.current) {
																	return;
																}
																imageAddedRef.current = true;

																const auxPage = { ...pages[currentPage] };

																if (!auxPage.canvasImages) {
																	auxPage.canvasImages = [];
																}

																// Verificar que la imagen con este ID no exista ya
																const imageExists = auxPage.canvasImages.some(
																	(img) => img.id === imageId,
																);
																if (imageExists) {
																	isProcessingImageRef.current = false;
																	return;
																}

																auxPage.canvasImages.push(selectedImage);
																updateCurrentPage(auxPage);
																isProcessingImageRef.current = false;

																if (!tabbar) {
																	setDrawerOpen(false);
																	document.querySelector("html").scrollTop = 0;
																}
															};

															selectedImage.image.onerror = (error) => {
																console.log(error);
																isProcessingImageRef.current = false;
															};

															selectedImage.image.src = base64Image;
														} else {
															isProcessingImageRef.current = false;
														}
													} catch (error) {
														console.error("Error al cargar la imagen:", error);
														isProcessingImageRef.current = false;
													}

													// Limpiar el input después de procesar
													event.target.value = "";
												}}
												ref={fileInputRef}
												style={{ display: "none" }}
											/>
											<Button
												variant="contained"
												fullWidth
												onClick={() => {
													fileInputRef.current.click();
												}}
												disabled={compressing}
												startIcon={
													compressing ? (
														<CircularProgress
															size={16}
															sx={{ color: "white" }}
														/>
													) : (
														<LuImagePlus size={18} />
													)
												}
												sx={{
													textTransform: "none",
													fontWeight: 600,
													padding: "14px 24px",
													borderRadius: "14px",
													background:
														"linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
													boxShadow: "0 4px 12px rgba(99, 102, 241, 0.25)",
													fontSize: 13,
													"&:hover": {
														backgroundColor: "rgb(37, 99, 235)",
														boxShadow: "0 6px 16px rgba(99, 102, 241, 0.3)",
														transform: "translateY(-1px)",
													},
													"&:active": {
														transform: "scale(0.98)",
													},
													"&:disabled": {
														backgroundColor: "rgba(148, 163, 184, 0.15)",
														color: "rgba(148, 163, 184, 0.5)",
													},
													transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
												}}
											>
												{compressing ? "Comprimiendo..." : "Seleccionar imagen"}
											</Button>
										</Box>
									</>
								)}

								{/* Panel de Páginas para tabbar móvil */}
								{tabbar && selectedTab === "pages" && (
									<>
										<Typography
											sx={{
												fontSize: 15,
												fontWeight: 600,
												color: "#1e293b",
												marginBottom: 1.5,
											}}
										>
											Páginas
										</Typography>

										{/* Lista de páginas con scroll horizontal */}
										<Box
											sx={{
												overflowX: "auto",
												overflowY: "visible",
												WebkitOverflowScrolling: "touch",
												paddingY: 2,
												marginX: -2,
												paddingX: 2,
											}}
										>
											<Box
												sx={{
													display: "flex",
													flexDirection: "row",
													gap: 1.5,
													padding: "8px 4px",
													width: "max-content",
													overflowY: "visible",
												}}
											>
												<DndContext
													sensors={sensors}
													collisionDetection={closestCenter}
													onDragStart={handleDragStart}
													onDragEnd={handleDragEnd}
												>
													<SortableContext
														items={pages}
														strategy={horizontalListSortingStrategy}
													>
														{pages.map((page, index) => {
															const isDragging = activeId === page.id;
															return (
																<SortableItem key={page.id} id={page.id}>
																	{({ dragListeners, dragAttributes }) => (
																		<Box
																			{...dragAttributes}
																			{...dragListeners}
																			sx={{
																				flexShrink: 0,
																				backgroundColor:
																					index === currentPage
																						? "#6366F1"
																						: "rgba(255,255,255,0.95)",
																				border:
																					index === currentPage
																						? "2px solid #6366F1"
																						: "2px solid rgba(0,0,0,0.08)",
																				borderRadius: "14px",
																				display: "flex",
																				justifyContent: "center",
																				alignItems: "center",
																				height: 60,
																				width: 60,
																				position: "relative",
																				userSelect: "none",
																				//touchAction: "none", // Prevenir scroll durante drag en móvil
																				transition: isDragging
																					? "none"
																					: "all 0.2s ease",
																				boxShadow:
																					index === currentPage
																						? "0 4px 16px rgba(99, 102, 241,0.35)"
																						: "0 2px 8px rgba(0,0,0,0.06)",
																				cursor: isDragging
																					? "grabbing"
																					: "grab",
																			}}
																			onClick={(e) => {
																				// El delay del TouchSensor permite que los taps funcionen antes de activar el drag
																				if (!activeId) {
																					e.preventDefault();
																					e.stopPropagation();
																					setCurrentPage(index);
																					setCurrentTemplateIndex(
																						page.templateId,
																					);
																					setClickedX(null);
																					setClickedY(null);
																					setSelectedTextIndex(null);
																					setSelectedStickerIndex(null);
																					setSelectedImageIndex(null);
																					//setSelectedTab(null);
																				}
																			}}
																		>
																			<Typography
																				variant="body2"
																				sx={{
																					fontWeight: 700,
																					fontSize: "18px",
																					color:
																						index === currentPage
																							? "white"
																							: "#334155",
																					userSelect: "none",
																				}}
																			>
																				{index + 1}
																			</Typography>
																			{/* Botón eliminar */}
																			{currentPage === index &&
																				pages.length > 1 && (
																					<IconButton
																						size="small"
																						sx={{
																							position: "absolute",
																							top: -8,
																							right: -8,
																							width: 22,
																							height: 22,
																							backgroundColor: "#ef4444",
																							color: "white",
																							boxShadow:
																								"0 2px 6px rgba(239,68,68,0.4)",
																							zIndex: 10,
																							"&:hover": {
																								backgroundColor: "#dc2626",
																							},
																						}}
																						onClick={(e) => {
																							e.stopPropagation();
																							let newIndex =
																								index === pages.length - 1
																									? index - 1
																									: index;
																							setCurrentPage(newIndex);
																							setCurrentTemplateIndex(
																								pages[
																									newIndex === index
																										? index + 1
																										: newIndex
																								].templateId,
																							);
																							setPages((prev) => [
																								...prev
																									.filter((_, i) => i !== index)
																									.map((p, i) => {
																										p.order = i;
																										return p;
																									}),
																							]);
																						}}
																					>
																						<Close sx={{ fontSize: "12px" }} />
																					</IconButton>
																				)}
																		</Box>
																	)}
																</SortableItem>
															);
														})}
													</SortableContext>
													<DragOverlay dropAnimation={null}>
														{activeId
															? (() => {
																	const dragIndex = pages.findIndex(
																		(p) => p.id === activeId,
																	);
																	const isActive = dragIndex === currentPage;
																	return (
																		<Box
																			sx={{
																				backgroundColor: isActive
																					? "#6366F1"
																					: "rgba(255,255,255,0.95)",
																				border: isActive
																					? "2px solid #6366F1"
																					: "2px solid rgba(0,0,0,0.08)",
																				borderRadius: "14px",
																				display: "flex",
																				justifyContent: "center",
																				alignItems: "center",
																				height: 60,
																				width: 60,
																				boxShadow:
																					"0 8px 24px rgba(99, 102, 241,0.45)",
																				transform: "scale(1.08)",
																				cursor: "grabbing",
																			}}
																		>
																			<Typography
																				variant="body2"
																				sx={{
																					fontWeight: 700,
																					fontSize: "18px",
																					color: isActive ? "white" : "#334155",
																					userSelect: "none",
																				}}
																			>
																				{dragIndex + 1}
																			</Typography>
																		</Box>
																	);
																})()
															: null}
													</DragOverlay>
												</DndContext>

												{/* Botón añadir página */}
												<Box
													sx={{
														flexShrink: 0,
														backgroundColor: "rgba(255,255,255,0.95)",
														border: "2px dashed rgba(99, 102, 241,0.4)",
														borderRadius: "14px",
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
														height: 60,
														width: 60,
														cursor:
															pages.length >= maxPagesAllowed
																? "not-allowed"
																: "pointer",
														opacity: pages.length >= maxPagesAllowed ? 0.5 : 1,
														transition: "all 0.2s ease",
														"&:hover":
															pages.length >= maxPagesAllowed
																? {}
																: {
																		backgroundColor: "rgba(99, 102, 241,0.08)",
																		borderColor: "#6366F1",
																	},
														"&:active":
															pages.length >= maxPagesAllowed
																? {}
																: {
																		transform: "scale(0.95)",
																	},
													}}
													title={
														pages.length >= maxPagesAllowed
															? `Máximo ${maxPagesAllowed} páginas por guía`
															: "Añadir página"
													}
													onClick={tryAddPage}
												>
													<AddCircleOutlineIcon
														sx={{
															fontSize: "26px",
															color: "#6366F1",
														}}
													/>
												</Box>
											</Box>
										</Box>
									</>
								)}

								{!tabbar && <Divider sx={{ margin: "20px 0px" }} />}

								{/** Links */}

								{/*<Box>
							<span style={{ opacity: !editTemplate ? 1.0 : 0.5 }}>
								Plantilla
							</span>
							<Switch
								checked={editTemplate}
								onChange={() => setEditTemplate(!editTemplate)}
							/>
							<span style={{ opacity: editTemplate ? 1.0 : 0.5 }}>Canvas</span>
							</Box>*/}
							</Box>
						</Box>

						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								width: smallScreen
									? 550 //(height - 0 - 45) * (21 / 29.7)
									: 550,
								height: smallScreen ? height - 88 + 43 : 770,
								//maxWidth: smallScreen ? undefined : "100%",
								maxHeight: smallScreen
									? undefined
									: "min(770px, calc(100vh - 82px))",
								margin: smallScreen ? "auto" : "0",
								// En móvil con tabbar, usar maxHeight calculado restando header y tab bar
								...(smallScreen && tabbar
									? {
											maxWidth: "100%",
											width: "550px",
											height: !isMobile
												? "calc(min(100vh - 175px, 765px))"
												: "calc(min(100vh - 235px, 765px))",
											maxHeight: !isMobile
												? "calc(min(100vh - 175px, 765px))"
												: "calc(min(100vh - 235px, 765px))",
											minHeight: !isMobile
												? "calc(min(100vh - 175px, 765px))"
												: "calc(min(100vh - 235px, 765px))",
											//maxHeight: `calc(100vh - 148px - 84px)`, // 148px: header (logo 140px + margin 8px), 84px: tab bar (72px height + 12px bottom)
											//height: "100%", // Permitir que use toda la altura disponible hasta el maxHeight
										}
									: {}),
								// Ajuste específico para Safari en móvil con tabbar
								...(isSafari && isMobile && smallScreen && tabbar
									? newSafari
										? {
												maxWidth: "100%",
												width: "550px",
												height: "calc(min(100vh - 220px, 765px))",
												maxHeight: "calc(min(100vh - 220px, 0px), 765px))",
												minHeight: "calc(min(100vh - 220px, 0px), 765px))",
											}
										: {
												maxWidth: "100%",
												width: "550px",
												height:
													"calc(min(100vh - 260px - env(safe-area-inset-bottom, 0px), 765px))",
												maxHeight:
													"calc(min(100vh - 260px - env(safe-area-inset-bottom, 0px), 765px))",
												minHeight:
													"calc(min(100vh - 260px - env(safe-area-inset-bottom, 0px), 765px))",
												//maxHeight: `calc(100vh - 148px - 84px - env(safe-area-inset-bottom, 0px))`,
											}
									: {}),
							}}
						>
							<Box
								sx={{
									//backgroundColor: "white",
									flex: 1,
									flexGrow: 1,
									overflow: "hidden",
									height: "100%",
									...(smallScreen && tabbar
										? {
												maxHeight: "100%", // Respetar el maxHeight del padre
											}
										: {}),
								}}
								id="main-canvas-ref"
								ref={mainCanvasRef}
							>
								<Box
									sx={{
										position: "relative",
										backgroundColor: "#FFF",
										width: "100%",
										maxWidth: "100%",
										flex: 0,
										height: "100%",
										overflow: "hidden",
										//height: height,
									}}
								>
								<Box
									id="templates-container"
									sx={{
										outline: "1px solid rgba(0, 0, 0, 0.04)",
										borderRadius: "12px",
										overflowY:
											pages[currentPage]?.templateId === 100 /* ||
											pages[currentPage]?.templateId === 102 ||
											pages[currentPage]?.templateId === 103 ||
											pages[currentPage]?.templateId === 104*/
												? "hidden"
												: "auto",
										overflowX: "hidden",
										overscrollBehavior: "none",
										aspectRatio: undefined,
											backgroundColor: backgroundColor,
											transform: "none",
											transformOrigin: "top left",
											position: "relative",
											top: 0,
											left: 0,
											width: "100%",
											height: "100%",
											minHeight: undefined,
											// Template 100/102/103/104: pointer-events none en contenedor; los [data-template-item] y scroll reciben clics
											// Template 101 (Travel Kit): encima del canvas para que los iconos reciban clics directamente
											/*zIndex:
												pages[currentPage]?.templateId === 100 ||
												pages[currentPage]?.templateId === 102 ||
												pages[currentPage]?.templateId === 101 ||
												pages[currentPage]?.templateId === 103 ||
												pages[currentPage]?.templateId === 104
													? 1053
													: undefined,
											pointerEvents:
												pages[currentPage]?.templateId === 100 ||
												pages[currentPage]?.templateId === 102 ||
												pages[currentPage]?.templateId === 103 ||
												pages[currentPage]?.templateId === 104
													? "none"
													: pages[currentPage]?.templateId === 101
													? "auto"
													: undefined,*/
											//height: "848.57px",
											"& label *": {
												fontFamily: "Nunito Sans!important",
											},
											"& button": {
												fontFamily: "Nunito Sans!important",
											},
											"& ul": {
												margin: "0!important",
											},
											...((pages[currentPage]?.templateId === 23 ||
												pages[currentPage]?.templateId >= 25) && {
												"& > * > *:first-child": { zIndex: 10002 },
											}),
										}}
									>
										<ImageBaseUrlProvider value={editorImageBaseUrl}>
											{/* Overlay de loading al guardar */}
											{showSaveLoading && (
												<Box
													sx={{
														position: "absolute",
														top: 0,
														left: 0,
														right: 0,
														bottom: 0,
														width: "100%",
														height: smallScreen ? "100%" : "770px",
														minHeight: "100%",
														backgroundColor: "white",
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
														flexDirection: "column",
														zIndex: 1100,
														borderRadius: "12px",
													}}
												>
													<CircularProgress
														size={32}
														sx={{ color: "#6366F1" }}
													/>
													<Typography
														variant="body1"
														sx={{ marginTop: 2, fontWeight: "bold" }}
													>
														Guardando...
													</Typography>
												</Box>
											)}
											{pages[currentPage]?.templateId === 23 ? (
												<Template23
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 24 ? (
												<Template24
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onNavigateToPage={handleNavigateToPage}
													pages={pages}
												/>
											) : pages[currentPage]?.templateId === 25 ? (
												<Template25
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 26 ? (
												<Template26
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 27 ? (
												<Template27
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 28 ? (
												<Template28
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 29 ? (
												<Template29
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 30 ? (
												<Template30
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 31 ? (
												<Template31
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 32 ? (
												<Template32
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 33 ? (
												<Template33
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 34 ? (
												<Template34
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 35 ? (
												<Template35
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 36 ? (
												<Template36
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 37 ? (
												<Template37
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 38 ? (
												<Template38
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 39 ? (
												<Template39
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 40 ? (
												<Template40
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 41 ? (
												<Template41
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 42 ? (
												<Template42
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 43 ? (
												<Template43
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 50 ? (
												<Template50
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onNavigateToPage={handleNavigateToPage}
													pages={pages}
												/>
											) : pages[currentPage]?.templateId === 51 ? (
												<Template51
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 52 ? (
												<Template52
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 53 ? (
												<Template53
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 54 ? (
												<Template54
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 55 ? (
												<Template55
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 56 ? (
												<Template56
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 57 ? (
												<Template57
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 58 ? (
												<Template58
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 59 ? (
												<Template59
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 60 ? (
												<Template60
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 61 ? (
												<Template61
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 62 ? (
												<Template62
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 65 ? (
												<Template65
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 70 ? (
												<Template70
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 71 ? (
												<Template71
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onNavigateToPage={handleNavigateToPage}
													pages={pages}
												/>
											) : pages[currentPage]?.templateId === 72 ? (
												<Template72
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 73 ? (
												<Template73
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 74 ? (
												<Template74
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 75 ? (
												<Template75
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 76 ? (
												<Template76
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 77 ? (
												<Template77
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 78 ? (
												<Template78
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 79 ? (
												<Template79
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 80 ? (
												<Template80
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 81 ? (
												<Template81
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 82 ? (
												<Template82
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 83 ? (
												<Template83
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 84 ? (
												<Template84
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 85 ? (
												<Template85
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 86 ? (
												<Template86
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 87 ? (
												<Template87
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 88 ? (
												<Template88
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 89 ? (
												<Template89
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 90 ? (
												<Template90
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 91 ? (
												<Template91
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 92 ? (
												<Template92
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 93 ? (
												<Template93
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 94 ? (
												<Template94
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 95 ? (
												<Template95
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 96 ? (
												<Template96
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 97 ? (
												<Template97
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 98 ? (
												<Template98
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 99 ? (
												<Template99
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 100 ? (
												<Template100
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													registerScrollContainer={(ref) => {
														template100ScrollRef.current = ref;
													}}
												/>
											) : pages[currentPage]?.templateId === 101 ? (
												<Template101
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 102 ? (
												<Template102
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 103 ? (
												<Template103
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 104 ? (
												<Template104
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 105 ? (
												<Template105
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 106 ? (
												<Template106
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 110 ? (
												<Template110
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onNavigateToPage={handleNavigateToPage}
													pages={pages}
												/>
											) : pages[currentPage]?.templateId === 111 ? (
												<Template111
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 112 ? (
												<Template112
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 113 ? (
												<Template113
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 114 ? (
												<Template114
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 115 ? (
												<Template115
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 116 ? (
												<Template116
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 117 ? (
												<Template117
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 118 ? (
												<Template118
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 119 ? (
												<Template119
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 120 ? (
												<Template120
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 121 ? (
												<Template121
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 122 ? (
												<Template122
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 123 ? (
												<Template123
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 124 ? (
												<Template124
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 125 ? (
												<Template125
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 126 ? (
												<Template126
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 127 ? (
												<Template127
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 128 ? (
												<Template128
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 129 ? (
												<Template129
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onNavigateToPage={handleNavigateToPage}
													pages={pages}
												/>
											) : pages[currentPage]?.templateId === 130 ? (
												<Template130
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 131 ? (
												<Template131
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 132 ? (
												<Template132
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 133 ? (
												<Template133
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 134 ? (
												<Template134
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 135 ? (
												<Template135
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 136 ? (
												<Template136
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 137 ? (
												<Template137
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 138 ? (
												<Template138
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 139 ? (
												<Template139
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 140 ? (
												<Template140
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 141 ? (
												<Template141
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 142 ? (
												<Template142
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 143 ? (
												<Template143
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 144 ? (
												<Template144
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 145 ? (
												<Template145
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 146 ? (
												<Template146
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 147 ? (
												<Template147
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : pages[currentPage]?.templateId === 150 ? (
												<Template150
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onNavigateToPage={handleNavigateToPage}
													pages={pages}
													prebuiltGuideId={selectedProject?.prebuiltGuideId}
												/>
											) : ((tid) =>
													(tid >= 151 && tid <= 233) ||
													(tid >= 246 && tid <= 9999))(
													pages[currentPage]?.templateId,
											  ) ? (
												(() => {
													const tid = pages[currentPage]?.templateId;
													const TemplateComponent = {
														151: Template151,
														152: Template152,
														153: Template153,
														154: Template154,
														155: Template155,
														156: Template156,
														157: Template157,
														158: Template158,
														159: Template159,
														160: Template160,
														161: Template161,
														162: Template162,
														163: Template163,
														164: Template164,
														165: Template165,
														166: Template166,
														167: Template167,
														168: Template168,
														169: Template169,
														170: Template170,
														171: Template171,
														172: Template172,
														173: Template173,
														174: Template174,
														175: Template175,
														176: Template176,
														177: Template177,
														178: Template178,
														179: Template179,
														180: Template180,
														181: Template181,
														182: Template182,
														183: Template183,
														184: Template184,
														185: Template185,
														186: Template186,
														187: Template187,
														188: Template188,
														189: Template189,
														190: Template190,
														191: Template191,
														192: Template192,
														193: Template193,
														194: Template194,
														195: Template195,
														196: Template196,
														197: Template197,
														198: Template198,
														199: Template199,
														200: Template200,
														201: Template201,
														202: Template202,
														203: Template203,
														204: Template204,
														205: Template205,
														206: Template206,
														207: Template207,
														208: Template208,
														209: Template209,
														210: Template210,
														211: Template211,
														212: Template212,
														213: Template213,
														214: Template214,
														215: Template215,
														216: Template216,
														217: Template217,
														218: Template218,
														219: Template219,
														220: Template220,
														221: Template221,
														222: Template222,
														223: Template223,
														224: Template224,
														225: Template225,
														226: Template226,
														227: Template227,
														228: Template228,
														229: Template229,
														230: Template230,
														231: Template231,
														232: Template232,
														233: Template233,
														246: Template246,
														247: Template247,
														248: Template248,
														249: Template249,
														250: Template250,
														251: Template251,
														252: Template252,
														253: Template253,
														254: Template254,
														255: Template255,
														256: Template256,
														257: Template257,
														258: Template258,
														259: Template259,
														260: Template260,
														261: Template261,
														262: Template262,
														263: Template263,
														264: Template264,
														265: Template265,
														266: Template266,
														267: Template267,
														268: Template268,
														269: Template269,
														270: Template270,
														271: Template271,
														272: Template272,
														273: Template273,
														274: Template274,
														275: Template275,
														276: Template276,
														277: Template277,
														278: Template278,
														279: Template279,
														280: Template280,
														281: Template281,
														282: Template282,
														283: Template283,
														284: Template284,
														285: Template285,
														286: Template286,
														287: Template287,
														288: Template288,
														289: Template289,
														290: Template290,
														291: Template291,
														293: Template293,
														294: Template294,
														295: Template295,
														296: Template296,
														297: Template297,
														298: Template298,
														299: Template299,
														300: Template300,
														301: Template301,
														302: Template302,
														303: Template303,
														304: Template304,
														305: Template305,
														309: Template309,
														310: Template310,
														311: Template311,
														312: Template312,
														313: Template313,
														314: Template314,
														315: Template315,
														316: Template316,
														317: Template317,
														318: Template318,
														319: Template319,
														324: Template324,
														325: Template325,
														326: Template326,
														327: Template327,
														328: Template328,
														330: Template330,
														331: Template331,
														332: Template332,
														333: Template333,
														334: Template334,
														335: Template335,
														336: Template336,
														337: Template337,
														338: Template338,
														339: Template339,
														340: Template340,
													}[tid];
													return TemplateComponent ? (
														<TemplateComponent
															headerTextColor={headerTextColor}
															headerBackgroundColor={headerBackgroundColor}
															backgroundColor={backgroundColor}
															textColor={textColor}
															fontFamily={fontFamily}
															page={safeCurrentPage}
															updatePage={(auxPage) =>
																updateCurrentPage(auxPage)
															}
															onNavigateToPage={
																tid === 168 ||
																tid === 129 ||
																tid === 303 ||
																tid === 304 ||
																tid === 305 ||
																tid === 310
																	? handleNavigateToPage
																	: undefined
															}
															pages={
																tid === 168 ||
																tid === 129 ||
																tid === 303 ||
																tid === 304 ||
																tid === 305 ||
																tid === 310
																	? pages
																	: undefined
															}
															prebuiltGuideId={selectedProject?.prebuiltGuideId}
															onMapFullscreenChange={setMapFullscreenActive}
														/>
													) : null;
												})()
											) : pages[currentPage]?.templateId === 63 ? (
												<Template63
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : pages[currentPage]?.templateId === 64 ? (
												<Template64
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
													onMapFullscreenChange={setMapFullscreenActive}
												/>
											) : currentTemplateIndex === 0 ? (
												<Template1
													key={`template-1-${currentPage}`}
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 1 ? (
												<Template2
													key={`template-2-${currentPage}`}
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 2 ? (
												<Template3
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 3 ? (
												<Template4
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 4 ? (
												<Template5
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 5 ? (
												<Template6
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 6 ? (
												<Template7
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 7 ? (
												<Template8
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 8 ? (
												<Template9
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 9 ? (
												<Template10
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 10 ? (
												<Template11
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 11 ? (
												<Template12
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 12 ? (
												<Template13
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 13 ? (
												<Template14
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 14 ? (
												<Template15
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 15 ? (
												<Template16
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 16 ? (
												<Template17
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 17 ? (
												<Template18
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 18 ? (
												<Template19
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 19 ? (
												<Template20
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : currentTemplateIndex === 20 ? (
												<Template21
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											) : (
												<Template22
													headerTextColor={headerTextColor}
													headerBackgroundColor={headerBackgroundColor}
													backgroundColor={backgroundColor}
													textColor={textColor}
													fontFamily={fontFamily}
													page={safeCurrentPage}
													updatePage={(auxPage) => updateCurrentPage(auxPage)}
												/>
											)}
									</ImageBaseUrlProvider>
									{/* Renderizar notas dentro de templates-container para que hagan scroll con el contenido */}
									{pages[currentPage]?.notes &&
										pages[currentPage].notes.length > 0 && (
											<Box
												data-viewer-notes
												sx={{
													position: "absolute",
													top: 0,
													left: 0,
													width: "100%",
													height: `${canvasDimensions.height}px`,
													pointerEvents: "none",
													zIndex: 1053,
												}}
											>
												{pages[currentPage].notes.map((note) => (
													<Box
														key={note.id}
														sx={{
															position: "absolute",
															left: `${note.x}%`,
															top: `${note.y}%`,
															pointerEvents: "auto",
														}}
													>
														<Note
															note={note}
															editMode={editTemplate}
															onEdit={handleEditNote}
															onDelete={handleDeleteNote}
														/>
													</Box>
												))}
											</Box>
										)}
								</Box>
									{isAddingNote && (
										<Box
											sx={{
												position: "absolute",
												top: 16,
												left: "50%",
												transform: "translateX(-50%)",
												zIndex: 99999,
												pointerEvents: "auto",
												display: "flex",
												alignItems: "center",
												gap: 1,
												backgroundColor: "#6366F1",
												color: "white",
												borderRadius: "12px",
												padding: "10px 16px",
												boxShadow:
													"0 4px 20px rgba(99, 102, 241, 0.4)",
												animation: "fadeInNote 0.25s ease-out",
												"@keyframes fadeInNote": {
													from: {
														opacity: 0,
														transform:
															"translateX(-50%) translateY(-8px)",
													},
													to: {
														opacity: 1,
														transform:
															"translateX(-50%) translateY(0)",
													},
												},
											}}
										>
											<NoteIcon
												sx={{ fontSize: 18, flexShrink: 0 }}
											/>
											<Typography
												sx={{
													fontSize: 13,
													fontWeight: 600,
													whiteSpace: "nowrap",
												}}
											>
												Toca donde quieras añadir la nota
											</Typography>
											<Box
												onClick={handleCancelNote}
												sx={{
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													cursor: "pointer",
													marginLeft: 0.5,
													borderRadius: "50%",
													width: 24,
													height: 24,
													flexShrink: 0,
													backgroundColor:
														"rgba(255,255,255,0.2)",
													"&:hover": {
														backgroundColor:
															"rgba(255,255,255,0.35)",
													},
												}}
											>
												<Close
													sx={{
														fontSize: 16,
														color: "white",
													}}
												/>
											</Box>
										</Box>
									)}
									{/* Renderizar canvas de Konva para stickers y textos */}
								<Box
									ref={canvasContainerRef}
									sx={{
										position: "absolute",
										top: 0,
										left: 0,
										width: "100%",
										height: "100%",
										overflowY: "auto",
										overflowX: "hidden",
										overscrollBehavior: "none",
										pointerEvents: "auto",
										zIndex: 1052,
										"& .konvajs-content": {
											width: `${canvasDimensions.width}px !important`,
											height: `${canvasDimensions.height}px !important`,
										},
									}}
									>
										{/* Spacer para que el canvas container tenga el mismo scroll que templates-container */}
										<Box
											sx={{
												width: "100%",
												height: canvasDimensions.height,
												minHeight: canvasDimensions.height,
												position: "relative",
											}}
										>
											{/* En template 100, 101, 102, capa solo para wheel (scroll); pointer-events: none para que los clics en el template lleguen a los botones (el template va encima con z-index) */}
											{pages[currentPage]?.templateId === 100 /*||
											pages[currentPage]?.templateId === 101 ||
											pages[currentPage]?.templateId === 102*/ && (
												<Box
													onWheel={(e) => {
														const tid = pages[currentPage]?.templateId;
														const scrollEl = document.querySelector(
															`[data-template${tid}-scroll]`,
														);
														if (!scrollEl) return;
														const maxScroll =
															scrollEl.scrollHeight - scrollEl.clientHeight;
														if (maxScroll <= 0) return;
														scrollEl.scrollTop = Math.max(
															0,
															Math.min(
																scrollEl.scrollTop + e.deltaY,
																maxScroll,
															),
														);
														e.preventDefault();
														e.stopPropagation();
													}}
													sx={{
														position: "absolute",
														top: 0,
														left: 0,
														width: "100%",
														height: "100%",
														zIndex: 1,
														pointerEvents: "none",
													}}
												/>
											)}
											{/* Wrapper mismo tamaño que el Stage para que los botones overlay hagan scroll con el canvas */}
											<Box
												sx={{
													position: "relative",
													width: canvasDimensions.width,
													height: canvasDimensions.height,
													flexShrink: 0,
													pointerEvents: "auto",
												}}
											>
												<Stage
													width={canvasDimensions.width}
													height={canvasDimensions.height}
													onClick={handleCanvasClick}
													onTap={handleCanvasClick}
													onWheel={(e) => {
														if (pages[currentPage]?.templateId !== 100) return;
														const scrollEl = document.querySelector(
															"[data-template100-scroll]",
														);
														if (!scrollEl) return;
														const maxScroll =
															scrollEl.scrollHeight - scrollEl.clientHeight;
														if (maxScroll <= 0) return;
														scrollEl.scrollTop = Math.max(
															0,
															Math.min(
																scrollEl.scrollTop + e.evt.deltaY,
																maxScroll,
															),
														);
														e.evt.preventDefault();
														e.evt.stopPropagation();
													}}
													onMouseDown={() => {}}
													onTouchStart={(e) => {
														const touch =
															e.evt?.touches?.[0] || e.evt?.changedTouches?.[0];
														if (touch) {
															canvasTouchStartRef.current = {
																x: touch.clientX,
																y: touch.clientY,
																time: Date.now(),
															};
															canvasHasMovedRef.current = false;
															// Para To-Do: guardar Y para reenviar scroll táctil
															if (pages[currentPage]?.templateId === 100) {
																template100TouchYRef.current = touch.clientY;
															}
														}
													}}
													onTouchMove={(e) => {
														const touch =
															e.evt?.touches?.[0] || e.evt?.changedTouches?.[0];
														// En To-Do: si el touch es sobre zona vacía (Stage o Layer), reenviar scroll al contenido
														const stage = e.target?.getStage?.();
														const isEmptyArea =
															stage &&
															(e.target === stage ||
																(e.target.getClassName?.() &&
																	e.target.getClassName() === "Layer"));
														if (
															pages[currentPage]?.templateId === 100 &&
															template100TouchYRef.current != null &&
															touch &&
															isEmptyArea
														) {
															const scrollEl = document.querySelector(
																"[data-template100-scroll]",
															);
															if (scrollEl) {
																const deltaY =
																	touch.clientY - template100TouchYRef.current;
																scrollEl.scrollTop += deltaY;
																template100TouchYRef.current = touch.clientY;
															}
															return;
														}
														// Detectar si hay movimiento (scroll) para otros templates
														if (canvasTouchStartRef.current && touch) {
															const deltaX = Math.abs(
																touch.clientX - canvasTouchStartRef.current.x,
															);
															const deltaY = Math.abs(
																touch.clientY - canvasTouchStartRef.current.y,
															);
															if (deltaX > 5 || deltaY > 5) {
																canvasHasMovedRef.current = true;
															}
														}
													}}
													onTouchEnd={() => {
														// Resetear estado después de un breve delay
														setTimeout(() => {
															canvasHasMovedRef.current = false;
															canvasTouchStartRef.current = null;
														}, 100);
													}}
												>
													<Layer>
														{
															/*stickersOnCanvas*/ pages &&
																pages.length > currentPage &&
																pages[currentPage].canvasImages &&
																pages[currentPage].canvasImages
																	.filter((s) => {
																		if (s.notShow) return false; // Mostrar si tiene imageUrl o imagen cargada (Sticker requiere image completa)
																		if (
																			!s.imageUrl &&
																			!(s.image && s.image.src)
																		)
																			return false;
																		// Templates NY (70-99): no mostrar imágenes en el canvas; el contenido va en el template
																		const tid = pages[currentPage]?.templateId;
																		if (tid >= 70 && tid <= 99) return false;
																		// Para Template23-43: filtrar imágenes que son parte del template
																		if (
																			pages[currentPage]?.templateId === 23 ||
																			pages[currentPage]?.templateId === 24 ||
																			pages[currentPage]?.templateId === 25 ||
																			pages[currentPage]?.templateId === 26 ||
																			pages[currentPage]?.templateId === 27 ||
																			pages[currentPage]?.templateId === 28 ||
																			pages[currentPage]?.templateId === 29 ||
																			pages[currentPage]?.templateId === 30 ||
																			pages[currentPage]?.templateId === 31 ||
																			pages[currentPage]?.templateId === 32 ||
																			pages[currentPage]?.templateId === 33 ||
																			pages[currentPage]?.templateId === 34 ||
																			pages[currentPage]?.templateId === 35 ||
																			pages[currentPage]?.templateId === 36 ||
																			pages[currentPage]?.templateId === 37 ||
																			pages[currentPage]?.templateId === 38 ||
																			pages[currentPage]?.templateId === 39 ||
																			pages[currentPage]?.templateId === 40 ||
																			pages[currentPage]?.templateId === 41 ||
																			pages[currentPage]?.templateId === 42 ||
																			pages[currentPage]?.templateId === 43 ||
																			pages[currentPage]?.templateId === 50 ||
																			pages[currentPage]?.templateId === 51 ||
																			pages[currentPage]?.templateId === 52 ||
																			pages[currentPage]?.templateId === 53 ||
																			pages[currentPage]?.templateId === 54 ||
																			pages[currentPage]?.templateId === 55 ||
																			pages[currentPage]?.templateId === 56 ||
																			pages[currentPage]?.templateId === 57 ||
																			pages[currentPage]?.templateId === 58 ||
																			pages[currentPage]?.templateId === 59 ||
																			pages[currentPage]?.templateId === 60 ||
																			pages[currentPage]?.templateId === 61 ||
																			pages[currentPage]?.templateId === 62 ||
																			pages[currentPage]?.templateId === 63 ||
																			pages[currentPage]?.templateId === 64 ||
																			pages[currentPage]?.templateId === 65 ||
																			pages[currentPage]?.templateId === 70
																		) {
																			// IDs de imágenes que son parte del template y no deben renderizarse en el canvas
																			const templateImageIds = [
																				"logo",
																				"sticker-1",
																				"sticker-2",
																				"yasaka-sticker",
																				"gion-sticker",
																				"portada-central",
																				"background-stickers",
																				"overlay-negro",
																				"sticker-arashiyama",
																				"sticker-bosque",
																				"ninenzaka-sticker",
																				"templo-dorado-sticker3",
																				"templo-dorado-sticker2",
																				"ryoanji-sticker",
																				"pontocho-sticker",
																				"nijo-sticker",
																				"monos-sticker",
																				"inari-sticker",
																				"nara-sticker",
																				"ciervos-sticker",
																				"camino-filosofia",
																				"autobus-kioto",
																				"train-sticker",
																				"ceremonia-te",
																				"kansai",
																				"consejos",
																				"enchufe",
																				// Stickers de Tokio (templates 50-62)
																				"asakusa-sticker",
																				"asakusa-sticker-2",
																				"ueno-sticker",
																				"ueno-sticker-2",
																				"akihabara-sticker",
																				"badge-akihabara",
																				"shibuya-sticker",
																				"takeshite-st",
																				"kamakura-sticker",
																				"palacio-sticker",
																				"imperial-sticker",
																				"ginza-sticker",
																				"odaiba-sticker",
																				"shinjuku-sticker",
																				"torre-sticker",
																				"freeDay-sticker",
																				"dia-libre-sticker",
																				"sushi-sticker",
																				"hasedera-sticker",
																				// Stickers de Tokio (templates 63-64)
																				"fotomaton",
																				"palacio-imperial",
																				"mercado-sticker",
																			];
																			// Solo renderizar imágenes que NO están en la lista (stickers añadidos por el usuario)
																			return !templateImageIds.includes(s.id);
																		}
																		return true;
																	})
																	.map((sticker, index) => (
																		<Sticker
																			handleContextMenu={(event) => {
																				console.log(event);
																				event.evt.preventDefault();
																				setContextMenu(
																					contextMenu === null
																						? {
																								mouseX: event.evt.clientX + 2,
																								mouseY: event.evt.clientY - 6,
																							}
																						: null,
																				);
																				setSelectedTextIndex(null);
																				setSelectedImageIndex(index);
																				setSelectedStickerIndex(null);
																			}}
																			tabbar={tabbar}
																			ref={(node) => {
																				const map = getMap();
																				if (node) {
																					map.set(sticker.id, node);
																				} else {
																					map.delete(sticker.id);
																				}
																			}}
																			key={sticker.id + "-" + index}
																			stickerProps={sticker}
																			isSelected={selectedImageIndex === index}
																			getCanvasWidth={getCanvasWidth}
																			getCanvasHeight={getCanvasHeight}
																			onSelect={(e) => {
																				e.cancelBubble = true;
																				console.log("SELECTING");
																				setSelectedTextIndex(null);
																				setEditingTextIndex(null);
																				setSelectedStickerIndex(null);
																				setClickedX(null);
																				setClickedY(null);
																				if (selectedImageIndex === index) {
																					setSelectedImageIndex(null);
																				} else {
																					setSelectedImageIndex(index);
																				}
																			}}
																			onChange={(newAttrs) => {
																				const auxPage = {
																					...pages[currentPage],
																				};
																				const updatedStickers =
																					auxPage.canvasImages.slice();
																				updatedStickers[index] = newAttrs;

																				auxPage.canvasImages = [
																					...updatedStickers,
																				];
																				updateCurrentPage(auxPage);

																				//setStickersOnCanvas(updatedStickers);
																			}}
																			onDelete={() => {
																				console.log(sticker);
																				console.log("deleting");
																				const auxPage = {
																					...pages[currentPage],
																				};
																				const updatedStickers =
																					auxPage.canvasImages
																						.slice()
																						.filter(
																							(auxSticker) =>
																								sticker.id !== auxSticker.id,
																						);
																				console.log(sticker.id);
																				auxPage.canvasImages = [
																					...updatedStickers,
																				];
																				console.log(auxPage.canvasImages);
																				updateCurrentPage(auxPage);
																			}}
																			onTransformStart={() =>
																				setIsTransformingSticker(true)
																			}
																			onTransformEnd={() =>
																				setIsTransformingSticker(false)
																			}
																		/>
																	))
														}
														{
															/*stickersOnCanvas*/ pages &&
																pages.length > currentPage &&
																pages[currentPage].canvasStickers &&
																pages[currentPage].canvasStickers
																	.filter((s) => s.image?.src)
																	.map((sticker, index) => {
																		// Calcular tamaño escalado (proporcional al canvas original)
																		const scaledSize =
																			getScaledStickerSize(sticker);
																		const stickerPos = getStickerPixelPosition(
																			sticker,
																			scaledSize.width,
																			scaledSize.height,
																		);
																		console.log(
																			"[StickerApp render] sticker:",
																			sticker.uniqueId,
																			"scaledSize:",
																			scaledSize,
																			"stickerPos:",
																			stickerPos,
																			"anchorType:",
																			sticker.anchorType,
																			"widthPercent:",
																			sticker.widthPercent,
																		);
																		return (
																			<Sticker
																				handleContextMenu={(event) => {
																					console.log(event);
																					event.evt.preventDefault();
																					setContextMenu(
																						contextMenu === null
																							? {
																									mouseX: event.evt.clientX + 2,
																									mouseY: event.evt.clientY - 6,
																								}
																							: null,
																					);
																					setSelectedTextIndex(null);
																					setSelectedImageIndex(null);
																					setSelectedStickerIndex(index);
																				}}
																				tabbar={tabbar}
																				ref={(node) => {
																					const map = getMap();
																					if (node) {
																						map.set(sticker.uniqueId, node);
																					} else {
																						map.delete(sticker.uniqueId);
																					}
																				}}
																				key={sticker.uniqueId + "-" + index}
																				stickerProps={sticker}
																				displayX={stickerPos.x}
																				displayY={stickerPos.y}
																				displayWidth={scaledSize.width}
																				displayHeight={scaledSize.height}
																				isSelected={
																					selectedStickerIndex === index
																				}
																				getCanvasWidth={getCanvasWidth}
																				getCanvasHeight={getCanvasHeight}
																				onSelect={(e) => {
																					e.cancelBubble = true;
																					console.log("SELECTING");
																					setSelectedTextIndex(null);
																					setEditingTextIndex(null);
																					setSelectedImageIndex(null);
																					setClickedX(null);
																					setClickedY(null);
																					if (selectedStickerIndex === index) {
																						setSelectedStickerIndex(null);
																					} else {
																						setSelectedStickerIndex(index);
																					}
																				}}
																				onChange={(newAttrs) => {
																					// Guardamos posición + anclaje (bloque o página) + tamaño
																					const cw = getCanvasWidth();
																					const ch = getCanvasHeight();
																					const stageX = newAttrs.x ?? 0;
																					const stageY = newAttrs.y ?? 0;
																					const sw =
																						newAttrs.width ??
																						sticker.width ??
																						80;
																					const sh =
																						newAttrs.height ??
																						sticker.height ??
																						80;

																					const hit = hitTestBlock(
																						stageX,
																						stageY,
																					);
																					let finalAttrs = {
																						...newAttrs,
																						// Guardar widthPercent y aspectRatio para mantener proporción
																						width: sw,
																						height: sh,
																						widthPercent:
																							cw > 0 ? (sw / cw) * 100 : null,
																						aspectRatio: sw > 0 ? sh / sw : 1,
																					};

																					if (hit) {
																						const { blockId, rect } = hit;
																						const blockOffsetXPercent =
																							rect.width !== 0
																								? ((stageX - rect.left) /
																										rect.width) *
																									100
																								: 0;
																						const blockOffsetYPercent =
																							rect.height !== 0
																								? ((stageY - rect.top) /
																										rect.height) *
																									100
																								: 0;
																						finalAttrs = {
																							...finalAttrs,
																							x: stageX,
																							y: stageY,
																							anchorType: "block",
																							anchorBlockId: blockId,
																							blockOffsetXPercent,
																							blockOffsetYPercent,
																						};
																					} else {
																						const anchorData =
																							pixelToAnchorForText(
																								stageX,
																								stageY,
																								sw,
																								sh,
																								cw,
																								ch,
																							);
																						finalAttrs = {
																							...finalAttrs,
																							x: stageX,
																							y: stageY,
																							anchorType: "page",
																							anchor: anchorData.anchor,
																							offsetX:
																								cw > 0
																									? (anchorData.offsetX / cw) *
																										100
																									: 0,
																							offsetY:
																								ch > 0
																									? (anchorData.offsetY / ch) *
																										100
																									: 0,
																							offsetInPixels: false,
																						};
																					}

																					const auxPage = {
																						...pages[currentPage],
																					};
																					const updatedStickers =
																						auxPage.canvasStickers.slice();
																					updatedStickers[index] = finalAttrs;

																					auxPage.canvasStickers = [
																						...updatedStickers,
																					];
																					updateCurrentPage(auxPage);

																					//setStickersOnCanvas(updatedStickers);
																				}}
																				onDelete={() => {
																					console.log(sticker);
																					console.log("deleting");
																					const auxPage = {
																						...pages[currentPage],
																					};
																					const updatedStickers =
																						auxPage.canvasStickers
																							.slice()
																							.filter(
																								(auxSticker) =>
																									sticker.uniqueId !==
																									auxSticker.uniqueId,
																							);
																					console.log(sticker.uniqueId);
																					auxPage.canvasStickers = [
																						...updatedStickers,
																					];
																					console.log(auxPage.canvasStickers);
																					updateCurrentPage(auxPage);
																				}}
																				onTransformStart={() =>
																					setIsTransformingSticker(true)
																				}
																				onTransformEnd={() =>
																					setIsTransformingSticker(false)
																				}
																			/>
																		);
																	})
														}
														{
															/*textOnCanvas*/ pages &&
																pages.length > currentPage &&
																pages[currentPage].canvasTexts &&
																pages[currentPage].canvasTexts.map(
																	(text, index) => {
																		// Calcular posición (igual que stickers)
																		const textDims =
																			getCanvasTextDimensions(text);
																		const textPos = getTextPixelPosition(
																			text,
																			textDims.width,
																			textDims.height,
																		);
																		return (
																			<TextSticker
																				tabbar={tabbar}
																				key={(text.text ?? "") + "-" + index}
																				index={index}
																				text={text}
																				displayX={textPos.x}
																				displayY={textPos.y}
																				blockRects={blockRects}
																				hitTestBlock={hitTestBlock}
																				isSelected={selectedTextIndex === index}
																				visible={selectedTextIndex === index}
																				onClick={(e) => {
																					e.cancelBubble = true;
																					setEditingTextIndex(index);
																					//setSelectedStickerIndex(null);
																					//setSelectedTextIndex(null);
																					//e.stopPropagation();
																				}}
																				handleTextClick={handleTextClick}
																				setTextIndex={setTextIndex}
																				setModalText={setModalText}
																				setIsModalOpen={setIsModalOpen}
																				updateCurrentPage={updateCurrentPage}
																				page={safeCurrentPage}
																				getCanvasWidth={getCanvasWidth}
																				getCanvasHeight={getCanvasHeight}
																				canvasWidth={canvasDimensions.width}
																				canvasHeight={canvasDimensions.height}
																				context={(() => {
																					const canvas = document.querySelector(
																						".konvajs-content > canvas",
																					);
																					if (canvas) {
																						return canvas.getContext("2d");
																					}
																					// Si no hay canvas, crear uno temporal para medir texto
																					const tempCanvas =
																						document.createElement("canvas");
																					return tempCanvas.getContext("2d");
																				})()}
																				onSelect={(wasSelected) => {
																					console.log("SELECTED", wasSelected);
																					setSelectedStickerIndex(null);
																					setSelectedImageIndex(null);
																					setClickedX(null);
																					setClickedY(null);
																					if (wasSelected) {
																						// Si ya estaba seleccionado, deseleccionar
																						setSelectedTextIndex(null);
																						setEditingTextIndex(null);
																					} else {
																						// Si no estaba seleccionado, seleccionar
																						setSelectedTextIndex(index);
																						setEditingTextIndex(index);
																					}
																				}}
																				onDelete={() => {
																					console.log("deleting");
																					console.log(text);
																					const auxPage = {
																						...pages[currentPage],
																					};
																					const updatedStickers =
																						auxPage.canvasTexts
																							.slice()
																							.filter(
																								(auxText) =>
																									text.id !== auxText.id,
																							);

																					auxPage.canvasTexts = [
																						...updatedStickers,
																					];
																					console.log(auxPage.canvasTexts);
																					updateCurrentPage(auxPage);
																				}}
																				handleContextMenu={(event) => {
																					console.log(event);
																					event.evt.preventDefault();
																					setContextMenu(
																						contextMenu === null
																							? {
																									mouseX: event.evt.clientX + 2,
																									mouseY: event.evt.clientY - 6,
																								}
																							: null,
																					);
																					setSelectedTextIndex(index);
																					setSelectedImageIndex(null);
																					setSelectedStickerIndex(null);
																				}}
																				onTransformStart={() =>
																					setIsTransformingSticker(true)
																				}
																				onTransformEnd={() =>
																					setIsTransformingSticker(false)
																				}
																			/>
																		);
																	},
																)
														}
													</Layer>
												</Stage>
												{/* Botón de borrar - overlay HTML fuera de Konva con animación */}
												{(selectedImageIndex !== null ||
													selectedStickerIndex !== null) &&
													(() => {
														let selectedElement = null;
														let deleteHandler = null;

														if (
															selectedImageIndex !== null &&
															pages[currentPage]?.canvasImages?.[
																selectedImageIndex
															]
														) {
															selectedElement =
																pages[currentPage].canvasImages[
																	selectedImageIndex
																];
															deleteHandler = () => {
																const auxPage = { ...pages[currentPage] };
																auxPage.canvasImages =
																	auxPage.canvasImages.filter(
																		(_, i) => i !== selectedImageIndex,
																	);
																updateCurrentPage(auxPage);
																setSelectedImageIndex(null);
															};
														} else if (
															selectedStickerIndex !== null &&
															pages[currentPage]?.canvasStickers?.[
																selectedStickerIndex
															]
														) {
															selectedElement =
																pages[currentPage].canvasStickers[
																	selectedStickerIndex
																];
															deleteHandler = () => {
																const auxPage = { ...pages[currentPage] };
																auxPage.canvasStickers =
																	auxPage.canvasStickers.filter(
																		(_, i) => i !== selectedStickerIndex,
																	);
																updateCurrentPage(auxPage);
																setSelectedStickerIndex(null);
															};
														}

														if (!selectedElement || !deleteHandler) return null;

														// Posición en Stage (igual que la que usa el Sticker al renderizar)
														const elWidth = selectedElement.width || 100;
														const elHeight =
															selectedElement.height ||
															selectedElement.width ||
															100;
														const pos = getStickerPixelPosition(
															selectedElement,
															elWidth,
															elHeight,
														);
														const rotation =
															(selectedElement.rotation || 0) * (Math.PI / 180);
														const cos = Math.cos(rotation);
														const sin = Math.sin(rotation);
														// Konva rota alrededor de pos (esquina superior izquierda)
														// Esquina superior derecha rotada = pos + (width, 0) rotado
														const topRightX = pos.x + elWidth * cos;
														const topRightY = pos.y + elWidth * sin;
														// Offset: un poco hacia la derecha y arriba (en coordenadas rotadas)
														const deleteBtnSize = 22;
														const offset = deleteBtnSize / 2 + 2;
														// Derecha rotada: (cos, sin), Arriba rotada: (sin, -cos)
														const btnX =
															topRightX + offset * cos + offset * sin;
														const btnY =
															topRightY + offset * sin - offset * cos;

														const isVisible = !isTransformingSticker;

														return (
															<Box
																onClick={(e) => {
																	if (!isVisible) return;
																	e.stopPropagation();
																	deleteHandler();
																}}
																onTouchEnd={(e) => {
																	if (!isVisible) return;
																	e.stopPropagation();
																	e.preventDefault();
																	deleteHandler();
																}}
																sx={{
																	position: "absolute",
																	left: btnX,
																	top: btnY,
																	transform: isVisible
																		? "translate(-50%, -50%) scale(1)"
																		: "translate(-50%, -50%) scale(0.5)",
																	width: deleteBtnSize,
																	height: deleteBtnSize,
																	borderRadius: "50%",
																	backgroundColor: "#ef4444",
																	display: "flex",
																	alignItems: "center",
																	justifyContent: "center",
																	cursor: isVisible ? "pointer" : "default",
																	boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
																	zIndex: 1001,
																	opacity: isVisible ? 1 : 0,
																	pointerEvents: isVisible ? "auto" : "none",
																	transition:
																		"opacity 0.15s ease-out, transform 0.15s ease-out, background-color 0.1s",
																	"&:hover": isVisible
																		? {
																				backgroundColor: "#dc2626",
																				transform:
																					"translate(-50%, -50%) scale(1.1)",
																			}
																		: {},
																}}
															>
																<Typography
																	sx={{
																		color: "white",
																		fontSize: 12,
																		fontWeight: "bold",
																		lineHeight: 1,
																		userSelect: "none",
																	}}
																>
																	✕
																</Typography>
															</Box>
														);
													})()}

												{/* Botones para texto seleccionado: editar y borrar juntos */}
												{selectedTextIndex !== null &&
													pages[currentPage]?.canvasTexts?.[
														selectedTextIndex
													] &&
													(() => {
														const selectedText =
															pages[currentPage].canvasTexts[selectedTextIndex];
														const textDims =
															getCanvasTextDimensions(selectedText);
														const textWidth =
															textDims.width * (selectedText.scaleX || 1);
														const textHeight =
															textDims.height * (selectedText.scaleY || 1);
														// Usar getTextPixelPosition (igual que TextSticker al renderizar)
														const pos = getTextPixelPosition(
															selectedText,
															textWidth,
															textHeight,
														);
														const rotation =
															(selectedText.rotation || 0) * (Math.PI / 180);
														const cos = Math.cos(rotation);
														const sin = Math.sin(rotation);
														// Konva rota alrededor de pos (esquina superior izquierda)
														// Esquina superior derecha rotada = pos + (width, 0) rotado
														const topRightX = pos.x + textWidth * cos;
														const topRightY = pos.y + textWidth * sin;
														// Offset: un poco hacia la derecha y arriba (en coordenadas rotadas)
														const btnSize = isMobile ? 34 : 22;
														const gap = isMobile ? 6 : 4;
														const offset = btnSize / 2 + 2;
														// Derecha rotada: (cos, sin), Arriba rotada: (sin, -cos)
														const deleteBtnX =
															topRightX + offset * cos + offset * sin;
														const deleteBtnY =
															topRightY + offset * sin - offset * cos;
														// Editar a la izquierda del borrar (en la dirección "izquierda" rotada = -cos, -sin)
														const editBtnX = deleteBtnX - (btnSize + gap) * cos;
														const editBtnY = deleteBtnY - (btnSize + gap) * sin;

														const isVisible = !isTransformingSticker;

														const handleEditText = () => {
															handleTextClick(
																selectedTextIndex,
																selectedText.text,
																selectedText.fontFamily,
																selectedText.fill,
																selectedText.stroke,
																selectedText.strokeWidth,
																selectedText.align,
																selectedText.fontSize,
															);
														};

														const handleDeleteText = () => {
															const auxPage = { ...pages[currentPage] };
															auxPage.canvasTexts = auxPage.canvasTexts.filter(
																(_, i) => i !== selectedTextIndex,
															);
															updateCurrentPage(auxPage);
															setSelectedTextIndex(null);
															setEditingTextIndex(null);
														};

														return (
															<>
																{/* Botón de editar */}
																<Box
																	onClick={(e) => {
																		if (!isVisible) return;
																		e.stopPropagation();
																		handleEditText();
																	}}
																	onTouchEnd={(e) => {
																		if (!isVisible) return;
																		e.stopPropagation();
																		e.preventDefault();
																		handleEditText();
																	}}
																	sx={{
																		position: "absolute",
																		left: editBtnX,
																		top: editBtnY,
																		transform: isVisible
																			? "translate(-50%, -50%) scale(1)"
																			: "translate(-50%, -50%) scale(0.5)",
																		width: btnSize,
																		height: btnSize,
																		borderRadius: "50%",
																		backgroundColor: "#3b82f6",
																		display: "flex",
																		alignItems: "center",
																		justifyContent: "center",
																		cursor: isVisible ? "pointer" : "default",
																		boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
																		zIndex: 1001,
																		opacity: isVisible ? 1 : 0,
																		pointerEvents: isVisible ? "auto" : "none",
																		transition:
																			"opacity 0.15s ease-out, transform 0.15s ease-out, background-color 0.1s",
																		"&:hover": isVisible
																			? {
																					backgroundColor: "#2563eb",
																					transform:
																						"translate(-50%, -50%) scale(1.1)",
																				}
																			: {},
																	}}
																>
																	<Typography
																		sx={{
																			color: "white",
																			fontSize: isMobile ? 18 : 12,
																			lineHeight: 1,
																			userSelect: "none",
																		}}
																	>
																		✎
																	</Typography>
																</Box>

																{/* Botón de borrar */}
																<Box
																	onClick={(e) => {
																		if (!isVisible) return;
																		e.stopPropagation();
																		handleDeleteText();
																	}}
																	onTouchEnd={(e) => {
																		if (!isVisible) return;
																		e.stopPropagation();
																		e.preventDefault();
																		handleDeleteText();
																	}}
																	sx={{
																		position: "absolute",
																		left: deleteBtnX,
																		top: deleteBtnY,
																		transform: isVisible
																			? "translate(-50%, -50%) scale(1)"
																			: "translate(-50%, -50%) scale(0.5)",
																		width: btnSize,
																		height: btnSize,
																		borderRadius: "50%",
																		backgroundColor: "#ef4444",
																		display: "flex",
																		alignItems: "center",
																		justifyContent: "center",
																		cursor: isVisible ? "pointer" : "default",
																		boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
																		zIndex: 1001,
																		opacity: isVisible ? 1 : 0,
																		pointerEvents: isVisible ? "auto" : "none",
																		transition:
																			"opacity 0.15s ease-out, transform 0.15s ease-out, background-color 0.1s",
																		"&:hover": isVisible
																			? {
																					backgroundColor: "#dc2626",
																					transform:
																						"translate(-50%, -50%) scale(1.1)",
																				}
																			: {},
																	}}
																>
																	<Typography
																		sx={{
																			color: "white",
																			fontSize: isMobile ? 18 : 12,
																			fontWeight: "bold",
																			lineHeight: 1,
																			userSelect: "none",
																		}}
																	>
																		✕
																	</Typography>
																</Box>
															</>
														);
													})()}
											</Box>
										</Box>
										<Menu
											open={contextMenu !== null}
											onClose={handleClose}
											anchorReference="anchorPosition"
											anchorPosition={
												contextMenu !== null
													? {
															top: contextMenu.mouseY,
															left: contextMenu.mouseX,
														}
													: undefined
											}
										>
											<MenuItem
												disabled
												onClick={(e) => {
													e.preventDefault();
												}}
												sx={{
													textTransform: "uppercase",
													fontSize: 10,
													opacity: "1!important",
													fontWeight: "bold",
													borderBottom: "1px solid #ccc",
												}}
											>
												Organizar{" "}
												{selectedStickerIndex
													? "stickers"
													: selectedTextIndex
														? "textos"
														: "imágenes"}
											</MenuItem>
											<MenuItem
												onClick={() => {
													const i =
														selectedStickerIndex !== null
															? selectedStickerIndex
															: selectedTextIndex !== null
																? selectedTextIndex
																: selectedImageIndex;

													const auxPage = { ...pages[currentPage] };
													const updatedStickers =
														auxPage[
															selectedStickerIndex !== null
																? "canvasStickers"
																: selectedTextIndex !== null
																	? "canvasTexts"
																	: "canvasImages"
														].slice();
													const updatedSticker = {
														...updatedStickers[i],
													};
													updatedStickers.splice(i, 1);
													if (selectedStickerIndex) {
														setSelectedStickerIndex(updatedStickers.length - 1);
													} else if (selectedTextIndex) {
														setSelectedTextIndex(updatedStickers.length - 1);
													} else {
														setSelectedImageIndex(updatedStickers.length - 1);
													}
													updatedStickers.push(updatedSticker);
													auxPage[
														selectedStickerIndex !== null
															? "canvasStickers"
															: selectedTextIndex !== null
																? "canvasTexts"
																: "canvasImages"
													] = [...updatedStickers];
													updateCurrentPage(auxPage);
													handleClose();
												}}
												sx={{
													fontSize: 14,
													borderBottom: "1px solid #eee",
													padding: "8px 16px",
												}}
											>
												Traer al frente
											</MenuItem>
											<MenuItem
												onClick={() => {
													const i =
														selectedStickerIndex !== null
															? selectedStickerIndex
															: selectedTextIndex !== null
																? selectedTextIndex
																: selectedImageIndex;

													if (
														i <
														pages[currentPage].canvasStickers.length - 1
													) {
														const auxPage = { ...pages[currentPage] };
														const updatedStickers =
															auxPage[
																selectedStickerIndex !== null
																	? "canvasStickers"
																	: selectedTextIndex !== null
																		? "canvasTexts"
																		: "canvasImages"
															].slice();
														const updatedSticker = {
															...updatedStickers[i],
														};
														updatedStickers.splice(i, 1);
														if (selectedStickerIndex) {
															setSelectedStickerIndex(i + 1);
														} else if (selectedTextIndex) {
															setSelectedTextIndex(i + 1);
														} else {
															setSelectedImageIndex(i + 1);
														}
														updatedStickers.splice(i + 1, 0, updatedSticker);
														auxPage[
															selectedStickerIndex !== null
																? "canvasStickers"
																: selectedTextIndex !== null
																	? "canvasTexts"
																	: "canvasImages"
														] = [...updatedStickers];
														updateCurrentPage(auxPage);
													}
													handleClose();
												}}
												sx={{
													fontSize: 14,
													borderBottom: "1px solid #eee",
													padding: "8px 16px",
												}}
											>
												Hacia adelante
											</MenuItem>
											<MenuItem
												onClick={() => {
													const i =
														selectedStickerIndex !== null
															? selectedStickerIndex
															: selectedTextIndex !== null
																? selectedTextIndex
																: selectedImageIndex;
													if (i > 0) {
														const auxPage = { ...pages[currentPage] };
														const updatedStickers =
															auxPage[
																selectedStickerIndex !== null
																	? "canvasStickers"
																	: selectedTextIndex !== null
																		? "canvasTexts"
																		: "canvasImages"
															].slice();
														const updatedSticker = {
															...updatedStickers[i],
														};
														updatedStickers.splice(i, 1);
														if (selectedStickerIndex) {
															setSelectedStickerIndex(i - 1);
														} else if (selectedTextIndex) {
															setSelectedTextIndex(i - 1);
														} else {
															setSelectedImageIndex(i - 1);
														}

														updatedStickers.splice(i - 1, 0, updatedSticker);
														auxPage[
															selectedStickerIndex !== null
																? "canvasStickers"
																: selectedTextIndex !== null
																	? "canvasTexts"
																	: "canvasImages"
														] = [...updatedStickers];
														updateCurrentPage(auxPage);
													}
													handleClose();
												}}
												sx={{
													fontSize: 14,
													borderBottom: "1px solid #eee",
													padding: "8px 16px",
												}}
											>
												Hacia atrás
											</MenuItem>
											<MenuItem
												onClick={() => {
													const i =
														selectedStickerIndex !== null
															? selectedStickerIndex
															: selectedTextIndex !== null
																? selectedTextIndex
																: selectedImageIndex;
													const auxPage = { ...pages[currentPage] };
													const updatedStickers =
														auxPage[
															selectedStickerIndex !== null
																? "canvasStickers"
																: selectedTextIndex !== null
																	? "canvasTexts"
																	: "canvasImages"
														].slice();
													const updatedSticker = {
														...updatedStickers[i],
													};
													updatedStickers.splice(i, 1);
													if (selectedStickerIndex) {
														setSelectedStickerIndex(0);
													} else if (selectedTextIndex) {
														setSelectedTextIndex(0);
													} else {
														setSelectedImageIndex(0);
													}

													updatedStickers.unshift(updatedSticker);
													auxPage[
														selectedStickerIndex !== null
															? "canvasStickers"
															: selectedTextIndex !== null
																? "canvasTexts"
																: "canvasImages"
													] = [...updatedStickers];
													updateCurrentPage(auxPage);
													handleClose();
												}}
												sx={{ fontSize: 14, padding: "8px 16px 2px 16px" }}
											>
												Enviar detrás
											</MenuItem>
										</Menu>
										{/* Cierre del spacer Box */}
									</Box>
								</Box>
							</Box>
						</Box>

						{/* Lista de páginas - oculta en móvil, se muestra en el drawer */}
						<Box
							sx={{
								right: 0,
								top: 0,
								bottom: 0,
								overflow: "auto",
								marginLeft: 2,
								...(smallScreen
									? {
											display: "none", // Oculto en móvil - se usa el FAB + drawer
										}
									: {}),
							}}
						>
							<Box
								sx={{
									backgroundColor: "white",
									display: "flex",
									flexDirection: size.width < 740 ? "row" : "column",
									padding: size.width < 740 ? "0px 10px" : "16px 0px",
									gap: 2,
									width: "100%",
									maxWidth: "100%",
									height: "100%",
								}}
							>
								{/**<Stack
									direction="row"
									spacing={1}
									alignItems="center"
									flexDirection={smallScreen ? "row" : "column"}
									sx={{ padding: smallScreen ? 0 : "1px 16px" }}
								>
									<Typography sx={{ fontSize: 10 }}>Ajustar</Typography>
									{smallScreen ? (
										<AntSwitchMobile
											defaultChecked
											inputProps={{ "aria-label": "ant design" }}
											checked={scaleMode === "100%"}
											onChange={(e) => {
												setScaleMode(e.target.checked ? "100%" : "fit");
											}}
										/>
									) : (
										<AntSwitch
											defaultChecked
											inputProps={{ "aria-label": "ant design" }}
											checked={scaleMode === "100%"}
											onChange={(e) => {
												setScaleMode(e.target.checked ? "100%" : "fit");
											}}
										/>
									)}
									<Typography sx={{ fontSize: 10, marginLeft: "0!important" }}>
										100%
									</Typography>
								</Stack>*/}
								{/*<Divider
									orientation={smallScreen ? "vertical" : "horizontal"}
								/>*/}
								<Box
									ref={pagesListScrollRef}
									sx={{
										width: "100%",
										...(smallScreen
											? {
													height: "auto",
													overflowX: "auto",
													overflowY: "hidden",
													WebkitOverflowScrolling: "touch",
													scrollbarWidth: "thin",
													"-webkit-overflow-scrolling": "touch",
													msOverflowStyle: "auto",
													touchAction: "pan-x",
												}
											: {
													maxHeight: "calc(100% - 97px)",
													overflow: "auto",
												}),
									}}
								>
									<Box
										sx={{
											backgroundColor: "transparent",
											display: "flex",
											flexDirection: smallScreen ? "row" : "column",
											gap: 1.5,
											padding: smallScreen ? "12px 4px" : "12px 12px",
											alignItems: "center",
											justifyContent: smallScreen ? "flex-start" : "center",
											...(smallScreen
												? {
														width: "max-content",
														minWidth: `${pages.length * 64 + 100}px`,
														flexShrink: 0,
													}
												: {
														width: "100%",
													}),
										}}
									>
										<DndContext
											sensors={sensors}
											collisionDetection={closestCenter}
											onDragStart={handleDragStart}
											onDragEnd={handleDragEnd}
										>
											<SortableContext
												items={pages}
												strategy={
													smallScreen
														? horizontalListSortingStrategy
														: verticalListSortingStrategy
												}
											>
												{pages.map((page, index) => {
													const isDragging = activeId === page.id;
													return (
														<SortableItem key={page.id} id={page.id}>
															{({ dragListeners, dragAttributes }) => (
																<Box
																	{...dragAttributes}
																	{...dragListeners}
																	sx={{
																		flexShrink: 0,
																		backgroundColor:
																			index === currentPage
																				? "#6366F1"
																				: "rgba(255,255,255,0.9)",
																		border:
																			index === currentPage
																				? "2px solid #6366F1"
																				: "2px solid rgba(0,0,0,0.08)",
																		borderRadius: "12px",
																		display: "flex",
																		justifyContent: "center",
																		alignItems: "center",
																		height: 48,
																		width: 48,
																		position: "relative",
																		userSelect: "none",
																		touchAction: "none", // Prevenir scroll durante drag en móvil
																		transition: isDragging
																			? "none"
																			: "all 0.2s ease",
																		boxShadow:
																			index === currentPage
																				? "0 4px 12px rgba(99, 102, 241,0.3)"
																				: "0 2px 4px rgba(0,0,0,0.08)",
																		cursor: isDragging
																			? "grabbing"
																			: smallScreen
																				? "grab"
																				: "pointer",
																		"&:hover": {
																			transform: isDragging
																				? "none"
																				: "translateY(-2px)",
																			boxShadow:
																				index === currentPage
																					? "0 6px 16px rgba(99, 102, 241,0.4)"
																					: "0 4px 8px rgba(0,0,0,0.12)",
																			borderColor:
																				index === currentPage
																					? "#6366F1"
																					: "rgba(99, 102, 241,0.3)",
																		},
																	}}
																	onClick={(e) => {
																		// Cambiar de página si no hay un drag activo
																		// El delay del TouchSensor permite que los taps funcionen antes de activar el drag
																		if (!activeId) {
																			e.preventDefault();
																			e.stopPropagation();
																			setCurrentPage(index);
																			setCurrentTemplateIndex(page.templateId);
																			setClickedX(null);
																			setClickedY(null);
																			setSelectedTextIndex(null);
																			setSelectedStickerIndex(null);
																			setSelectedImageIndex(null);
																		}
																	}}
																	onTouchStart={(e) => {
																		// En móvil, manejar el tap para cambiar de página
																		// El TouchSensor con delay permite que los taps rápidos funcionen primero
																		if (!activeId && smallScreen) {
																			const touch = e.touches[0];
																			const startX = touch.clientX;
																			const startY = touch.clientY;
																			const startTime = Date.now();

																			const handleTouchEnd = (e2) => {
																				// Solo procesar si no se inició un drag
																				if (activeId) {
																					document.removeEventListener(
																						"touchend",
																						handleTouchEnd,
																					);
																					return;
																				}

																				const touch2 = e2.changedTouches[0];
																				const endX = touch2.clientX;
																				const endY = touch2.clientY;
																				const endTime = Date.now();
																				const deltaX = Math.abs(endX - startX);
																				const deltaY = Math.abs(endY - startY);
																				const deltaTime = endTime - startTime;

																				// Si es un tap rápido (menos de 250ms y menos de 5px de movimiento)
																				// El delay del sensor es 250ms, así que si es más rápido, es un tap
																				if (
																					deltaTime < 250 &&
																					deltaX < 5 &&
																					deltaY < 5
																				) {
																					e2.preventDefault();
																					e2.stopPropagation();
																					setCurrentPage(index);
																					setCurrentTemplateIndex(
																						page.templateId,
																					);
																					setClickedX(null);
																					setClickedY(null);
																					setSelectedTextIndex(null);
																					setSelectedStickerIndex(null);
																					setSelectedImageIndex(null);
																				}

																				document.removeEventListener(
																					"touchend",
																					handleTouchEnd,
																				);
																			};

																			document.addEventListener(
																				"touchend",
																				handleTouchEnd,
																				{ once: true, passive: false },
																			);
																		}
																	}}
																>
																	{/* Icono de drag - solo visible en desktop */}
																	{!smallScreen && (
																		<Box
																			data-drag-handle
																			{...dragListeners}
																			onClick={(e) => {
																				e.stopPropagation();
																			}}
																			sx={{
																				position: "absolute",
																				left: 2,
																				top: "50%",
																				transform: "translateY(-50%)",
																				opacity: 0.4,
																				cursor: isDragging
																					? "grabbing"
																					: "grab",
																				display: "flex",
																				alignItems: "center",
																				justifyContent: "center",
																				width: 16,
																				height: 16,
																				zIndex: 2,
																				pointerEvents: "auto",
																				"&:hover": {
																					opacity: 0.8,
																				},
																				"&:active": {
																					opacity: 1,
																				},
																			}}
																		>
																			<DragIndicatorIcon
																				sx={{
																					fontSize: "16px",
																					color:
																						index === currentPage
																							? "white"
																							: "#666",
																				}}
																			/>
																		</Box>
																	)}
																	<Typography
																		variant="body2"
																		sx={{
																			fontWeight: 700,
																			fontSize: "14px",
																			color:
																				index === currentPage
																					? "white"
																					: "#333",
																			cursor: "pointer",
																			userSelect: "none",
																		}}
																	>
																		{index + 1}
																	</Typography>
																	{currentPage === index &&
																		pages.length > 1 && (
																			<IconButton
																				data-no-drag="true"
																				size="small"
																				sx={{
																					position: "absolute",
																					top: -10,
																					right: -10,
																					width: 22,
																					height: 22,
																					backgroundColor: "#ef4444",
																					color: "white",
																					boxShadow:
																						"0 2px 6px rgba(239,68,68,0.4)",
																					zIndex: 10,
																					"&:hover": {
																						backgroundColor: "#dc2626",
																						transform: "scale(1.1)",
																					},
																				}}
																				onClick={(e) => {
																					e.stopPropagation();

																					let newTemplateIndex =
																						index + 1 < pages.length
																							? index + 1
																							: index - 1;
																					let newIndex =
																						index === pages.length - 1
																							? index - 1
																							: index;
																					setCurrentPage(newIndex);
																					setCurrentTemplateIndex(
																						pages[newTemplateIndex].templateId,
																					);
																					const auxPages = [...pages];
																					setPages([
																						...auxPages
																							.filter((p, i) => i !== index)
																							.map((p, i) => {
																								p.order = i;
																								return p;
																							}),
																					]);
																				}}
																			>
																				<Close sx={{ fontSize: "14px" }} />
																			</IconButton>
																		)}
																</Box>
															)}
														</SortableItem>
													);
												})}
											</SortableContext>
											<DragOverlay>
												{activeId ? (
													<Box
														sx={{
															flexShrink: 0,
															background:
																"linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
															border: "2px solid #6366F1",
															borderRadius: "12px",
															display: "flex",
															justifyContent: "center",
															alignItems: "center",
															height: 48,
															width: 48,
															position: "relative",
															boxShadow: "0 8px 24px rgba(99, 102, 241,0.5)",
															transform: "rotate(5deg) scale(1.1)",
															opacity: 0.95,
															cursor: "grabbing",
														}}
													>
														<Typography
															variant="body2"
															sx={{
																fontWeight: 700,
																fontSize: "14px",
																color: "white",
															}}
														>
															{pages.findIndex((p) => p.id === activeId) + 1}
														</Typography>
													</Box>
												) : null}
											</DragOverlay>
										</DndContext>
										{/* Botón de añadir página - solo en móvil (en desktop se usa el de más abajo) */}
										{smallScreen && (
											<>
												<Box
													sx={{
														flexShrink: 0,
														backgroundColor: "rgba(255,255,255,0.9)",
														border: "2px dashed rgba(99, 102, 241,0.3)",
														borderRadius: "12px",
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
														height: 48,
														width: 48,
														cursor:
															pages.length >= maxPagesAllowed
																? "not-allowed"
																: "pointer",
														opacity: pages.length >= maxPagesAllowed ? 0.5 : 1,
														transition: "all 0.2s ease",
														"&:hover":
															pages.length >= maxPagesAllowed
																? {}
																: {
																		backgroundColor: "rgba(99, 102, 241,0.1)",
																		borderColor: "#6366F1",
																		transform: "translateY(-2px)",
																		boxShadow: "0 4px 8px rgba(0,0,0,0.12)",
																	},
													}}
													title={
														pages.length >= maxPagesAllowed
															? `Máximo ${maxPagesAllowed} páginas por guía`
															: "Añadir página"
													}
													onClick={() => {
														if (!tryAddPage()) return;
														setTimeout(() => {
															if (pagesListScrollRef.current) {
																if (smallScreen) {
																	pagesListScrollRef.current.scrollLeft =
																		pagesListScrollRef.current.scrollWidth;
																} else {
																	pagesListScrollRef.current.scrollTop =
																		pagesListScrollRef.current.scrollHeight;
																}
															}
														}, 0);
													}}
												>
													<AddCircleOutlineIcon
														sx={{
															fontSize: "24px",
															color: "#6366F1",
														}}
													/>
												</Box>
											</>
										)}
									</Box>
								</Box>
								{/* Botón de añadir página - fuera del contenedor con scroll en escritorio */}
								{!smallScreen && (
									<>
										<Divider orientation="horizontal" />
										<Box
											sx={{
												flexShrink: 0,
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												padding: "12px 12px",
											}}
										>
											<Box
												sx={{
													flexShrink: 0,
													backgroundColor: "rgba(255,255,255,0.9)",
													border: "2px dashed rgba(99, 102, 241,0.3)",
													borderRadius: "12px",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
													height: 48,
													width: 48,
													cursor:
														pages.length >= maxPagesAllowed
															? "not-allowed"
															: "pointer",
													opacity: pages.length >= maxPagesAllowed ? 0.5 : 1,
													transition: "all 0.2s ease",
													"&:hover":
														pages.length >= maxPagesAllowed
															? {}
															: {
																	backgroundColor: "rgba(99, 102, 241,0.1)",
																	borderColor: "#6366F1",
																	transform: "translateY(-2px)",
																	boxShadow: "0 4px 8px rgba(0,0,0,0.12)",
																},
												}}
												title={
													pages.length >= maxPagesAllowed
														? `Máximo ${maxPagesAllowed} páginas por guía`
														: "Añadir página"
												}
												onClick={tryAddPage}
											>
												<AddCircleOutlineIcon
													sx={{
														fontSize: "24px",
														color: "#6366F1",
													}}
												/>
											</Box>
										</Box>
									</>
								)}
							</Box>
						</Box>

						{/*<IconButton
							sx={{
								position: "absolute",
								top: 0,
								left: 0,
								zIndex: 3,
								display:
									size.width < 1200 && size.width / size.height >= 21 / 29.7
										? "block"
															: "none",
								background: "white",
								height: "34px",
							}}
							size={"small"}
							onClick={() => {
								setDrawerOpen(!drawerOpen);
							}}
						>
							<MenuIcon />
						</IconButton>*/}
						{/* Botones de navegación de páginas - flotando encima del botón Páginas */}
						{tabbar && pages.length > 1 && !mapFullscreenActive && (
							<Box
								sx={{
									position: "fixed",
									bottom: 92, // Justo encima de la tab bar (72px altura + 12px bottom + 8px separación)
									right: 16,
									zIndex: 10002,
									display: "flex",
									gap: "8px",
									alignItems: "center",
								}}
							>
								{/* Botón anterior */}
								<Box
									onClick={() => {
										if (currentPage > 0) {
											const newIndex = currentPage - 1;
											setCurrentPage(newIndex);
											setCurrentTemplateIndex(pages[newIndex]?.templateId);
											setClickedX(null);
											setClickedY(null);
											setSelectedTextIndex(null);
											setSelectedStickerIndex(null);
											setSelectedImageIndex(null);
										}
									}}
									sx={{
										width: 34,
										height: 34,
										borderRadius: "12px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										cursor: currentPage > 0 ? "pointer" : "default",
										opacity: currentPage > 0 ? 1 : 0.4,
										background:
											currentPage > 0
												? "linear-gradient(135deg, rgba(99, 102, 241, 0.9) 0%, rgba(139, 92, 246, 0.85) 100%)"
												: "rgba(255, 255, 255, 0.85)",
										backdropFilter: "blur(12px)",
										WebkitBackdropFilter: "blur(12px)",
										boxShadow:
											currentPage > 0
												? "0 4px 14px rgba(99, 102, 241, 0.4), 0 2px 6px rgba(0,0,0,0.1)"
												: "0 2px 8px rgba(0,0,0,0.08)",
										border:
											currentPage > 0
												? "1.5px solid rgba(255, 255, 255, 0.3)"
												: "1px solid rgba(0,0,0,0.08)",
										transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
										"&:active":
											currentPage > 0 ? { transform: "scale(0.9)" } : {},
									}}
								>
									<LuChevronLeft
										size={18}
										style={{
											color: currentPage > 0 ? "#fff" : "#94a3b8",
											strokeWidth: 2.5,
										}}
									/>
								</Box>
								{/* Indicador de página */}
								<Box
									sx={{
										background: "rgba(255, 255, 255, 0.9)",
										backdropFilter: "blur(12px)",
										WebkitBackdropFilter: "blur(12px)",
										borderRadius: "10px",
										padding: "4px 10px",
										boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
										border: "1px solid rgba(0,0,0,0.06)",
									}}
								>
									<Typography
										sx={{
											fontSize: "12px",
											fontWeight: 700,
											color: "#6366F1",
											lineHeight: 1.4,
										}}
									>
										{currentPage + 1}/{pages.length}
									</Typography>
								</Box>
								{/* Botón siguiente */}
								<Box
									onClick={() => {
										if (currentPage < pages.length - 1) {
											const newIndex = currentPage + 1;
											setCurrentPage(newIndex);
											setCurrentTemplateIndex(pages[newIndex]?.templateId);
											setClickedX(null);
											setClickedY(null);
											setSelectedTextIndex(null);
											setSelectedStickerIndex(null);
											setSelectedImageIndex(null);
										}
									}}
									sx={{
										width: 34,
										height: 34,
										borderRadius: "12px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										cursor:
											currentPage < pages.length - 1 ? "pointer" : "default",
										opacity: currentPage < pages.length - 1 ? 1 : 0.4,
										background:
											currentPage < pages.length - 1
												? "linear-gradient(135deg, rgba(99, 102, 241, 0.9) 0%, rgba(139, 92, 246, 0.85) 100%)"
												: "rgba(255, 255, 255, 0.85)",
										backdropFilter: "blur(12px)",
										WebkitBackdropFilter: "blur(12px)",
										boxShadow:
											currentPage < pages.length - 1
												? "0 4px 14px rgba(99, 102, 241, 0.4), 0 2px 6px rgba(0,0,0,0.1)"
												: "0 2px 8px rgba(0,0,0,0.08)",
										border:
											currentPage < pages.length - 1
												? "1.5px solid rgba(255, 255, 255, 0.3)"
												: "1px solid rgba(0,0,0,0.08)",
										transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
										"&:active":
											currentPage < pages.length - 1
												? { transform: "scale(0.9)" }
												: {},
									}}
								>
									<LuChevronRight
										size={18}
										style={{
											color:
												currentPage < pages.length - 1 ? "#fff" : "#94a3b8",
											strokeWidth: 2.5,
										}}
									/>
								</Box>
							</Box>
						)}
						{tabbar && (
							<Box
								sx={{
									// Modern glassmorphism tab bar
									background: "rgba(255, 255, 255, 0.85)",
									backdropFilter: "blur(20px) saturate(180%)",
									WebkitBackdropFilter: "blur(20px) saturate(180%)",
									width: "calc(100% - 24px)",
									margin: "0 12px",
									height: 72,
									position: "fixed",
									bottom: 12,
									left: 0,
									zIndex: 10001,
									isolation: "isolate",
									display: "flex",
									justifyContent: "space-around",
									alignItems: "center",
									gap: "8px",
									borderRadius: "24px",
									boxShadow:
										"0 8px 32px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
									border: "1px solid rgba(255, 255, 255, 0.6)",
									padding: "0 8px",
								}}
							>
								{/* Plantillas */}
								<Box
									sx={{
										flex: 1,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										justifyContent: "center",
										padding: "8px 4px",
										borderRadius: "16px",
										cursor: "pointer",
										transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
										background:
											selectedTab === "templates"
												? "linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0.08) 100%)"
												: "transparent",
										transform:
											selectedTab === "templates" ? "scale(1.02)" : "scale(1)",
										"&:active": {
											transform: "scale(0.95)",
										},
									}}
									onClick={() => {
										setSelectedTab("templates");
										setTimeout(() => {
											document.querySelector("html").scrollTop =
												document.querySelector("html").scrollHeight;
										}, 250);
									}}
								>
									<LuLayoutGrid
										size={22}
										style={{
											color:
												selectedTab === "templates" ? "#6366F1" : "#94a3b8",
											strokeWidth: selectedTab === "templates" ? 2.5 : 2,
											transition: "all 0.2s ease",
										}}
									/>
									<Typography
										sx={{
											fontWeight: selectedTab === "templates" ? 700 : 500,
											fontSize: "10px",
											color:
												selectedTab === "templates" ? "#6366F1" : "#64748b",
											marginTop: 0.5,
											letterSpacing: "0.02em",
											transition: "all 0.2s ease",
										}}
									>
										Plantillas
									</Typography>
								</Box>

								{/* Stickers */}
								<Box
									sx={{
										flex: 1,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										justifyContent: "center",
										padding: "8px 4px",
										borderRadius: "16px",
										cursor: "pointer",
										transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
										background:
											selectedTab === "stickers"
												? "linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0.08) 100%)"
												: "transparent",
										transform:
											selectedTab === "stickers" ? "scale(1.02)" : "scale(1)",
										"&:active": {
											transform: "scale(0.95)",
										},
									}}
									onClick={() => {
										setSelectedTab("stickers");
										setTimeout(() => {
											document.querySelector("html").scrollTop =
												document.querySelector("html").scrollHeight;
										}, 250);
									}}
								>
									<LuSticker
										size={22}
										style={{
											color: selectedTab === "stickers" ? "#6366F1" : "#94a3b8",
											strokeWidth: selectedTab === "stickers" ? 2.5 : 2,
											transition: "all 0.2s ease",
										}}
									/>
									<Typography
										sx={{
											fontWeight: selectedTab === "stickers" ? 700 : 500,
											fontSize: "10px",
											color: selectedTab === "stickers" ? "#6366F1" : "#64748b",
											marginTop: 0.5,
											letterSpacing: "0.02em",
											transition: "all 0.2s ease",
										}}
									>
										Stickers
									</Typography>
								</Box>

								{/* Apariencia */}
								<Box
									sx={{
										flex: 1,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										justifyContent: "center",
										padding: "8px 4px",
										borderRadius: "16px",
										cursor: "pointer",
										transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
										background:
											selectedTab === "appearance"
												? "linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0.08) 100%)"
												: "transparent",
										transform:
											selectedTab === "appearance" ? "scale(1.02)" : "scale(1)",
										"&:active": {
											transform: "scale(0.95)",
										},
									}}
									onClick={() => {
										setSelectedTab("appearance");
										setTimeout(() => {
											document.querySelector("html").scrollTop =
												document.querySelector("html").scrollHeight;
										}, 250);
									}}
								>
									<LuPalette
										size={22}
										style={{
											color:
												selectedTab === "appearance" ? "#6366F1" : "#94a3b8",
											strokeWidth: selectedTab === "appearance" ? 2.5 : 2,
											transition: "all 0.2s ease",
										}}
									/>
									<Typography
										sx={{
											fontWeight: selectedTab === "appearance" ? 700 : 500,
											fontSize: "10px",
											color:
												selectedTab === "appearance" ? "#6366F1" : "#64748b",
											marginTop: 0.5,
											letterSpacing: "0.02em",
											transition: "all 0.2s ease",
										}}
									>
										Estilo
									</Typography>
								</Box>

								{/* Añadir (Texto + Fotos combinados) */}
								<Box
									sx={{
										flex: 1,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										justifyContent: "center",
										padding: "8px 4px",
										borderRadius: "16px",
										cursor: "pointer",
										transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
										background:
											selectedTab === "add"
												? "linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0.08) 100%)"
												: "transparent",
										transform:
											selectedTab === "add" ? "scale(1.02)" : "scale(1)",
										"&:active": {
											transform: "scale(0.95)",
										},
									}}
									onClick={() => {
										setSelectedTab("add");
										setTimeout(() => {
											document.querySelector("html").scrollTop =
												document.querySelector("html").scrollHeight;
										}, 250);
									}}
								>
									<LuPlusCircle
										size={22}
										style={{
											color: selectedTab === "add" ? "#6366F1" : "#94a3b8",
											strokeWidth: selectedTab === "add" ? 2.5 : 2,
											transition: "all 0.2s ease",
										}}
									/>
									<Typography
										sx={{
											fontWeight: selectedTab === "add" ? 700 : 500,
											fontSize: "10px",
											color: selectedTab === "add" ? "#6366F1" : "#64748b",
											marginTop: 0.5,
											letterSpacing: "0.02em",
											transition: "all 0.2s ease",
										}}
									>
										Añadir
									</Typography>
								</Box>

								{/* Páginas */}
								<Box
									sx={{
										flex: 1,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										justifyContent: "center",
										padding: "8px 4px",
										borderRadius: "16px",
										cursor: "pointer",
										transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
										background:
											selectedTab === "pages"
												? "linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0.08) 100%)"
												: "transparent",
										transform:
											selectedTab === "pages" ? "scale(1.02)" : "scale(1)",
										"&:active": {
											transform: "scale(0.95)",
										},
									}}
									onClick={() => {
										setSelectedTab("pages");
										setTimeout(() => {
											document.querySelector("html").scrollTop =
												document.querySelector("html").scrollHeight;
										}, 250);
									}}
								>
									<Box sx={{ position: "relative" }}>
										<LuLayers
											size={22}
											style={{
												color: selectedTab === "pages" ? "#6366F1" : "#94a3b8",
												strokeWidth: selectedTab === "pages" ? 2.5 : 2,
												transition: "all 0.2s ease",
											}}
										/>
										{/* Badge con número de página actual */}
										<Box
											sx={{
												position: "absolute",
												top: -6,
												right: -10,
												minWidth: 16,
												height: 16,
												borderRadius: "8px",
												background:
													"linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												padding: "0 4px",
											}}
										>
											<Typography
												sx={{
													fontSize: "9px",
													fontWeight: 700,
													color: "white",
													lineHeight: 1,
												}}
											>
												{currentPage + 1}
											</Typography>
										</Box>
									</Box>
									<Typography
										sx={{
											fontWeight: selectedTab === "pages" ? 700 : 500,
											fontSize: "10px",
											color: selectedTab === "pages" ? "#6366F1" : "#64748b",
											marginTop: 0.5,
											letterSpacing: "0.02em",
											transition: "all 0.2s ease",
										}}
									>
										Páginas
									</Typography>
								</Box>
							</Box>
						)}
						{/* Overlay oscuro cuando el panel está visible en tabbar - siempre renderizado para animar */}
						{tabbar && (
							<Box
								sx={{
									position: "fixed",
									top: 0,
									left: 0,
									right: 0,
									bottom: 0,
									backgroundColor: "rgba(0, 0, 0, 0.4)",
									zIndex: 9998,
									transition:
										"opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
									opacity: selectedTab ? 1 : 0,
									pointerEvents: selectedTab ? "auto" : "none",
									visibility: selectedTab ? "visible" : "hidden",
								}}
								onClick={() => {
									setSelectedTab(null);
								}}
							/>
						)}
					</Box>
				</Box>

				<BasicModal
					width={500}
					showModal={showLogin}
					handleClose={() => {
						setShowLogin(false);
					}}
					contentSx={modalContentSx}
					children={
						<Auth
							setShowLogin={setShowLogin}
							setJustInitSession={setJustInitSession}
						/>
					}
				/>
				<BasicModal
					width={900}
					showModal={showProjects}
					handleClose={() => {
						setShowProjects(false);
					}}
					contentSx={modalContentSx}
					children={
						<Projects
							setShowProjects={setShowProjects}
							selectedProject={selectedProject}
							setSelectedProject={setSelectedProject}
							getProjectsFB={getProjects}
							getProject={getProject}
							onCreatedNewGuide={(projectId, userIdFromProject) => {
								setShowProjects(false);
								const uid = userIdFromProject ?? user?.id ?? user?.uid;
								if (uid) navigate(`/usuarios/${uid}/guias/${projectId}`);
							}}
						/>
					}
				/>
				<BasicModal
					width={600}
					showModal={showExport}
					handleClose={() => {
						setShowExport(false);
					}}
					contentSx={modalContentSx}
					children={<Export selectedProject={selectedProject} user={user} />}
				/>
				<BasicModal
					width={460}
					showModal={showPageLimitModal}
					handleClose={() => setShowPageLimitModal(false)}
					contentSx={modalContentSx}
					children={
						<Box sx={{ p: 2 }}>
							<Typography
								sx={{
									fontSize: "18px",
									fontWeight: 700,
									mb: 1,
									color: "#1e293b",
								}}
							>
								Límite de páginas alcanzado
							</Typography>
							<Typography
								sx={{
									fontSize: "14px",
									color: "#64748b",
									mb: 2,
								}}
							>
								Has alcanzado el límite de páginas adicionales en esta guía.
								{upgradePack
									? ` Consigue el ${upgradePack.title} para añadir ${
											upgradePack.entitlements?.extraPagesPerGuide?.[
												selectedProject?.prebuiltGuideId
											] || 15
										} páginas extra, o hazte Pro para tener hasta ${MAX_PAGES_PER_GUIDE} páginas por guía.`
									: ` Hazte Pro para tener hasta ${MAX_PAGES_PER_GUIDE} páginas por guía.`}
							</Typography>

							{upgradePack && (
								<Box
									sx={{
										border: "1px solid rgba(239,68,68,0.25)",
										borderRadius: 2,
										p: 1.5,
										mb: 1.5,
										background:
											"linear-gradient(135deg, rgba(239,68,68,0.06) 0%, rgba(239,68,68,0.02) 100%)",
									}}
								>
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											justifyContent: "space-between",
											gap: 1,
											mb: 1,
										}}
									>
										<Box>
											<Typography
												sx={{
													fontSize: 14,
													fontWeight: 700,
													color: "#0f172a",
												}}
											>
												{upgradePack.title}
											</Typography>
											<Typography
												sx={{ fontSize: 12, color: "#64748b" }}
											>
												{upgradePack.subtitle ||
													"Guía + stickers + páginas extra"}
											</Typography>
										</Box>
										<Typography
											sx={{
												fontSize: 16,
												fontWeight: 800,
												color: "#0f172a",
											}}
										>
											{(() => {
												const p = Number(upgradePack.price);
												return Number.isFinite(p)
													? p % 1 === 0
														? `${p}€`
														: `${p.toFixed(2).replace(".", ",")}€`
													: "";
											})()}
										</Typography>
									</Box>
									<Button
										variant="contained"
										fullWidth
										disabled={
											purchasingUpgradePack ||
											!upgradePack.isAvailableForPurchase
										}
										onClick={async () => {
											if (!upgradePack) return;
											setPurchasingUpgradePack(true);
											try {
												await purchasePack?.(upgradePack.id);
											} catch (err) {
												console.error("Error purchasing pack:", err);
											} finally {
												setPurchasingUpgradePack(false);
											}
										}}
										sx={{
											textTransform: "none",
											fontWeight: 700,
											borderRadius: 2,
											background:
												"linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
											"&:hover": {
												background:
													"linear-gradient(135deg, #f87171 0%, #ef4444 100%)",
											},
										}}
									>
										{purchasingUpgradePack
											? "Redirigiendo…"
											: `Conseguir ${upgradePack.title}`}
									</Button>
								</Box>
							)}

							<Button
								variant="contained"
								fullWidth
								onClick={() => {
									setShowPageLimitModal(false);
									navigate("/profile", { state: { section: "plan" } });
								}}
								sx={{
									...primaryButtonSx,
								}}
							>
								{upgradePack ? "Ver planes (o Pro)" : "Ver planes"}
							</Button>
						</Box>
					}
				/>
				<BasicModal
					width={600}
					showModal={isModalOpen}
					handleClose={handleModalCancel}
					contentSx={modalContentSx}
					children={
						<Box sx={{ p: 3 }}>
							<Typography
								sx={{
									fontSize: "18px !important",
									fontWeight: 700,
									color: TRAVEL_KIT_MODAL.textPrimary,
									mb: 2,
									fontFamily: "'Inter', sans-serif",
								}}
							>
								Editar texto
							</Typography>

							{/* Controles de estilo */}
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: 2.5,
									marginBottom: 3,
								}}
							>
								{/* Colores */}
								<Box
									sx={{
										display: "grid",
										gridTemplateColumns: "repeat(2, 1fr)",
										gap: 2,
									}}
								>
									{/* Color del texto */}
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											gap: 1.5,
										}}
									>
										<Typography
											variant="body2"
											sx={{
												fontSize: 10,
												textTransform: "uppercase",
												letterSpacing: 1.2,
												fontWeight: 600,
												color: "#475569",
											}}
										>
											Color del texto
										</Typography>
										<Box
											sx={{
												position: "relative",
												width: "100%",
												height: 56,
												borderRadius: 2,
												overflow: "hidden",
												border: "2px solid rgba(148,163,184,0.2)",
												boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
												cursor: "pointer",
												transition: "all 0.2s ease",
												"&:hover": {
													borderColor: "rgba(99, 102, 241,0.4)",
													boxShadow: "0 4px 12px rgba(99, 102, 241,0.15)",
												},
											}}
										>
											<input
												type="color"
												value={modalTextColor}
												onChange={(e) => setModalTextColor(e.target.value)}
												style={{
													position: "absolute",
													top: 0,
													left: 0,
													width: "100%",
													height: "100%",
													border: "none",
													padding: 0,
													cursor: "pointer",
													opacity: 0,
												}}
											/>
											<Box
												sx={{
													position: "absolute",
													top: 0,
													left: 0,
													width: "100%",
													height: "100%",
													backgroundColor: modalTextColor,
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													pointerEvents: "none",
												}}
											/>
										</Box>
									</Box>

									{/* Color de contorno */}
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											gap: 1.5,
										}}
									>
										<Typography
											variant="body2"
											sx={{
												fontSize: 10,
												textTransform: "uppercase",
												letterSpacing: 1.2,
												fontWeight: 600,
												color: "#475569",
											}}
										>
											Color de contorno
										</Typography>
										<Box
											sx={{
												position: "relative",
												width: "100%",
												height: 56,
												borderRadius: 2,
												overflow: "hidden",
												border: "2px solid rgba(148,163,184,0.2)",
												boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
												cursor: "pointer",
												transition: "all 0.2s ease",
												"&:hover": {
													borderColor: "rgba(99, 102, 241,0.4)",
													boxShadow: "0 4px 12px rgba(99, 102, 241,0.15)",
												},
											}}
										>
											<input
												type="color"
												value={modalTextStrokeColor}
												onChange={(e) =>
													setModalTextStrokeColor(e.target.value)
												}
												style={{
													position: "absolute",
													top: 0,
													left: 0,
													width: "100%",
													height: "100%",
													border: "none",
													padding: 0,
													cursor: "pointer",
													opacity: 0,
												}}
											/>
											<Box
												sx={{
													position: "absolute",
													top: 0,
													left: 0,
													width: "100%",
													height: "100%",
													backgroundColor: modalTextStrokeColor,
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													pointerEvents: "none",
												}}
											/>
										</Box>
									</Box>
								</Box>

								{/* Grosor y Fuente */}
								<Box
									sx={{
										display: "grid",
										gridTemplateColumns: "1fr 1fr",
										gap: 2,
									}}
								>
									{/* Grosor de contorno */}
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											gap: 1.5,
										}}
									>
										<Typography
											variant="body2"
											sx={{
												fontSize: 10,
												textTransform: "uppercase",
												letterSpacing: 1.2,
												fontWeight: 600,
												color: "#475569",
											}}
										>
											Grosor de contorno
										</Typography>
										<TextField
											placeholder="0-20"
											value={modalTextStrokeWidth}
											onChange={(e) =>
												setModalTextStrokeWidth(
													Math.min(
														Math.max(0, parseFloat(e.target.value ?? 0)),
														20,
													),
												)
											}
											fullWidth
											size="small"
											type="number"
											step={1}
											sx={{
												"& .MuiOutlinedInput-root": {
													borderRadius: 2,
													backgroundColor: "white",
													border: "2px solid rgba(148,163,184,0.2)",
													height: 56,
													transition: "all 0.2s ease",
													"&:hover": {
														borderColor: "rgba(99, 102, 241,0.4)",
													},
													"&.Mui-focused": {
														borderColor: "#6366F1",
													},
												},
											}}
											inputProps={{
												step: 1,
												min: 0,
												max: 20,
											}}
										/>
									</Box>

									{/* Alineación */}
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											gap: 1.5,
										}}
									>
										<Typography
											variant="body2"
											sx={{
												fontSize: 10,
												textTransform: "uppercase",
												letterSpacing: 1.2,
												fontWeight: 600,
												color: "#475569",
											}}
										>
											Alineación
										</Typography>
										<Box
											sx={{
												display: "flex",
												gap: 1,
											}}
										>
											{[
												{ value: "left", Icon: FormatAlignLeftIcon },
												{ value: "center", Icon: FormatAlignCenterIcon },
												{ value: "right", Icon: FormatAlignRightIcon },
											].map((option) => (
												<Box
													key={option.value}
													onClick={() => setModalTextAlign(option.value)}
													sx={{
														flex: 1,
														padding: "12px",
														borderRadius: 2,
														border:
															modalTextAlign === option.value
																? "2px solid #6366F1"
																: "2px solid rgba(148,163,184,0.2)",
														backgroundColor:
															modalTextAlign === option.value
																? "rgba(99, 102, 241, 0.08)"
																: "white",
														cursor: "pointer",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
														transition: "all 0.2s ease",
														"&:hover": {
															borderColor: "rgba(99, 102, 241, 0.4)",
														},
													}}
												>
													<option.Icon
														sx={{
															fontSize: 24,
															color:
																modalTextAlign === option.value
																	? "#6366F1"
																	: "#64748b",
														}}
													/>
												</Box>
											))}
										</Box>
									</Box>

									{/* Fuente */}
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											gap: 1.5,
										}}
									>
										<Typography
											variant="body2"
											sx={{
												fontSize: 10,
												textTransform: "uppercase",
												letterSpacing: 1.2,
												fontWeight: 600,
												color: "#475569",
											}}
										>
											Fuente
										</Typography>
										<TextField
											select
											size="small"
											fullWidth
											value={modalTextFont}
											onChange={(event) => setModalTextFont(event.target.value)}
											sx={{
												"& .MuiOutlinedInput-root": {
													borderRadius: 2,
													backgroundColor: "white",
													border: "2px solid rgba(148,163,184,0.2)",
													height: 56,
													transition: "all 0.2s ease",
													"&:hover": {
														borderColor: "rgba(99, 102, 241,0.4)",
													},
													"&.Mui-focused": {
														borderColor: "#6366F1",
													},
												},
											}}
											SelectProps={{
												displayEmpty: true,
												// `BasicModal` usa z-index 10002; el menú de MUI usa z-index (modal) ~1300 por defecto.
												// En desktop eso hacía que la lista quedase "debajo" de la modal.
												MenuProps: {
													sx: { zIndex: 10003 },
													PaperProps: {
														sx: { zIndex: 10003, maxHeight: "50vh" },
													},
												},
												renderValue: (value) =>
													value ? (
														<Typography
															sx={{ fontFamily: value + "!important" }}
														>
															{value}
														</Typography>
													) : (
														<em style={{ color: "#94a3b8" }}>
															Seleccionar fuente
														</em>
													),
											}}
										>
											{fontNames.map((fontName) => (
												<MenuItem
													key={fontName}
													value={fontName}
													sx={{ fontFamily: fontName + "!important" }}
												>
													{fontName}
												</MenuItem>
											))}
										</TextField>
									</Box>

									{/* Tamaño del texto (independiente de la bounding box) */}
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											gap: 1.5,
										}}
									>
										<Typography
											variant="body2"
											sx={{
												fontSize: 10,
												textTransform: "uppercase",
												letterSpacing: 1.2,
												fontWeight: 600,
												color: "#475569",
											}}
										>
											Tamaño del texto
										</Typography>
										<TextField
											type="number"
											size="small"
											fullWidth
											value={modalTextFontSize}
											onChange={(e) =>
												setModalTextFontSize(
													Math.min(
														120,
														Math.max(8, Number(e.target.value) || 8),
													),
												)
											}
											inputProps={{ min: 8, max: 120, step: 1 }}
											sx={{
												"& .MuiOutlinedInput-root": {
													borderRadius: 2,
													backgroundColor: "white",
													border: "2px solid rgba(148,163,184,0.2)",
													height: 56,
													transition: "all 0.2s ease",
													"&:hover": {
														borderColor: "rgba(99, 102, 241,0.4)",
													},
													"&.Mui-focused": {
														borderColor: "#6366F1",
													},
												},
											}}
										/>
									</Box>
								</Box>
							</Box>

							{/* Campo de texto */}
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									gap: 1.5,
									marginBottom: 3,
								}}
							>
								<Typography
									variant="body2"
									sx={{
										fontSize: 10,
										textTransform: "uppercase",
										letterSpacing: 1.2,
										fontWeight: 600,
										color: "#475569",
									}}
								>
									Contenido del texto
								</Typography>
								<TextField
									InputLabelProps={{ shrink: false }}
									variant="outlined"
									fullWidth
									multiline
									rows={4}
									size="small"
									value={modalText}
									onChange={(e) => setModalText(e.target.value)}
									placeholder="Escribe tu texto aquí..."
									sx={{
										"& .MuiOutlinedInput-root": {
											borderRadius: 2,
											backgroundColor: "white",
											border: "2px solid rgba(148,163,184,0.2)",
											transition: "all 0.2s ease",
											"&:hover": {
												borderColor: "rgba(99, 102, 241,0.4)",
											},
											"&.Mui-focused": {
												borderColor: "#6366F1",
											},
										},
									}}
								/>
							</Box>

							{/* Botones - mismo diseño que TravelKit (103/104) */}
							<Box
								sx={{
									display: "flex",
									justifyContent: "flex-end",
									gap: 1.5,
									mt: 3,
								}}
							>
								<Button onClick={handleModalCancel} sx={secondaryButtonSx}>
									Cancelar
								</Button>
								<Button
									variant="contained"
									onClick={handleModalSave}
									sx={primaryButtonSx}
								>
									Guardar
								</Button>
							</Box>
						</Box>
					}
					hideClose
				/>

				{/* Modal para editar notas */}
				<BasicModal
					width={600}
					showModal={isNoteModalOpen}
					handleClose={handleCancelNote}
					contentSx={modalContentSx}
					children={
						<Box sx={{ p: 3 }}>
							<Typography
								sx={{
									fontSize: "18px !important",
									fontWeight: 700,
									color: TRAVEL_KIT_MODAL.textPrimary,
									mb: 2,
									fontFamily: "'Inter', sans-serif",
								}}
							>
								{editingNote ? "Editar Nota" : "Añadir Nota"}
							</Typography>
							<Box sx={{ mb: 2 }}>
								<Typography
									sx={{
										fontSize: 13,
										fontWeight: 600,
										color: "#475569",
										mb: 1,
									}}
								>
									Emoji (opcional)
								</Typography>
								<Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
									<TextField
										value={noteEmoji}
										onChange={(e) => {
											const val = e.target.value;
											const emojiRegex =
												/\p{Emoji_Presentation}|\p{Extended_Pictographic}/u;
											if (val === "" || emojiRegex.test(val)) {
												const chars = [...val];
												setNoteEmoji(
													chars.length > 0 ? chars[chars.length - 1] : "",
												);
											}
										}}
										placeholder="📌"
										inputProps={{
											style: { fontSize: 24, textAlign: "center", width: 48 },
										}}
										sx={{
											width: 64,
											"& .MuiOutlinedInput-root": {
												borderRadius: "12px",
												bgcolor: "#f8fafc",
											},
										}}
									/>
									<Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
										{[
											"📌",
											"⭐",
											"💡",
											"❤️",
											"📍",
											"🎯",
											"✈️",
											"🍽️",
											"🏨",
											"📸",
											"🎒",
											"⚠️",
										].map((em) => (
											<Box
												key={em}
												onClick={() => setNoteEmoji(em)}
												sx={{
													cursor: "pointer",
													fontSize: 20,
													width: 32,
													height: 32,
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													borderRadius: "8px",
													border:
														noteEmoji === em
															? "2px solid #6366F1"
															: "2px solid transparent",
													backgroundColor:
														noteEmoji === em
															? "rgba(99,102,241,0.08)"
															: "transparent",
													"&:hover": {
														backgroundColor: "rgba(99,102,241,0.08)",
													},
													transition: "all 0.15s ease",
												}}
											>
												{em}
											</Box>
										))}
									</Box>
								</Box>
							</Box>
							<TextField
								value={noteContent}
								onChange={(e) => setNoteContent(e.target.value)}
								fullWidth
								multiline
								rows={4}
								margin="normal"
								placeholder="Escribe tu nota aquí..."
								sx={{
									"& .MuiOutlinedInput-root": {
										bgcolor: TRAVEL_KIT_MODAL.bgInput || "#f8fafc",
										borderRadius: "12px",
										"&:hover fieldset": { borderColor: "#cbd5e1" },
										"&.Mui-focused fieldset": {
											borderColor: TRAVEL_KIT_MODAL.primary,
											borderWidth: "2px",
										},
									},
								}}
							/>
							<Box
								sx={{
									display: "flex",
									justifyContent: "flex-end",
									gap: 1.5,
									mt: 3,
								}}
							>
								<Button onClick={handleCancelNote} sx={secondaryButtonSx}>
									Cancelar
								</Button>
								<Button
									variant="contained"
									onClick={handleSaveNote}
									disabled={!noteContent || noteContent.trim() === ""}
									sx={primaryButtonSx}
								>
									Guardar
								</Button>
							</Box>
						</Box>
					}
				/>
			</Box>

			<PurchaseChoiceModal
				open={purchaseModalOpen}
				guide={purchaseModalOpen ? STICKER_PACK_GUIDE : null}
				onClose={() => setPurchaseModalOpen(false)}
				onBuyGuide={() => {
					setPurchaseModalOpen(false);
					window.location.href = "/descuentos";
				}}
				onSubscribe={() => {
					setPurchaseModalOpen(false);
					window.location.href = "/descuentos";
				}}
				loading={false}
			/>

			<CustomStickerModal
				open={customStickerModalOpen}
				onClose={() => setCustomStickerModalOpen(false)}
				onAdd={handleAddCustomSticker}
			/>
		</>
	);
};

export default StickerApp;
